const getDefaultTurnaroundParameters = () => ({
    aibt: {
        id: "aibt",
        label: {
            "en-GB": "AIBT",
            "en-US": "AIBT",
            "de-DE": "AIBT",
            "ja-JP": "AIBT",
        },
        description: {
            "en-GB": "Actual In-Block Time",
            "en-US": "Actual In-Block Time",
            "de-DE": "Actual In-Block Time",
            "ja-JP": "Actual In-Block Time（実際のインブロック時刻）",
        },
    },
    aircraft_end_ts: {
        id: "aircraft_end_ts",
        label: {
            "en-GB": "Pushback started",
            "en-US": "Pushback started",
            "de-DE": "Pushback gestartet",
            "ja-JP": "プッシュバック開始",
        },
        description: {
            "en-GB": "Pushback started",
            "en-US": "Pushback started",
            "de-DE": "Pushback gestartet",
            "ja-JP": "プッシュバック開始",
        },
    },
    aircraft_or_pushback_ts: {
        id: "aircraft_or_pushback_ts",
        label: {
            "en-GB": "Aircraft parked or tow-on disconnected",
            "en-US": "Aircraft parked or tow-on disconnected",
            "de-DE": "LFZ gepart oder tow-on abgeschlossen",
            "ja-JP": "航空機駐機または牽引終了",
        },
        description: {
            "en-GB": "Aircraft parked or tow-on disconnected",
            "en-US": "Aircraft parked or tow-on disconnected",
            "de-DE": "LFZ gepart oder tow-on abgeschlossen",
            "ja-JP": "航空機駐機または牽引終了",
        },
    },
    aircraft_ready_ts: {
        id: "aircraft_ready_ts",
        label: {
            "en-GB": "Aircraft ready",
            "en-US": "Aircraft ready",
            "de-DE": "LFZ bereit",
            "ja-JP": "航空機準備完了",
        },
        description: {
            "en-GB": "Aircraft ready",
            "en-US": "Aircraft ready",
            "de-DE": "LFZ bereit",
            "ja-JP": "航空機準備完了",
        },
    },
    aircraft_start_ts: {
        id: "aircraft_start_ts",
        label: {
            "en-GB": "Aircraft stationary",
            "en-US": "Aircraft stationary",
            "de-DE": "LFZ in Parkposition",
            "ja-JP": "航空機定置",
        },
        description: {
            "en-GB": "Aircraft stationary",
            "en-US": "Aircraft stationary",
            "de-DE": "LFZ in Parkposition",
            "ja-JP": "航空機定置",
        },
    },
    aldt: {
        id: "aldt",
        label: {
            "en-GB": "ALDT",
            "en-US": "ALDT",
            "de-DE": "ALDT",
            "ja-JP": "ALDT",
        },
        description: {
            "en-GB": "Actual Landing Time (ACDM)",
            "en-US": "Actual Landing Time (ACDM)",
            "de-DE": "Actual Landing Time (ACDM)",
            "ja-JP": "実際の着陸時刻",
        },
    },
    aobt: {
        id: "aobt",
        label: {
            "en-GB": "AOBT",
            "en-US": "AOBT",
            "de-DE": "AOBT",
            "ja-JP": "AOBT",
        },
        description: {
            "en-GB": "Actual Off-Block Time",
            "en-US": "Actual Off-Block Time",
            "de-DE": "Actual Off-Block Time",
            "ja-JP": "Actual Off-Block Time（実際のオフブロック時刻）",
        },
    },
    apbg: {
        id: "apbg",
        label: {
            "en-GB": "APBG",
            "en-US": "APBG",
            "de-DE": "APBG",
            "ja-JP": "APBG",
        },
        description: {
            "en-GB": "APBG",
            "en-US": "APBG",
            "de-DE": "APBG",
            "ja-JP": "APBG",
        },
    },
    asat: {
        id: "asat",
        label: {
            "en-GB": "ASAT",
            "en-US": "ASAT",
            "de-DE": "ASAT",
            "ja-JP": "ASAT",
        },
        description: {
            "en-GB": "Actual Start-Up Approval Time",
            "en-US": "Actual Start-Up Approval Time",
            "de-DE": "Actual Start-Up Approval Time",
            "ja-JP": "実際のエンジン始動承認時刻",
        },
    },
    asrt: {
        id: "asrt",
        label: {
            "en-GB": "ASRT",
            "en-US": "ASRT",
            "de-DE": "ASRT",
            "ja-JP": "ASRT",
        },
        description: {
            "en-GB": "Actual Start-Up Request Time",
            "en-US": "Actual Start-Up Request Time",
            "de-DE": "Actual Start-Up Request Time",
            "ja-JP": "実際のエンジン始動要求時刻",
        },
    },
    ctot: {
        id: "ctot",
        label: {
            "en-GB": "CTOT",
            "en-US": "CTOT",
            "de-DE": "CTOT",
            "ja-JP": "CTOT",
        },
        description: {
            "en-GB": "Calculated Take Off Time",
            "en-US": "Calculated Take Off Time",
            "de-DE": "Calculated Take Off Time",
            "ja-JP": "算出された離陸時刻",
        },
    },
    eibt: {
        id: "eibt",
        label: {
            "en-GB": "EIBT",
            "en-US": "EIBT",
            "de-DE": "EIBT",
            "ja-JP": "EIBT",
        },
        description: {
            "en-GB": "Estimated In-Block Time",
            "en-US": "Estimated In-Block Time",
            "de-DE": "Estimated In-Block Time",
            "ja-JP": "予測インブロック時刻",
        },
    },
    eobt: {
        id: "eobt",
        label: {
            "en-GB": "EOBT",
            "en-US": "EOBT",
            "de-DE": "EOBT",
            "ja-JP": "EOBT",
        },
        description: {
            "en-GB": "Estimated Off-Block Time",
            "en-US": "Estimated Off-Block Time",
            "de-DE": "Estimated Off-Block Time",
            "ja-JP": "Estimated Off-Block Time（飛行計画上の出発時刻）",
        },
    },
    flight_ardt: {
        id: "flight_ardt",
        label: {
            "en-GB": "ARDT",
            "en-US": "ARDT",
            "de-DE": "ARDT",
            "ja-JP": "ARDT",
        },
        description: {
            "en-GB": "Actual Aircraft Ready Time",
            "en-US": "Actual Aircraft Ready Time",
            "de-DE": "Actual Aircraft Ready Time",
            "ja-JP": "実際の牽引準備完了時刻",
        },
    },
    initial_eobt: {
        id: "initial_eobt",
        label: {
            "en-GB": "Initial EOBT",
            "en-US": "Initial EOBT",
            "de-DE": "Erstes EOBT",
            "ja-JP": "当初のEOBT",
        },
        description: {
            "en-GB": "Initial Estimated Off-Block Time",
            "en-US": "Initial Estimated Off-Block Time",
            "de-DE": "Initial Estimated Off-Block Time",
            "ja-JP": "当初の飛行計画上の出発時刻",
        },
    },
    ltd: {
        id: "ltd",
        label: {
            "en-GB": "LTD",
            "en-US": "LTD",
            "de-DE": "LTD",
            "ja-JP": "LTD",
        },
        description: {
            "en-GB": "Latest Time of Departure",
            "en-US": "Latest Time of Departure",
            "de-DE": "Latest Time of Departure",
            "ja-JP": "最新の出発時刻",
        },
    },
    pobt: {
        id: "pobt",
        label: {
            "en-GB": "POBT",
            "en-US": "POBT",
            "de-DE": "POBT",
            "ja-JP": "POBT",
        },
        description: {
            "en-GB": "Predicted Off-Block Time",
            "en-US": "Predicted Off-Block Time",
            "de-DE": "Predicted Off-Block Time",
            "ja-JP": "Predicted Off-Block Time（予測オフブロック時刻）",
        },
    },
    predicted_aircraft_ready_ts: {
        id: "predicted_aircraft_ready_ts",
        label: {
            "en-GB": "PRDT",
            "en-US": "PRDT",
            "de-DE": "PRDT",
            "ja-JP": "PRDT",
        },
        description: {
            "en-GB": "Predicted aircraft ready time",
            "en-US": "Predicted aircraft ready time",
            "de-DE": "Predicted aircraft ready time",
            "ja-JP": "予測牽引準備完了時刻",
        },
    },
    sibt: {
        id: "sibt",
        label: {
            "en-GB": "SIBT",
            "en-US": "SIBT",
            "de-DE": "SIBT",
            "ja-JP": "SIBT",
        },
        description: {
            "en-GB": "Scheduled In-Block Time",
            "en-US": "Scheduled In-Block Time",
            "de-DE": "Scheduled In-Block Time",
            "ja-JP": "Scheduled In-Block Time（予定インブロック時刻）",
        },
    },
    sobt: {
        id: "sobt",
        label: {
            "en-GB": "SOBT",
            "en-US": "SOBT",
            "de-DE": "SOBT",
            "ja-JP": "SOBT（STD)",
        },
        description: {
            "en-GB": "Scheduled Off-Block Time",
            "en-US": "Scheduled Off-Block Time",
            "de-DE": "Scheduled Off-Block Time",
            "ja-JP": "Scheduled Off-Block Time（予定オフブロック時刻）",
        },
    },
    tobt: {
        id: "tobt",
        label: {
            "en-GB": "TOBT",
            "en-US": "TOBT",
            "de-DE": "TOBT",
            "ja-JP": "TOBT",
        },
        description: {
            "en-GB": "Target Off-Block Time",
            "en-US": "Target Off-Block Time",
            "de-DE": "Target Off-Block Time",
            "ja-JP": "目標オフブロック時刻",
        },
    },
    tsat: {
        id: "tsat",
        label: {
            "en-GB": "TSAT",
            "en-US": "TSAT",
            "de-DE": "TSAT",
            "ja-JP": "TSAT",
        },
        description: {
            "en-GB": "Target Start Up Approval Time",
            "en-US": "Target Start Up Approval Time",
            "de-DE": "Target Start Up Approval Time",
            "ja-JP": "目標エンジン始動要求時刻",
        },
    },
    cobt: {
        id: "cobt",
        label: {
            "en-GB": "COBT",
            "en-US": "COBT",
            "de-DE": "COBT",
            "ja-JP": "COBT",
        },
        description: {
            "en-GB": "Calculated Off-Block Time",
            "en-US": "Calculated Off-Block Time",
            "de-DE": "Berechnete Off-Block Zeit",
            "ja-JP": "Calculated Off-Block Time",
        },
    },
    eldt: {
        id: "eldt",
        label: {
            "en-GB": "ELDT",
            "en-US": "ELDT",
            "de-DE": "ELDT",
            "ja-JP": "ELDT",
        },
        description: {
            "en-GB": "Estimated Landing Time",
            "en-US": "Estimated Landing Time",
            "de-DE": "Estimated Landing Time",
            "ja-JP": "Estimated Landing Time",
        },
    },
});

const defaultAdminUITexts = {
    flight_parameter_subtitle: {
        "en-GB": "EOBT, SOBT, LTD etc.",
        "en-US": "EOBT, SOBT, LTD etc.",
        "de-DE": "EOBT, SOBT, LTD etc.",
        "ja-JP": "EOBT, SOBT, LTD etc.",
    },
};

const LOCALES = ["en-GB", "en-US", "de-DE", "ja-JP"];
const DEFAULT_LOCALE = "en-GB";
const DEFAULT_LOCALES = [DEFAULT_LOCALE];

const defaultTurnaroundParams = getDefaultTurnaroundParameters();
const createDefaultAdminConfig = () => ({
    configVersion: "mock-version",
    enableDutyPhones: true,
    enableOTPTokenReset: false,
    enablePtsDirection: false,
    enableResendUserPersonalLink: false,
    filterNotificationGroups: [],
    filterPtsGroups: [],
    phonesMask: "+99999999999",
    enablePts: true,
    texts: defaultAdminUITexts,
    logoUrl: null,
    logoHeight: null,
    incidentTurnaroundParams: [
        defaultTurnaroundParams.pobt,
        defaultTurnaroundParams.sobt,
        defaultTurnaroundParams.eobt,
        defaultTurnaroundParams.initial_eobt,
        defaultTurnaroundParams.sibt,
        defaultTurnaroundParams.eibt,
        defaultTurnaroundParams.aldt,
        defaultTurnaroundParams.aircraft_or_pushback_ts,
    ],
    ptsTurnaroundParams: [
        defaultTurnaroundParams.pobt,
        defaultTurnaroundParams.sobt,
        defaultTurnaroundParams.eobt,
        defaultTurnaroundParams.initial_eobt,
        defaultTurnaroundParams.sibt,
        defaultTurnaroundParams.eibt,
        defaultTurnaroundParams.aldt,
        defaultTurnaroundParams.aircraft_start_ts,
        defaultTurnaroundParams.aircraft_end_ts,
    ],
    commitHash: "",
    locales: DEFAULT_LOCALES,
    defaultLocale: "en-GB",
});

const getAdminConfigMock = () => {
    const defaultConfig = createDefaultAdminConfig();
    const specificFields = {
        commitHash: "",
    };
    return {
        ...defaultConfig,
        ...specificFields,
        turnaroundEvents: [],
        operationLabels: {},
        ptsLabels: {},
        ptsOperationsGroups: {},
    };
};

const alaska = "alaska.png";
const american = "american.png";
const airasia = "airasia.png";
const delta = "delta.png";
const horizon = "horizon.png";
const cu = "cu.png";
const southwest = "southwest.png";
const ua = "ua.png";
const gti = "atlas.png";
const aca = "air-canada.png";
const afr = "air-france.svg";
const amx = "aeromexico.png";
const baw = "british-airways.png";
const eva = "eva-air.svg";
const cpa = "cathay-pacific.png";
const cfg = "condor.png";
const ein = "aer-lingus.png";
const uae = "emirates.png";
const fft = "frontier.png";
const ice = "iceland-air.png";
const hal = "hawaii.png";
const jal = "japan-airlines.png";
const kal = "korean-air.png";
const dlh = "lufthansa.png";
const rch = "air-mobility-command.png";
const ana = "ana.png";
const oae = "omni.png";
const aar = "asiana.png";
const qtr = "qatar.png";
const sia = "singapore.png";
const scx = "sun-country.png";
const vir = "virgin-atlantic.png";
const swq = "swiftair.png";
const wja = "westjet.png";
const voi = "volaris.png";
const nks = "spirit.png";
const jbu = "jetblue.png";
const noAirline = "no-airline-transparent.png";
const cai = "corendon.png";
const eju = "easyjet.png";
const ewg = "eurowings.png";
const ryr = "ryanair.png";
const sas = "sas.png";
const tvs = "smartwings.png";
const swr = "swiss.png";
const tui = "tui.png";
const cj = "city-flyer.jpeg";
const hv = "transavia.png";
const lg = "luxair.png";
const ux = "aireuropa.png";
const wk = "edelweiss.png";
const fb = "bulgaria.png";
const av = "avianca.png";
const bw = "caribbean-airlines.png";
const cm = "copa.png";
const ey = "etijad.png";
const ku = "kuwait.jpeg";
const kq = "kenya.png";
const ly = "israel.jpeg";
const ms = "egyptair.png";
const jj = "latam.png";
const ngn = "leav.svg";
const ix = "india.png";
const hy = "hala.png";
const klm = "royal-dutch.jpeg";
const exs = "jet2.png";
const aua = "austrian.png";
const NOZ = "noz.png";
const VKG = "sunclass.png";
const SDR = "sundair.png";
const CI = "china-airlines.png";
const fin = "finnair.svg";
const thy = "turkish.png";
const lxj = "flexjet.png";
const pr = "philippine-airlines.png";
const aay = "allegiant.png";
const helvetic = "helvetic.svg";
const albastar = "albastar.svg";
const airbaltic = "airbaltic.svg";
const ethiopian = "ethiopian.svg";
const flyr = "flyr.svg";
const iberia = "iberia.svg";
const malta = "malta.svg";
const neos = "neos.svg";
const bamboo = "bamboo.png";
const thai = "thai.png";
const vlg = "vueling.svg";
const wzz = "wizz.svg";
const fdb = "fly-dubai.svg";
const qfa = "qantas.svg";
const aic = "air-india.svg";
const ant = "air-north.svg";
const tsc = "air-transat.svg";
const rzo = "azores-airlines.svg";
const bbc = "biman-bangladesh-airlines.svg";
const cjl = "canada-jetlines.svg";
const akt = "canadian-north.svg";
const ces = "china-eastern.svg";
const csn = "china-southern.svg";
const fle = "flair-airlines.svg";
const jza = "jazz.svg";
const lot = "lot-polish-airlines.svg";
const dat = "lynx-air.svg";
const owg = "owg.svg";
const pia = "pakistan-international.svg";
const poe = "porter-airlines.svg";
const rja = "royal-jordanian-airlines.svg";
const swg = "sunwing.svg";
const wsw = "swoop-airlines.svg";
const tap = "tap-portugal.svg";
const aui = "ukraine-international-airlines.svg";
const aee = "aegean.svg";
const aez = "aeroitalia.svg";
const cbj = "beijing-capital.svg";
const bel = "brussels.svg";
const fji = "fiji-airways.svg";
const ity = "ita-airways.svg";
const mas = "malaysia.svg";
const ram = "royal-air-morocco.svg";
const tgw = "scoot.svg";
const hvn = "vietnam-airlines.svg";
const voe = "volotea.svg";
const sva = "saudia-airlines.svg";
const pgt = "pegasus.svg";
const igo = "indigo.svg";
const rxa = "regional-express.svg";
const gia = "garuda.svg";
const gfa = "gulf-air.svg";
const lni = "lion-air.svg";
const asl = "air-serbia.svg";
const nbt = "norse-atlantic.svg";
const ctn = "croatia-airlines.svg";
const mne = "air-montenegro.svg";
const dwi = "arajet.svg";
const dtr = "dat.svg";
const swu = "sky-alps.svg";
const fpy = "play.svg";
const grl = "air-greenland.svg";
const jtd = "jettime.svg";
const sxs = "sun-express.svg";
const tkj = "ajet.svg";
const mea = "mid-east-airlines.svg";
const cca = "air-china.svg";
const chh = "hainan.png";
const vlu = "valuair.svg";
const ubd = "ur-airlines.svg";
const ahy = "azerbaijan-air.svg";
const lbt = "nouvel-air.svg";
const fia = "fly-one.svg";
const fhy = "freebird.svg";
const tah = "air-anka.svg";
const msc = "air-cairo.svg";
const isr = "israir.svg";
const gpx = "gp-aviation.svg";
const nma = "nesma.svg";
const tgz = "georgian.svg";
const ent = "enter-air.svg";
const sek = "star-east.svg";
const abl = "air-busan.svg";
const aiq = "thai-airasia.svg";
const asv = "air-seoul.svg";
const ceb = "cebu-pacific.svg";
const esr = "eastar-jet.svg";
const fda = "fuji-dream.svg";
const crk = "hongkong-airlines.svg";
const hke = "hongkong-express.svg";
const jta = "japan-transocean.svg";
const jja = "jeju-air.svg";
const jjp = "jetstar.svg";
const jna = "jin-air.svg";
const apj = "peach.svg";
const sky = "skymark.svg";
const cqh = "spring.svg";
const sfj = "star-flyer.svg";
const sjx = "starlux.svg";
const twb = "tway.svg";
const tvj = "thai-vietjet.svg";
const ttw = "tigerair.svg";
const ado = "airdo.svg";
const apk = "air-peace.svg";
const bma = "bermud-air.svg";
const cxa = "xiamen.svg";
const fli = "atlantic-airways.svg";
const kne = "flynas.svg";
const mac = "air-arabia.svg";
const tht = "air-tahiti.svg";
const cat = "copenhagen-air-taxi.svg";
const tar = "tunisair.svg";
const aci = "air-caledonie.svg";
const ajx = "air-japan.svg";
const alk = "srilankan.svg";
const amu = "air-macau.svg";
const ang = "air-niugini.svg";
const anz = "air-new-zealand.svg";
const bbg = "blue-bird.svg";
const bci = "business-air.svg";
const btk = "batik-air.svg";
const csc = "sichuan-airlines.svg";
const ctv = "citilink.svg";
const dig = "passion-air.svg";
const ffm = "firefly.svg";
const zg = "zipair.svg";
const mlr = "myanmar-airways.svg";
const mxd = "malindo-air.svg";
const nia = "nile-air.svg";
const ohy = "onur-air.svg";
const rba = "royal-brunei.svg";
const twi = "tailwind.svg";
const uba = "myanmar-national.svg";
const ubg = "us-bangla.svg";
const vjh = "vista-jet.svg";
const drk = "druk.svg";
const getAirlineIconMap = () => ({
    noAirline: noAirline,
    TG: thai,
    THA: thai,
    D7: airasia,
    QH: bamboo,
    AV: av,
    AVA: av,
    BW: bw,
    BWA: bw,
    CM: cm,
    CMP: cm,
    EK: uae,
    EY: ey,
    ETD: ey,
    KU: ku,
    KQ: kq,
    LY: ly,
    MS: ms,
    MSR: ms,
    MST: ms,
    VS: vir,
    WS: wja,
    B6: jbu,
    JJ: jj,
    LA: jj,
    LP: jj,
    IX: ix,
    HY: hy,
    CJ: cj,
    HV: hv,
    TVF: hv,
    TRA: hv,
    TO: hv,
    WK: wk,
    CAI: cai,
    XC: cai,
    XR: cai,
    CXI: cai,
    EJU: eju,
    EC: eju,
    U2: eju,
    DS: eju,
    EZS: eju,
    EZY: eju,
    EWG: ewg,
    EW: ewg,
    "4Y": ewg,
    RYR: ryr,
    FR: ryr,
    RK: ryr,
    SAS: sas,
    SK: sas,
    FB: fb,
    LZB: fb,
    TVS: tvs,
    QS: tvs,
    SWR: swr,
    LX: swr,
    TUI: tui,
    X3: tui,
    BY: tui,
    TOM: tui,
    "6B": tui,
    BLX: tui,
    LG: lg,
    LGL: lg,
    UX: ux,
    AEA: ux,
    ASA: alaska,
    AS: alaska,
    AAL: american,
    AA: american,
    CUB: cu,
    DAL: delta,
    DL: delta,
    QXE: horizon,
    UAL: ua,
    UA: ua,
    SWA: southwest,
    WN: southwest,
    GTI: gti,
    ACA: aca,
    AC: aca,
    AMX: amx,
    AM: amx,
    BAW: baw,
    BA: baw,
    EVA: eva,
    BR: eva,
    CPA: cpa,
    CX: cpa,
    CFG: cfg,
    DE: cfg,
    EIN: ein,
    EI: ein,
    UAE: uae,
    FFT: fft,
    F9: fft,
    ICE: ice,
    HAL: hal,
    HA: hal,
    CHH: chh,
    JAL: jal,
    JL: jal,
    KAL: kal,
    KE: kal,
    VLG: vlg,
    VY: vlg,
    WZZ: wzz,
    WMT: wzz,
    W6: wzz,
    W4: wzz,
    WUK: wzz,
    W9: wzz,
    DLH: dlh,
    LH: dlh,
    CL: dlh,
    CLH: dlh,
    VL: dlh,
    RCH: rch,
    ANA: ana,
    NH: ana,
    OAE: oae,
    AAR: aar,
    OZ: aar,
    QTR: qtr,
    QR: qtr,
    SIA: sia,
    SQ: sia,
    SCX: scx,
    SY: scx,
    VIR: vir,
    VA: vir,
    VOZ: vir,
    SWQ: swq,
    WJA: wja,
    VOI: voi,
    N3: voi,
    NKS: nks,
    JBU: jbu,
    KL: klm,
    KLM: klm,
    EXS: exs,
    LS: exs,
    AUA: aua,
    OS: aua,
    NOZ: NOZ,
    DY: NOZ,
    NSZ: NOZ,
    D8: NOZ,
    VKG: VKG,
    DK: VKG,
    SDR: SDR,
    SR: SDR,
    CI: CI,
    CAL: CI,
    FIN: fin,
    AY: fin,
    HTY: thy,
    THY: thy,
    TK: thy,
    LXJ: lxj,
    PR: pr,
    PAL: pr,
    AAY: aay,
    G4: aay,
    "2L": helvetic,
    OAW: helvetic,
    AFR: afr,
    AF: afr,
    A5: afr,
    HOP: afr,
    AP: albastar,
    LAV: albastar,
    BT: airbaltic,
    BTI: airbaltic,
    ET: ethiopian,
    ETH: ethiopian,
    FS: flyr,
    FOX: flyr,
    IB: iberia,
    IBE: iberia,
    I2: iberia,
    KM: malta,
    AMC: malta,
    NO: neos,
    NOS: neos,
    AI: aic,
    AIC: aic,
    ANT: ant,
    "4N": ant,
    TSC: tsc,
    TS: tsc,
    RZO: rzo,
    S4: rzo,
    BBC: bbc,
    BG: bbc,
    CJL: cjl,
    AU: cjl,
    AKT: akt,
    "5L": akt,
    CES: ces,
    MU: ces,
    CSN: csn,
    CZ: csn,
    FLE: fle,
    F8: fle,
    JZA: jza,
    QK: jza,
    LOT: lot,
    LO: lot,
    DAT: dat,
    Y9: dat,
    OWG: owg,
    N5: owg,
    PIA: pia,
    PK: pia,
    POE: poe,
    PD: poe,
    RJA: rja,
    RJ: rja,
    SWG: swg,
    WG: swg,
    WSW: wsw,
    WO: wsw,
    TAP: tap,
    TP: tap,
    AUI: aui,
    PS: aui,
    FDB: fdb,
    FZ: fdb,
    QFA: qfa,
    QF: qfa,
    A3: aee,
    AEE: aee,
    XZ: aez,
    AEZ: aez,
    JD: cbj,
    CBJ: cbj,
    SN: bel,
    BEL: bel,
    BXI: bel,
    FJ: fji,
    FJI: fji,
    AZ: ity,
    ITY: ity,
    MH: mas,
    MAS: mas,
    AT: ram,
    RAM: ram,
    TR: tgw,
    TGW: tgw,
    VN: hvn,
    HVN: hvn,
    V7: voe,
    VOE: voe,
    SV: sva,
    SVA: sva,
    PC: pgt,
    PGT: pgt,
    "6E": igo,
    IGO: igo,
    RXA: rxa,
    ZL: rxa,
    GA: gia,
    GIA: gia,
    GF: gfa,
    GFA: gfa,
    JT: lni,
    LNI: lni,
    JU: asl,
    ASL: asl,
    N0: nbt,
    NBT: nbt,
    Z0: nbt,
    UBT: nbt,
    OU: ctn,
    CTN: ctn,
    ZQ: mne,
    MNE: mne,
    DM: dwi,
    DWI: dwi,
    DX: dtr,
    DTR: dtr,
    BQ: swu,
    SWU: swu,
    FI: ice,
    OG: fpy,
    FPY: fpy,
    GL: grl,
    GRL: grl,
    JO: jtd,
    JTD: jtd,
    XQ: sxs,
    SXS: sxs,
    VF: tkj,
    TKJ: tkj,
    ME: mea,
    MEA: mea,
    CA: cca,
    CCA: cca,
    HU: chh,
    VLU: vlu,
    UD: ubd,
    UBD: ubd,
    J2: ahy,
    AHY: ahy,
    BJ: lbt,
    LBT: lbt,
    "5F": fia,
    OE: fia,
    FIA: fia,
    FH: fhy,
    FHY: fhy,
    TAH: tah,
    "6K": tah,
    MSC: msc,
    SM: msc,
    ISR: isr,
    "6H": isr,
    GPX: gpx,
    IV: gpx,
    NMA: nma,
    NE: nma,
    TGZ: tgz,
    A9: tgz,
    ENT: ent,
    E4: ent,
    SEK: sek,
    "4R": sek,
    ABL: abl,
    BX: abl,
    AIQ: aiq,
    FD: aiq,
    ASV: asv,
    RS: asv,
    CEB: ceb,
    "5J": ceb,
    ESR: esr,
    ZE: esr,
    FDA: fda,
    JH: fda,
    CRK: crk,
    HX: crk,
    HKE: hke,
    UO: hke,
    JTA: jta,
    NU: jta,
    JJA: jja,
    "7C": jja,
    JJP: jjp,
    GK: jjp,
    JNA: jna,
    LJ: jna,
    APJ: apj,
    MM: apj,
    SKY: sky,
    BC: sky,
    CQH: cqh,
    "9C": cqh,
    SJO: cqh,
    IJ: cqh,
    SFJ: sfj,
    "7G": sfj,
    SJX: sjx,
    JX: sjx,
    TWB: twb,
    TW: twb,
    TVJ: tvj,
    VZ: tvj,
    TTW: ttw,
    IT: ttw,
    ADO: ado,
    HD: ado,
    APK: apk,
    P4: apk,
    BMA: bma,
    "2T": bma,
    CXA: cxa,
    MF: cxa,
    FLI: fli,
    RC: fli,
    KNE: kne,
    XY: kne,
    MAC: mac,
    "3O": mac,
    THT: tht,
    TN: tht,
    CAT: cat,
    TAR: tar,
    TU: tar,
    ACI: aci,
    SB: aci,
    AJX: ajx,
    NQ: ajx,
    ALK: alk,
    UL: alk,
    AMU: amu,
    NX: amu,
    ANG: ang,
    PX: ang,
    ANZ: anz,
    NZ: anz,
    BBG: bbg,
    BZ: bbg,
    BCI: bci,
    "8B": bci,
    BTK: btk,
    ID: btk,
    CSC: csc,
    "3U": csc,
    CTV: ctv,
    QG: ctv,
    DIG: dig,
    OP: dig,
    FFM: ffm,
    FY: ffm,
    ZG: zg,
    MLR: mlr,
    "8M": mlr,
    MXD: mxd,
    OD: mxd,
    SL: mxd,
    TLM: mxd,
    NIA: nia,
    NP: nia,
    OHY: ohy,
    OQ: ohy,
    RBA: rba,
    BI: rba,
    TWI: twi,
    TI: twi,
    UBA: uba,
    UB: uba,
    UBG: ubg,
    BS: ubg,
    VJH: vjh,
    H5: vjh,
    DRK: drk,
    KB: drk,
    NGN: ngn,
    KK: ngn,
});

const IMAGES_FOLDER_NAME = "media";
const ML_CONFIG_SUBMODULE_PATH = "deps/ml/core/configuration";
const FE_TO_ML_SETUP_NAME_MAP = {
    toy: "toymodel",
    asa: "sea",
    "master-staging": "master-setup",
};
const PARAMETER_GROUPS_IDS = ["in-block", "ready", "off-block"];
const SAFETY_ROLE = "safety";
const APP_KINDS = ["dashboard", "admin", "id"];

const getDefaultTimelineGroups = (itemPredicate) => {
    const defaults = [
        {
            key: "general",
            label: {
                "en-GB": "General",
                "en-US": "General",
                "de-DE": "Allgemein",
                "ja-JP": "全般",
            },
            order: 0,
            operations: [
                "pts_schedule_aircraft_on_stand",
                "aircraft_on_stand",
                "pts_schedule_aircraft_parked",
                "aircraft",
                "pts_schedule_pushback_on_stand",
                "pushback_on_stand",
                "tbl_pushback_on_stand",
                "pts_schedule_pushback_connected",
                "push_back",
                "push_back_together",
                "tbl_push_back",
                "small_tbl_push_back",
                "remote_control_pushback",
                "aircraft_ready",
                "pts_schedule_chocks_on",
                "chocks",
                "left_chocks",
                "right_chocks",
                "stand_not_clear",
                "fod_walk",
                "aircraft_wait_for_park",
                "critical_stand_not_clear",
                "towbar",
                "towbar_on_stand",
            ],
        },
        {
            key: "service",
            label: {
                "en-GB": "Service",
                "en-US": "Service",
                "de-DE": "Service",
                "ja-JP": "サービス",
            },
            order: 1,
            operations: [
                "pts_schedule_fueller_on_stand",
                "fueling_on_stand",
                "fueling_right_on_stand",
                "pts_schedule_fueller_in_position",
                "fueling_in_position",
                "fueling_right_in_position",
                "pts_schedule_fueller_connected",
                "fueling",
                "fueling_right",
                "pts_schedule_gpu_connected",
                "gpu",
                "gp",
                "gp_together",
                "pts_schedule_acu_connected",
                "acu",
                "acu_hose",
                "acu_hose_deployed",
                "pts_schedule_catering_on_stand",
                "front_catering_on_stand",
                "back_left_catering_on_stand",
                "back_right_catering_on_stand",
                "pts_schedule_catering_connected",
                "front_catering_truck",
                "middle_left_catering_truck",
                "middle_front_left_catering_truck",
                "middle_front_right_catering_truck",
                "upper_middle_front_left_catering_truck",
                "upper_middle_front_right_catering_truck",
                "lower_middle_left_catering_truck",
                "middle_back_right_catering_truck",
                "middle_back_left_catering_truck",
                "upper_middle_back_right_catering_truck",
                "upper_middle_back_left_catering_truck",
                "lower_middle_back_right_catering_truck",
                "lower_middle_back_left_catering_truck",
                "back_left_catering_truck",
                "back_right_catering_truck",
                "back_right_catering",
                "pts_schedule_water_lav_truck_in_position",
                "water_truck_in_position",
                "sewage_in_position",
                "front_left_truck_in_position",
                "front_right_truck_in_position",
                "back_left_truck_in_position",
                "back_right_truck_in_position",
                "pts_schedule_cleaners_on_stand",
                "cleaning_on_stand",
                "back_right_cleaners_on_stand",
                "pts_schedule_cleaners_connected",
                "back_left_cleaners",
                "back_right_cleaners",
                "cleaning_team_onboarding_via_airstairs",
                "cleaning_team_disembarkation_via_airstairs",
                "cleaning_team_onboarding",
                "cleaning_team_offboarding",
                "vacuum_onboarding",
                "vacuum_offboarding",
                "pts_schedule_aircraft_door_open",
                "front_pax_door",
                "pax_door_together",
                "front_left_aircraft_door",
                "front_right_aircraft_door",
                "middle_front_left_aircraft_door",
                "middle_front_right_aircraft_door",
                "upper_middle_front_left_aircraft_door",
                "upper_middle_front_right_aircraft_door",
                "lower_middle_front_left_aircraft_door",
                "lower_middle_front_right_aircraft_door",
                "middle_back_left_aircraft_door",
                "middle_back_right_aircraft_door",
                "upper_middle_back_left_aircraft_door",
                "upper_middle_back_right_aircraft_door",
                "lower_middle_back_left_aircraft_door",
                "lower_middle_back_right_aircraft_door",
                "back_left_aircraft_door",
                "back_right_aircraft_door",
                "cleaning_process",
                "upper_middle_left_catering_truck",
                "catering_on_whole_stand",
                "fueling_on_whole_stand",
            ],
        },
        {
            key: "passengers",
            label: {
                "en-GB": "Passengers",
                "en-US": "Passengers",
                "de-DE": "Passagiere",
                "ja-JP": "旅客",
            },
            order: 2,
            operations: [
                "pts_schedule_bridge_parked",
                "bridge_parked",
                "pts_schedule_bridge_on_stand",
                "passenger_ramp_on_stand",
                "small_passenger_ramp_on_stand",
                "back_stairs_on_stand",
                "back_left_stairs_on_stand",
                "front_stairs_on_stand",
                "pts_schedule_bridge_connected",
                "bridge",
                "bridge_alt",
                "middle_bridge_alt",
                "upper_middle_bridge_alt",
                "lower_middle_bridge_alt",
                "bridge_alt_together",
                "front_stairs",
                "front_left_stairs",
                "back_stairs",
                "back_left_stairs",
                "onboard_airstair",
                "back_onboard_airstair",
                "prm_staff_at_bridge",
                "pts_schedule_ambulift_on_stand",
                "front_ambulift_on_stand",
                "back_ambulift_on_stand",
                "pts_schedule_ambulift_connected",
                "front_ambulift",
                "back_ambulift",
                "front_ambulift_moved",
                "back_ambulift_moved",
                "front_right_ambulift_moved",
                "back_right_ambulift_moved",
                "pass_bus_on_stand",
                "pts_schedule_passengers_offboarding",
                "pax_out",
                "pax_on_back_stair_unloading",
                "pts_schedule_passengers_onboarding",
                "pax_in",
                "pax_on_back_stair_loading",
                "gate_door_open",
                "gate_open",
                "boarding_into_gate_area",
                "ramp_agent",
            ],
        },
        {
            key: "cargo",
            label: {
                "en-GB": "Cargo",
                "en-US": "Cargo",
                "de-DE": "Ladung/Fracht",
                "ja-JP": "貨物",
            },
            order: 3,
            operations: [
                "pts_schedule_cargo_door_open",
                "front_cargo",
                "front_cargo_bulk",
                "front_cargo_together",
                "front_right_cargo",
                "front_right_cargo_bulk",
                "middle_cargo_bulk",
                "back_cargo",
                "back_cargo_bulk",
                "back_right_cargo",
                "back_right_cargo_bulk",
                "back_cargo_together",
                "pts_schedule_belt_on_stand",
                "front_highloader_on_stand",
                "back_highloader_on_stand",
                "front_belt_on_stand",
                "back_belt_on_stand",
                "back_right_belt_on_stand",
                "back_dolly",
                "front_dolly",
                "pts_schedule_belt_connected",
                "front_highloader",
                "back_highloader",
                "front_belt",
                "middle_belt",
                "back_belt",
                "back_right_belt",
                "pts_schedule_luggage_unloading",
                "front_luggage_on_belt_unloading",
                "back_luggage_on_belt_unloading",
                "back_right_luggage_on_belt_unloading",
                "luggage_unloading",
                "pts_schedule_luggage_loading",
                "front_luggage_on_belt_loading",
                "back_luggage_on_belt_loading",
                "back_right_luggage_on_belt_loading",
                "luggage_loading",
                "pts_schedule_container_unloading",
                "front_container_unloading",
                "back_container_unloading",
                "pts_schedule_container_loading",
                "front_container_loading",
                "back_container_loading",
            ],
        },
        {
            key: "crew",
            label: {
                "en-GB": "Crew",
                "en-US": "Crew",
                "de-DE": "Crew",
                "ja-JP": "クルー",
            },
            order: 4,
            operations: [
                "boarding_agent_at_gate",
                "cabin_crew_onboarding",
                "cabin_crew_offboarding",
                "cockpit_crew_onboarding",
                "cockpit_crew_offboarding",
                "arrival_walkaround_together",
                "departure_walkaround_together",
            ],
        },
        {
            key: "wingwalkers",
            label: {
                "en-GB": "Wingwalkers",
                "en-US": "Wingwalkers",
                "de-DE": "Wingwalkers",
                "ja-JP": "翼端監視員",
            },
            order: 5,
            operations: [
                "pts_schedule_wingwalkers",
                "left_wingwalker",
                "left_night_wand_usage",
                "right_wingwalker",
                "right_night_wand_usage",
            ],
        },
        {
            key: "others",
            label: {
                "en-GB": "Others",
                "en-US": "Others",
                "de-DE": "Andere",
                "ja-JP": "その他",
            },
            order: 99,
            operations: [
                "pts_schedule_tailstand_connected",
                "tail_stand",
                "pts_schedule_apu",
                "apu_sound",
                "pts_schedule_engine",
                "engine_sound",
                "pts_schedule_engine_cone_on",
                "left_engine_cone",
                "right_engine_cone",
                "second_left_engine_cone",
                "second_right_engine_cone",
                "human_without_vest",
                "human_entered_eiz2",
                "deicing_in_progress",
                "object_track_not_stopped",
                "front_catering_guard_rail",
                "back_left_catering_guard_rail",
                "back_right_catering_guard_rail",
                "one_front_left_catering_handrail_not_deployed",
                "back_right_catering_handrail_not_deployed",
                "one_back_right_catering_handrail_not_deployed",
                "front_catering_handrail_not_deployed",
                "catering_handrail_not_deployed",
                "front_belt_guard_rail_not_deployed",
                "walkaround_front_right",
                "walkaround_front_left",
                "walkaround_back_right",
                "walkaround_back_left",
                "bridge_not_parked",
                "second_bridge_not_parked",
                "flight_bags",
                "flight_pax",
                "pts_schedule_baggage",
                "pts_schedule_passengers",
                "aircraft_on_line_1",
                "aircraft_on_line_2",
                "aircraft_on_line_3",
                "aircraft_on_line_4",
                "aircraft_on_line_5",
                "aircraft_on_line_6",
                "aircraft_on_line_7",
                "aircraft_on_line_8",
                "aircraft_on_line_9",
            ],
        },
    ];
    if (typeof itemPredicate === "function") {
        return defaults.map(itemPredicate);
    }
    return defaults;
};

const defaultDashboardUITexts = {
    tutorial: {
        "en-GB": "Tutorial",
        "en-US": "Tutorial",
        "de-DE": "Tutorial",
        "ja-JP": "チュートリアル",
    },
    export_eobt_label: {
        "en-GB": "EOBT",
        "en-US": "EOBT",
        "de-DE": "EOBT",
        "ja-JP": "EOBT",
    },
};

const turnaroundApiRegex = "^/api/stands/([\\w-]+)/turnarounds/([\\w-]+)$";
const getDefaultMulticonfig = () => ({
    updateRate: 2000,
    requestTimeout: 30000,
    watchListLifePeriod: 3600 * 1000 * 20,
    fixPOBTOutOfBounds: false,
    disableWatchlist: false,
    setupType: "single",
    multiairportData: null,
    airports: {},
    commitHash: "",
    airlineIcons: getAirlineIconMap(),
    configVersion: "mock-version",
    locales: DEFAULT_LOCALES,
    defaultLocale: "en-GB",
});
const defaultTurnaroundParameters = getDefaultTurnaroundParameters();
// FIXME: Include required localized fields only (pass `locales` argument)
const createDefaultDashboardConfig = () => ({
    disableWatchlist: false,
    contactEmail: "support@assaia.com",
    turnaroundRedStatusThreshold: null,
    maxTriesUntilError: 3,
    showDetectionGap: false,
    disableExport: false,
    showStandClear: [],
    turnaroundsRequestLimit: 20,
    breakDetections: [],
    matomoSendUserId: true,
    turnaroundsStartTimestamp: null,
    contactPhone: null,
    watchListStandsGroups: [],
    turnaroundsVisibleRangeSizeByRole: null,
    turnParamsSource: {},
    apiMiddlewares: [
        {
            urlRegex: "timeline",
            preMiddleware: null,
            postMiddleware: "leaveFirstAndLastWalkaround",
        },
        {
            urlRegex: "export",
            preMiddleware: null,
            postMiddleware: "leaveFirstAndLastWalkaround",
        },
        {
            urlRegex: turnaroundApiRegex,
            preMiddleware: null,
            postMiddleware: "leaveFirstAndLastWalkaround",
        },
        {
            urlRegex: "timeline",
            preMiddleware: null,
            postMiddleware: "lifecycleMiddleware",
        },
        {
            urlRegex: "export",
            preMiddleware: null,
            postMiddleware: "lifecycleMiddleware",
        },
        {
            urlRegex: turnaroundApiRegex,
            preMiddleware: null,
            postMiddleware: "lifecycleMiddleware",
        },
    ],
    showStandClearAlert: false,
    showOutagesFor: ["superuser"],
    showPtsIntervals: false,
    showSupportButton: true,
    mergeOperations: false,
    mergableOperations: {},
    timelineGroups: getDefaultTimelineGroups(),
    redWarning: null,
    yellowWarning: null,
    frozen: false,
    minOperationConfidence: null,
    ignoreMinOperationConfidenceOps: [],
    hideTimelineGroups: {},
    texts: defaultDashboardUITexts,
    hiddenOperations: [],
    logoUrl: null,
    logoHeight: null,
    camerasOrder: ["-s"],
    ignoredOperations: [],
    allowedIncidentSeveritiesOnMap: ["MEDIUM", "HIGH"],
    turnaroundProgressConfig: {
        enableColoredProgressBarsOnMap: true,
        countdownSource: "pobt",
        prediction: "pobt",
        reference: "sobt",
        offsetInSeconds: 0,
        customMessage: {
            "en-GB": "POBT > SOBT",
            "en-US": "POBT > SOBT",
            "de-DE": "POBT > SOBT",
            "ja-JP": "POBT > SOBT",
        },
    },
    turnaroundParameters: [
        defaultTurnaroundParameters.sibt,
        defaultTurnaroundParameters.aibt,
        defaultTurnaroundParameters.pobt,
        defaultTurnaroundParameters.sobt,
        defaultTurnaroundParameters.eobt,
        defaultTurnaroundParameters.aobt,
    ],
    turnaroundPanelConfig: {
        groups: [
            {
                label: {
                    "en-GB": "In-Block",
                    "en-US": "In-Block",
                    "de-DE": "In-Block",
                    "ja-JP": "インブロック",
                },
                parameters: ["sibt", "aibt"],
                highlighted: [],
                withPlaceholder: [],
                hiddenWithoutOutboundFlight: [],
                hiddenWithoutInboundFlight: [],
            },
            {
                label: {
                    "en-GB": "Off-Block",
                    "en-US": "Off-Block",
                    "de-DE": "Off-Block",
                    "ja-JP": "オフブロック",
                },
                parameters: ["pobt", "sobt", "eobt", "aobt"],
                highlighted: ["pobt"],
                withPlaceholder: ["pobt"],
                hiddenWithoutOutboundFlight: ["pobt"],
                hiddenWithoutInboundFlight: [],
            },
        ],
        isAcRegNumberEnabled: true,
        isAcTailNumberEnabled: false,
    },
    standIdToStandLabelMap: {},
    terminals: [],
    standIdToAliasMap: {},
    tc2Features: {
        watchlistTiles: false,
        ganttChartTable: false,
        widgets: false,
    },
    tc2TrialButton: null,
    operationWidgetTitles: {
        pts_schedule_bridge_connected: {
            "en-GB": "bridge",
            "en-US": "bridge",
            "de-DE": "Brücke",
            "ja-JP": "bridge",
        },
        pts_schedule_gpu_connected: {
            "en-GB": "gpu",
            "en-US": "gpu",
            "de-DE": "GPU",
            "ja-JP": "gpu",
        },
        pts_schedule_cargo_door_open: {
            "en-GB": "cargo",
            "en-US": "cargo",
            "de-DE": "Ladung/Fracht",
            "ja-JP": "cargo",
        },
        pts_schedule_catering_connected: {
            "en-GB": "catering",
            "en-US": "catering",
            "de-DE": "Catering",
            "ja-JP": "catering",
        },
        pts_schedule_fueller_connected: {
            "en-GB": "fueller",
            "en-US": "fueler",
            "de-DE": "Betankungsfahrzeug",
            "ja-JP": "fueller",
        },
        pts_schedule_pushback_connected: {
            "en-GB": "pushback",
            "en-US": "pushback",
            "de-DE": "Pushback",
            "ja-JP": "pushback",
        },
        pts_schedule_belt_connected: {
            "en-GB": "(un)loading",
            "en-US": "(un)loading",
            "de-DE": "ausladen / entladen",
            "ja-JP": "(un)loading",
        },
    },
    operationWidgetStartLabels: {
        STANDBY: {
            "en-GB": "Standby",
            "en-US": "Standby",
            "de-DE": "Standby",
            "ja-JP": "Standby",
        },
        STANDBY_SLIGHTLY_LATE: {
            "en-GB": "Slight delay",
            "en-US": "Slight delay",
            "de-DE": "Leicht verspätet",
            "ja-JP": "Slight delay",
        },
        STANDBY_VERY_LATE: {
            "en-GB": "Delayed",
            "en-US": "Delayed",
            "de-DE": "Verspätet",
            "ja-JP": "Delayed",
        },
        SLIGHTLY_LATE: {
            "en-GB": "Started slightly late",
            "en-US": "Started slightly late",
            "de-DE": "Leicht verspätet gestartet",
            "ja-JP": "Started slightly late",
        },
        VERY_LATE: {
            "en-GB": "Started late",
            "en-US": "Started late",
            "de-DE": "Allgemein",
            "ja-JP": "Started late",
        },
        SLIGHTLY_EARLY: {
            "en-GB": "Started slightly early",
            "en-US": "Started slightly early",
            "de-DE": "Leicht zu früh gestartet",
            "ja-JP": "Started slightly early",
        },
        VERY_EARLY: {
            "en-GB": "Started too early",
            "en-US": "Started too early",
            "de-DE": "Zu früh gestartet",
            "ja-JP": "Started too early",
        },
        ON_TIME: {
            "en-GB": "Started on time",
            "en-US": "Started on time",
            "de-DE": "Pünktlich gestartet",
            "ja-JP": "Started on time",
        },
    },
    operationWidgetEndLabels: {
        STANDBY: {
            "en-GB": "Standby",
            "en-US": "Standby",
            "de-DE": "Standby",
            "ja-JP": "Standby",
        },
        STANDBY_SLIGHTLY_LATE: {
            "en-GB": "In progress, slight delay",
            "en-US": "In progress, slight delay",
            "de-DE": "Turnaround läuft, leichte Verspätung",
            "ja-JP": "In progress, slight delay",
        },
        STANDBY_VERY_LATE: {
            "en-GB": "In progress, delayed",
            "en-US": "In progress, delayed",
            "de-DE": "Turnaround läuft, leicht verspätet",
            "ja-JP": "In progress, delayed",
        },
        SLIGHTLY_LATE: {
            "en-GB": "Finished slightly late",
            "en-US": "Finished slightly late",
            "de-DE": "Leicht zu spät beendet",
            "ja-JP": "Finished slightly late",
        },
        VERY_LATE: {
            "en-GB": "Finished late",
            "en-US": "Finished late",
            "de-DE": "Spät beendet",
            "ja-JP": "Finished late",
        },
        SLIGHTLY_EARLY: {
            "en-GB": "Finished slightly early",
            "en-US": "Finished slightly early",
            "de-DE": "Leicht zu früh beendet",
            "ja-JP": "Finished slightly early",
        },
        VERY_EARLY: {
            "en-GB": "Finished too early",
            "en-US": "Finished too early",
            "de-DE": "Zu früh beendet",
            "ja-JP": "Finished too early",
        },
        ON_TIME: {
            "en-GB": "Finished on time",
            "en-US": "Finished on time",
            "de-DE": "Pünktlich beendet",
            "ja-JP": "Finished on time",
        },
    },
    safetyLampsOrder: [
        "wingwalker",
        "pushback_speed",
        "towbar_angle",
        "chocks",
        "fwd-belt-handrails",
        "brake-check",
        "safety-stop",
        "safety-vests",
        "right-engine-cone",
        "starboard-engine-cone",
        "port-engine-cone-2",
        "starboard-engine-cone-2",
        "fod-walk",
        "ramp_agent",
        "human-entered-eiz2",
        "catering_handrail",
        "left_catering_handrail_not_deployed",
        "right_catering_handrail_not_deployed",
        "provo-rails",
        "weighted",
    ],
    numericalOperationWidgetDisplayMode: "absolute",
    customAdminUrl: null,
    gateAcReadyIconSource: "aircraft_ready_ts",
    acdm: null,
    nextFlights: null,
    safetySections: [],
});

const createDashboardConfigMock = () => {
    const defaultConfig = createDefaultDashboardConfig();
    const specificFields = {
        matomoID: "",
        SENTRY_DSN: "",
        airportKey: "mock",
        airportTimezone: "UTC",
        hotjarId: null,
        standsWithSafety: [],
    };
    return {
        ...defaultConfig,
        ...specificFields,
        detectionTypes: [],
        ptsLabels: {},
        buildTs: 0,
        operationWidgets: [],
        ptsOperationsGroups: {},
        turnaroundEvents: [],
    };
};

const defaultEventLabels = {
    upper_middle_back_right_catering_truck_disconnected: {
        "en-GB": "Upper mid aft catering disconnected",
        "de-DE": "Upper mid aft catering disconnected",
        "en-US": "Upper mid aft catering disconnected",
        "ja-JP": "Upper mid aft catering disconnected",
    },
    upper_middle_back_right_catering_truck_connected: {
        "en-GB": "Upper mid aft catering connected",
        "de-DE": "Upper mid aft catering connected",
        "en-US": "Upper mid aft catering connected",
        "ja-JP": "Upper mid aft catering connected",
    },
    upper_middle_back_right_aircraft_door_closed: {
        "en-GB": "Upper mid aft service door closed",
        "de-DE": "Upper mid aft service door closed",
        "en-US": "Upper mid aft service door closed",
        "ja-JP": "Upper mid aft service door closed",
    },
    upper_middle_back_right_aircraft_door_open: {
        "en-GB": "Upper mid aft service door open",
        "de-DE": "Upper mid aft service door open",
        "en-US": "Upper mid aft service door open",
        "ja-JP": "Upper mid aft service door open",
    },
    upper_middle_front_left_aircraft_door_open: {
        "en-GB": "Upper mid fwd service door open",
        "de-DE": "Upper mid fwd service door open",
        "en-US": "Upper mid fwd service door open",
        "ja-JP": "Upper mid fwd service door open",
    },
    upper_middle_front_left_aircraft_door_closed: {
        "en-GB": "Upper mid fwd service door closed",
        "de-DE": "Upper mid fwd service door closed",
        "en-US": "Upper mid fwd service door closed",
        "ja-JP": "Upper mid fwd service door closed",
    },
    upper_middle_left_catering_truck_connected: {
        "en-GB": "Upper mid fwd catering connected",
        "de-DE": "Upper mid fwd catering connected",
        "en-US": "Upper mid fwd catering connected",
        "ja-JP": "Upper mid fwd catering connected",
    },
    upper_middle_left_catering_truck_disconnected: {
        "en-GB": "Upper mid fwd catering disconnected",
        "de-DE": "Upper mid fwd catering disconnected",
        "en-US": "Upper mid fwd catering disconnected",
        "ja-JP": "Upper mid fwd catering disconnected",
    },
    front_dolly_left_stand: {
        "de-DE": "Vordere Dolly verlässt Standplatz",
        "en-GB": "Fwd dolly left stand",
        "en-US": "Fwd dolly left stand",
        "ja-JP": "Fwd dolly left stand",
    },
    front_dolly_entered_stand: {
        "de-DE": "Vordere Dolly auf Standplatz",
        "en-GB": "Fwd dolly entered stand",
        "en-US": "Fwd dolly entered stand",
        "ja-JP": "Fwd dolly entered stand",
    },
    back_dolly_left_stand: {
        "de-DE": "Hintere Dolly verlässt Standplatz",
        "en-GB": "Aft dolly left stand",
        "en-US": "Aft dolly left stand",
        "ja-JP": "Aft dolly left stand",
    },
    back_dolly_entered_stand: {
        "de-DE": "Hintere Dolly auf Standplatz",
        "en-GB": "Aft dolly entered stand",
        "en-US": "Aft dolly entered stand",
        "ja-JP": "Aft dolly entered stand",
    },
    pushback_entered_stand: {
        "de-DE": "Pushback auf Standplatz",
        "en-GB": "Pushback tug entered position",
        "en-US": "Pushback tug entered position",
        "ja-JP": "航空機牽引車 定位置侵入",
    },
    pushback_left_stand: {
        "de-DE": "Pushback verlässt Standplatz",
        "en-GB": "Pushback tug left position",
        "en-US": "Pushback tug left position",
        "ja-JP": "航空機牽引車 定位置離脱",
    },
    push_back_connected: {
        "de-DE": "Pushback verbunden",
        "en-GB": "Pushback tug connected",
        "en-US": "Pushback tug connected",
        "ja-JP": "航空機牽引車 接続",
    },
    push_back_disconnected: {
        "de-DE": "Pushback getrennt",
        "en-GB": "Pushback tug disconnected",
        "en-US": "Pushback tug disconnected",
        "ja-JP": "航空機牽引車 取り外し",
    },
    aircraft_entered_stand: {
        "de-DE": "Luftfahrzeug auf Standplatz",
        "en-GB": "Aircraft entered stand",
        "en-US": "Aircraft entered stand",
        "ja-JP": "航空機スポット侵入",
    },
    aircraft_left_stand: {
        "de-DE": "Luftfahrzeug verlässt Standplatz",
        "en-GB": "Aircraft left stand",
        "en-US": "Aircraft left stand",
        "ja-JP": "航空機スポット離脱",
    },
    aircraft_stationary: {
        "de-DE": "Luftfahrzeug in Parkposition",
        "en-GB": "Aircraft parked",
        "en-US": "Aircraft parked",
        "ja-JP": "航空機駐機",
    },
    pushback_started: {
        "de-DE": "Start Pushback",
        "en-GB": "Pushback started",
        "en-US": "Pushback started",
        "ja-JP": "プッシュバック開始",
    },
    aircraft_ready: {
        "de-DE": "Luftfahrzeug bereit",
        "en-GB": "Aircraft ready",
        "en-US": "Aircraft ready",
        "ja-JP": "Aircraft ready",
    },
    bridge_connected: {
        "de-DE": "Fluggastbrücke verbunden",
        "en-GB": "Bridge connected",
        "en-US": "Bridge connected",
        "ja-JP": "搭乗橋接続",
    },
    bridge_disconnected: {
        "de-DE": "Fluggastbrücke getrennt",
        "en-GB": "Bridge disconnected",
        "en-US": "Bridge disconnected",
        "ja-JP": "搭乗橋取り外し",
    },
    back_stairs_entered_stand: {
        "de-DE": "Fluggasttreppe hinten auf Standplatz",
        "en-GB": "Aft port stairs entered stand",
        "en-US": "Aft port stairs entered stand",
        "ja-JP": "Aft port stairs entered stand",
    },
    back_stairs_left_stand: {
        "de-DE": "Fluggasttreppe hinten verlässt Standplatz",
        "en-GB": "Aft port stairs left stand",
        "en-US": "Aft port stairs left stand",
        "ja-JP": "Aft port stairs left stand",
    },
    back_stairs_connected: {
        "de-DE": "Fluggasttreppe hinten verbunden",
        "en-GB": "Aft port stairs connected",
        "en-US": "Aft port stairs connected",
        "ja-JP": "Aft port stairs connected",
    },
    back_stairs_disconnected: {
        "de-DE": "Fluggasttreppe hinten getrennt",
        "en-GB": "Aft port stairs disconnected",
        "en-US": "Aft port stairs disconnected",
        "ja-JP": "Aft port stairs disconnected",
    },
    back_left_stairs_entered_stand: {
        "de-DE": "Fluggasttreppe hinten auf Standplatz",
        "en-GB": "Aft starboard stairs entered stand",
        "en-US": "Aft starboard stairs entered stand",
        "ja-JP": "Aft starboard stairs entered stand",
    },
    back_left_stairs_left_stand: {
        "de-DE": "Fluggasttreppe hinten verlässt Standplatz",
        "en-GB": "Aft starboard stairs left stand",
        "en-US": "Aft starboard stairs left stand",
        "ja-JP": "Aft starboard stairs left stand",
    },
    back_left_stairs_connected: {
        "de-DE": "Fluggasttreppe hinten verbunden",
        "en-GB": "Aft starboard stairs connected",
        "en-US": "Aft starboard stairs connected",
        "ja-JP": "Aft starboard stairs connected",
    },
    back_left_stairs_disconnected: {
        "de-DE": "Fluggasttreppe hinten getrennt",
        "en-GB": "Aft starboard stairs disconnected",
        "en-US": "Aft starboard stairs disconnected",
        "ja-JP": "Aft starboard stairs disconnected",
    },
    front_stairs_entered_stand: {
        "de-DE": "Fluggasttreppe vorne auf Standplatz",
        "en-GB": "Fwd port stairs entered stand",
        "en-US": "Fwd port stairs entered stand",
        "ja-JP": "Fwd port stairs entered stand",
    },
    front_stairs_left_stand: {
        "de-DE": "Fluggasttreppe vorne verlässt Standplatz",
        "en-GB": "Fwd port stairs left stand",
        "en-US": "Fwd port stairs left stand",
        "ja-JP": "Fwd port stairs left stand",
    },
    front_stairs_connected: {
        "de-DE": "Fluggasttreppe vorne verbunden",
        "en-GB": "Fwd port stairs connected",
        "en-US": "Fwd port stairs connected",
        "ja-JP": "Fwd port stairs connected",
    },
    front_stairs_disconnected: {
        "de-DE": "Fluggasttreppe vorne getrennt",
        "en-GB": "Fwd port stairs disconnected",
        "en-US": "Fwd port stairs disconnected",
        "ja-JP": "Fwd port stairs disconnected",
    },
    front_left_stairs_connected: {
        "de-DE": "Fluggasttreppe vorne verbunden",
        "en-GB": "Fwd starboard stairs connected",
        "en-US": "Fwd starboard stairs connected",
        "ja-JP": "Fwd starboard stairs connected",
    },
    front_left_stairs_disconnected: {
        "de-DE": "Fluggasttreppe vorne getrennt",
        "en-GB": "Fwd starboard stairs disconnected",
        "en-US": "Fwd starboard stairs disconnected",
        "ja-JP": "Fwd starboard stairs disconnected",
    },
    onboard_airstair_connected: {
        "de-DE": "Bordeigene Treppe ausgefahren",
        "en-GB": "Fwd on-board stairs deployed",
        "en-US": "Fwd on-board stairs deployed",
        "ja-JP": "Fwd on-board stairs deployed",
    },
    onboard_airstair_disconnected: {
        "de-DE": "Bordeigene Treppe eingefahren",
        "en-GB": "Fwd on-board stairs retracted",
        "en-US": "Fwd on-board stairs retracted",
        "ja-JP": "Fwd on-board stairs retracted",
    },
    back_onboard_airstair_connected: {
        "de-DE": "Bordeigene Treppe ausgefahren",
        "en-GB": "Aft on-board stairs deployed",
        "en-US": "Aft on-board stairs deployed",
        "ja-JP": "Aft on-board stairs deployed",
    },
    back_onboard_airstair_disconnected: {
        "de-DE": "Bordeigene Treppe eingefahren",
        "en-GB": "Aft on-board stairs retracted",
        "en-US": "Aft on-board stairs retracted",
        "ja-JP": "Aft on-board stairs retracted",
    },
    front_cargo_open: {
        "de-DE": "Frachttür vorne offen",
        "en-GB": "Fwd starboard cargo door open",
        "en-US": "Fwd starboard cargo door open",
        "ja-JP": "前方右側貨物ドアオープン",
    },
    front_cargo_closed: {
        "de-DE": "Frachttür vorne geschlossen",
        "en-GB": "Fwd starboard cargo door closed",
        "en-US": "Fwd starboard cargo door closed",
        "ja-JP": "前方左側貨物ドアクローズ",
    },
    front_right_cargo_open: {
        "de-DE": "Frachttür vorne offen",
        "en-GB": "Fwd port cargo door open",
        "en-US": "Fwd port cargo door open",
        "ja-JP": "前方左側貨物ドアオープン",
    },
    front_right_cargo_closed: {
        "de-DE": "Frachttür vorne geschlossen",
        "en-GB": "Fwd port cargo door closed",
        "en-US": "Fwd port cargo door closed",
        "ja-JP": "前方左側貨物ドアクローズ",
    },
    front_cargo_bulk_open: {
        "de-DE": "Frachttür vorne offen",
        "en-GB": "Fwd starboard cargo bulk door open",
        "en-US": "Fwd starboard cargo bulk door open",
        "ja-JP": "Fwd starboard cargo bulk door open",
    },
    front_cargo_bulk_closed: {
        "de-DE": "Frachttür vorne geschlossen",
        "en-GB": "Fwd starboard cargo bulk door closed",
        "en-US": "Fwd starboard cargo bulk door closed",
        "ja-JP": "Fwd starboard cargo bulk door closed",
    },
    front_right_cargo_bulk_open: {
        "de-DE": "Frachttür vorne offen",
        "en-GB": "Fwd port cargo bulk door open",
        "en-US": "Fwd port cargo bulk door open",
        "ja-JP": "Fwd port cargo bulk door open",
    },
    front_right_cargo_bulk_closed: {
        "de-DE": "Frachttür vorne geschlossen",
        "en-GB": "Fwd port cargo bulk door closed",
        "en-US": "Fwd port cargo bulk door closed",
        "ja-JP": "Fwd port cargo bulk door closed",
    },
    back_cargo_open: {
        "de-DE": "Frachttür hinten offen",
        "en-GB": "Aft starboard cargo door open",
        "en-US": "Aft starboard cargo door open",
        "ja-JP": "後方右側貨物ドアオープン",
    },
    back_cargo_closed: {
        "de-DE": "Frachttür hinten geschlossen",
        "en-GB": "Aft starboard cargo door closed",
        "en-US": "Aft starboard cargo door closed",
        "ja-JP": "後方右側貨物ドアクローズ",
    },
    back_right_cargo_open: {
        "de-DE": "Frachttür hinten offen",
        "en-GB": "Aft port cargo door open",
        "en-US": "Aft port cargo door open",
        "ja-JP": "後方左側貨物ドアオープン",
    },
    back_right_cargo_closed: {
        "de-DE": "Frachttür hinten geschlossen",
        "en-GB": "Aft port cargo door closed",
        "en-US": "Aft port cargo door closed",
        "ja-JP": "後方左側貨物ドアクローズ",
    },
    back_cargo_bulk_open: {
        "de-DE": "Frachttür hinten offen",
        "en-GB": "Aft starboard cargo bulk door open",
        "en-US": "Aft starboard cargo bulk door open",
        "ja-JP": "Aft starboard cargo bulk door open",
    },
    back_cargo_bulk_closed: {
        "de-DE": "Frachttür hinten geschlossen",
        "en-GB": "Aft starboard cargo bulk door closed",
        "en-US": "Aft starboard cargo bulk door closed",
        "ja-JP": "Aft starboard cargo bulk door closed",
    },
    back_right_cargo_bulk_open: {
        "de-DE": "Frachttür hinten offen",
        "en-GB": "Aft port cargo bulk door open",
        "en-US": "Aft port cargo bulk door open",
        "ja-JP": "Aft port cargo bulk door open",
    },
    back_right_cargo_bulk_closed: {
        "de-DE": "Frachttür hinten geschlossen",
        "en-GB": "Aft port cargo bulk door closed",
        "en-US": "Aft port cargo bulk door closed",
        "ja-JP": "Aft port cargo bulk door closed",
    },
    middle_cargo_bulk_open: {
        "de-DE": "Frachttür mitte offen",
        "en-GB": "Mid starboard cargo door open",
        "en-US": "Mid starboard cargo door open",
        "ja-JP": "Mid starboard cargo door open",
    },
    middle_cargo_bulk_closed: {
        "de-DE": "Frachttür mitte geschlossen",
        "en-GB": "Mid starboard cargo door closed",
        "en-US": "Mid starboard cargo door closed",
        "ja-JP": "Mid starboard cargo door closed",
    },
    first_bag_out: {
        "de-DE": "Gepäckentladung gestartet",
        "en-GB": "Luggage unloading started",
        "en-US": "Luggage unloading started",
        "ja-JP": "Luggage unloading started",
    },
    last_bag_out: {
        "de-DE": "Gepäckentladung beendet",
        "en-GB": "Luggage unloading finished",
        "en-US": "Luggage unloading finished",
        "ja-JP": "Luggage unloading finished",
    },
    first_bag_in: {
        "de-DE": "Gepäckbeladung gestartet",
        "en-GB": "Luggage loading started",
        "en-US": "Luggage loading started",
        "ja-JP": "Luggage loading started",
    },
    last_bag_in: {
        "de-DE": "Gepäckbeladung beendet",
        "en-GB": "Luggage loading finished",
        "en-US": "Luggage loading finished",
        "ja-JP": "Luggage loading finished",
    },
    catering_connected: {
        "de-DE": "Catering verbunden",
        "en-GB": "Catering connected",
        "en-US": "Catering connected",
        "ja-JP": "Catering connected",
    },
    catering_asc: {
        "de-DE": "Catering verbunden",
        "en-GB": "Catering connected",
        "en-US": "Catering connected",
        "ja-JP": "Catering connected",
    },
    catering_disconnected: {
        "de-DE": "Catering getrennt",
        "en-GB": "Catering disconnected",
        "en-US": "Catering disconnected",
        "ja-JP": "Catering disconnected",
    },
    catering_desc: {
        "de-DE": "Catering getrennt",
        "en-GB": "Catering disconnected",
        "en-US": "Catering disconnected",
        "ja-JP": "Catering disconnected",
    },
    catering_entered_stand: {
        "de-DE": "Catering auf Standplatz",
        "en-GB": "Catering entered stand",
        "en-US": "Catering entered stand",
        "ja-JP": "Catering entered stand",
    },
    catering_left_stand: {
        "de-DE": "Catering verlässt Standplatz",
        "en-GB": "Catering left stand",
        "en-US": "Catering left stand",
        "ja-JP": "Catering left stand",
    },
    front_catering_connected: {
        "de-DE": "Catering vorne verbunden",
        "en-GB": "Fwd starboard catering connected",
        "en-US": "Fwd starboard catering connected",
        "ja-JP": "後方右側ケータリング車接続",
    },
    front_catering_asc: {
        "de-DE": "Catering vorne verbunden",
        "en-GB": "Fwd starboard catering connected",
        "en-US": "Fwd starboard catering connected",
        "ja-JP": "後方右側ケータリング車接続",
    },
    front_catering_disconnected: {
        "de-DE": "Catering vorne getrennt",
        "en-GB": "Fwd starboard catering disconnected",
        "en-US": "Fwd starboard catering disconnected",
        "ja-JP": "後方右側ケータリング車取り外し",
    },
    front_catering_desc: {
        "de-DE": "Catering vorne getrennt",
        "en-GB": "Fwd starboard catering disconnected",
        "en-US": "Fwd starboard catering disconnected",
        "ja-JP": "後方右側ケータリング車取り外し",
    },
    front_catering_entered_stand: {
        "de-DE": "Catering vorne auf Standplatz",
        "en-GB": "Fwd starboard catering entered stand",
        "en-US": "Fwd starboard catering entered stand",
        "ja-JP": "Fwd starboard catering entered stand",
    },
    front_catering_left_stand: {
        "de-DE": "Catering vorne verlässt Standplatz",
        "en-GB": "Fwd starboard catering left stand",
        "en-US": "Fwd starboard catering left stand",
        "ja-JP": "Fwd starboard catering left stand",
    },
    back_left_catering_connected: {
        "de-DE": "Catering hinten verbunden",
        "en-GB": "Aft starboard catering connected",
        "en-US": "Aft starboard catering connected",
        "ja-JP": "後方右側ケータリング車接続",
    },
    back_left_catering_asc: {
        "de-DE": "Catering hinten verbunden",
        "en-GB": "Aft starboard catering connected",
        "en-US": "Aft starboard catering connected",
        "ja-JP": "後方右側ケータリング車接続",
    },
    back_left_catering_disconnected: {
        "de-DE": "Catering hinten getrennt",
        "en-GB": "Aft starboard catering disconnected",
        "en-US": "Aft starboard catering disconnected",
        "ja-JP": "後方右側ケータリング車取り外し",
    },
    back_left_catering_desc: {
        "de-DE": "Catering hinten getrennt",
        "en-GB": "Aft starboard catering disconnected",
        "en-US": "Aft starboard catering disconnected",
        "ja-JP": "後方右側ケータリング車取り外し",
    },
    back_left_catering_entered_stand: {
        "de-DE": "Catering hinten auf Standplatz",
        "en-GB": "Aft starboard catering entered stand",
        "en-US": "Aft starboard catering entered stand",
        "ja-JP": "Aft starboard catering entered stand",
    },
    back_left_catering_left_stand: {
        "de-DE": "Catering hinten verlässt Standplatz",
        "en-GB": "Aft starboard catering left stand",
        "en-US": "Aft starboard catering left stand",
        "ja-JP": "Aft starboard catering left stand",
    },
    back_right_catering_connected: {
        "de-DE": "Catering hinten verbunden",
        "en-GB": "Aft port catering connected",
        "en-US": "Aft port catering connected",
        "ja-JP": "後方左側ケータリング車接続",
    },
    back_right_catering_asc: {
        "de-DE": "Catering hinten verbunden",
        "en-GB": "Aft port catering connected",
        "en-US": "Aft port catering connected",
        "ja-JP": "後方左側ケータリング車接続",
    },
    back_right_catering_disconnected: {
        "de-DE": "Catering hinten Catering getrennt",
        "en-GB": "Aft port catering disconnected",
        "en-US": "Aft port catering disconnected",
        "ja-JP": "後方左側ケータリング車取り外し",
    },
    back_right_catering_desc: {
        "de-DE": "Catering hinten getrennt",
        "en-GB": "Aft port catering disconnected",
        "en-US": "Aft port catering disconnected",
        "ja-JP": "後方左側ケータリング車取り外し",
    },
    back_right_catering_entered_stand: {
        "de-DE": "Catering hinten auf Standplatz",
        "en-GB": "Aft port catering entered stand",
        "en-US": "Aft port catering entered stand",
        "ja-JP": "Aft port catering entered stand",
    },
    back_right_catering_left_stand: {
        "de-DE": "Catering hinten verlässt Standplatz",
        "en-GB": "Aft port catering left stand",
        "en-US": "Aft port catering left stand",
        "ja-JP": "Aft port catering left stand",
    },
    middle_left_catering_connected: {
        "de-DE": "Catering mitte verbunden",
        "en-GB": "Mid starboard catering connected",
        "en-US": "Mid starboard catering connected",
        "ja-JP": "中央右側ケータリング車接続",
    },
    middle_left_catering_asc: {
        "de-DE": "Catering mitte verbunden",
        "en-GB": "Mid starboard catering connected",
        "en-US": "Mid starboard catering connected",
        "ja-JP": "中央右側ケータリング車接続",
    },
    middle_left_catering_disconnected: {
        "de-DE": "Catering mitte getrennt",
        "en-GB": "Mid starboard catering disconnected",
        "en-US": "Mid starboard catering disconnected",
        "ja-JP": "中央右側ケータリング車取り外し",
    },
    middle_left_catering_desc: {
        "de-DE": "Catering mitte getrennt",
        "en-GB": "Mid starboard catering disconnected",
        "en-US": "Mid starboard catering disconnected",
        "ja-JP": "中央右側ケータリング車取り外し",
    },
    middle_back_right_catering_asc: {
        "de-DE": "Catering mitte verbunden",
        "en-GB": "Mid port catering connected",
        "en-US": "Mid port catering connected",
        "ja-JP": "Mid port catering connected",
    },
    middle_back_right_catering_desc: {
        "de-DE": "Catering mitte getrennt",
        "en-GB": "Mid port catering disconnected",
        "en-US": "Mid port catering disconnected",
        "ja-JP": "Mid port catering disconnected",
    },
    front_belt_connected: {
        "de-DE": "Förderband vorne verbunden",
        "en-GB": "Fwd starboard belt connected",
        "en-US": "Fwd starboard belt connected",
        "ja-JP": "前方右側ベルトローダー接続",
    },
    front_belt_disconnected: {
        "de-DE": "Förderband vorne getrennt",
        "en-GB": "Fwd starboard belt disconnected",
        "en-US": "Fwd starboard belt disconnected",
        "ja-JP": "前方右側ベルトローダー取り外し",
    },
    back_belt_connected: {
        "de-DE": "Förderband hinten verbunden",
        "en-GB": "Aft starboard belt connected",
        "en-US": "Aft starboard belt connected",
        "ja-JP": "後方右側ベルトローダー接続",
    },
    back_belt_disconnected: {
        "de-DE": "Förderband hinten getrennt",
        "en-GB": "Aft starboard belt disconnected",
        "en-US": "Aft starboard belt disconnected",
        "ja-JP": "後方右側ベルトローダー取り外し",
    },
    middle_belt_connected: {
        "de-DE": "Förderband mitte verbunden",
        "en-GB": "Mid starboard belt connected",
        "en-US": "Mid starboard belt connected",
        "ja-JP": "Mid starboard belt connected",
    },
    middle_belt_disconnected: {
        "de-DE": "Förderband mitte getrennt",
        "en-GB": "Mid starboard belt disconnected",
        "en-US": "Mid starboard belt disconnected",
        "ja-JP": "Mid starboard belt disconnected",
    },
    back_right_belt_connected: {
        "de-DE": "Förderband hinten verbunden",
        "en-GB": "Aft port belt connected",
        "en-US": "Aft port belt connected",
        "ja-JP": "後方左側ベルトローダー接続",
    },
    back_right_belt_disconnected: {
        "de-DE": "Förderband hinten getrennt",
        "en-GB": "Aft port belt disconnected",
        "en-US": "Aft port belt disconnected",
        "ja-JP": "後方左側ベルトローダー取り外し",
    },
    gpu_connected: {
        "de-DE": "Bodenstrom verbunden",
        "en-GB": "GPU connected",
        "en-US": "GPU connected",
        "ja-JP": "GPU connected",
    },
    gpu_disconnected: {
        "de-DE": "Bodenstrom getrennt",
        "en-GB": "GPU disconnected",
        "en-US": "GPU disconnected",
        "ja-JP": "GPU disconnected",
    },
    gp_connected: {
        "de-DE": "Bodenstrom verbunden",
        "en-GB": "Ground power connected",
        "en-US": "Ground power connected",
        "ja-JP": "Ground power connected",
    },
    gp_disconnected: {
        "de-DE": "Bodenstrom getrennt",
        "en-GB": "Ground power disconnected",
        "en-US": "Ground power disconnected",
        "ja-JP": "Ground power disconnected",
    },
    fueling_entered_stand: {
        "de-DE": "Betankung auf Standplatz",
        "en-GB": "Starboard fueller on stand",
        "en-US": "Starboard fueler on stand",
        "ja-JP": "Starboard fueller on stand",
    },
    fueling_left_stand: {
        "de-DE": "Betankung verlässt Standplatz",
        "en-GB": "Starboard fueller left stand",
        "en-US": "Starboard fueler left stand",
        "ja-JP": "Starboard fueller left stand",
    },
    fueling_entered_whole_stand: {
        "de-DE": "Fueling entered stand",
        "en-GB": "Fueling entered stand",
        "en-US": "Fueling entered stand",
        "ja-JP": "Fueling entered stand",
    },
    fueling_left_whole_stand: {
        "de-DE": "Fueling left stand",
        "en-GB": "Fueling left stand",
        "en-US": "Fueling left stand",
        "ja-JP": "Fueling left stand",
    },
    fueling_connected: {
        "de-DE": "Betankung verbunden",
        "en-GB": "Starboard fueller connected",
        "en-US": "Starboard fueler connected",
        "ja-JP": "右側給油車接続",
    },
    fueling_disconnected: {
        "de-DE": "Betankung getrennt",
        "en-GB": "Starboard fueller disconnected",
        "en-US": "Starboard fueler disconnected",
        "ja-JP": "右側給油車取り外し",
    },
    fueling_entered_position: {
        "de-DE": "Betankung in Position",
        "en-GB": "Starboard fueller entered position",
        "en-US": "Starboard fueler entered position",
        "ja-JP": "Starboard fueller entered position",
    },
    fueling_left_position: {
        "de-DE": "Betankung verlässt Position",
        "en-GB": "Starboard fueller left position",
        "en-US": "Starboard fueler left position",
        "ja-JP": "Starboard fueller left position",
    },
    fueling_right_entered_position: {
        "de-DE": "Betankung in Position",
        "en-GB": "Port fueller entered position",
        "en-US": "Port fueler entered position",
        "ja-JP": "Port fueller entered position",
    },
    fueling_right_left_position: {
        "de-DE": "Betankung verlässt Position",
        "en-GB": "Port fueller left position",
        "en-US": "Port fueler left position",
        "ja-JP": "Port fueller left position",
    },
    pass_bus_entered_stand: {
        "de-DE": "Passagierbus auf Standplatz",
        "en-GB": "Passenger bus entered stand",
        "en-US": "Passenger bus entered stand",
        "ja-JP": "Passenger bus entered stand",
    },
    pass_bus_left_stand: {
        "de-DE": "Passagierbus verlässt Standplatz",
        "en-GB": "Passenger bus left stand",
        "en-US": "Passenger bus left stand",
        "ja-JP": "Passenger bus left stand",
    },
    catering_car_entered_stand: {
        "de-DE": "Catering auf Standplatz",
        "en-GB": "Catering entered stand",
        "en-US": "Catering entered stand",
        "ja-JP": "Catering entered stand",
    },
    catering_car_left_stand: {
        "de-DE": "Catering verlässt Standplatz",
        "en-GB": "Catering left stand",
        "en-US": "Catering left stand",
        "ja-JP": "Catering left stand",
    },
    front_highloader_connected: {
        "de-DE": "Highloader vorne verbunden",
        "en-GB": "Fwd starboard highloader connected",
        "en-US": "Fwd starboard highloader connected",
        "ja-JP": "前方右側ハイリフトローダー接続",
    },
    back_highloader_connected: {
        "de-DE": "Highloader hinten verbunden",
        "en-GB": "Aft starboard highloader connected",
        "en-US": "Aft starboard highloader connected",
        "ja-JP": "後方右側ハイリフトローダー接続",
    },
    front_highloader_disconnected: {
        "de-DE": "Highloader vorne getrennt",
        "en-GB": "Fwd starboard highloader disconnected",
        "en-US": "Fwd starboard highloader disconnected",
        "ja-JP": "前方右側ハイリフトローダー取り外し",
    },
    back_highloader_disconnected: {
        "de-DE": "Highloader hinten getrennt",
        "en-GB": "Aft starboard highloader disconnected",
        "en-US": "Aft starboard highloader disconnected",
        "ja-JP": "後方右側ハイリフトローダー取り外し",
    },
    front_highloader_entered_stand: {
        "de-DE": "Highloader vorne auf Standplatz",
        "en-GB": "Fwd starboard highloader entered stand",
        "en-US": "Fwd starboard highloader entered stand",
        "ja-JP": "Fwd starboard highloader entered stand",
    },
    back_highloader_entered_stand: {
        "de-DE": "Highloader hinten auf Standplatz",
        "en-GB": "Aft starboard highloader entered stand",
        "en-US": "Aft starboard highloader entered stand",
        "ja-JP": "Aft starboard highloader entered stand",
    },
    front_highloader_left_stand: {
        "de-DE": "Highloader vorne verlässt Standplatz",
        "en-GB": "Fwd starboard highloader left stand",
        "en-US": "Fwd starboard highloader left stand",
        "ja-JP": "Fwd starboard highloader left stand",
    },
    back_highloader_left_stand: {
        "de-DE": "Highloader hinten verlässt Standplatz",
        "en-GB": "Aft starboard highloader left stand",
        "en-US": "Aft starboard highloader left stand",
        "ja-JP": "Aft starboard highloader left stand",
    },
    belt_entered_stand: {
        "de-DE": "Förderband auf Standplatz",
        "en-GB": "Belt entered stand",
        "en-US": "Belt entered stand",
        "ja-JP": "Belt entered stand",
    },
    belt_left_stand: {
        "de-DE": "Förderband verlässt Standplatz",
        "en-GB": "Belt left stand",
        "en-US": "Belt left stand",
        "ja-JP": "Belt left stand",
    },
    front_belt_entered_stand: {
        "de-DE": "Förderband vorne auf Standplatz",
        "en-GB": "Fwd starboard belt entered stand",
        "en-US": "Fwd starboard belt entered stand",
        "ja-JP": "Fwd starboard belt entered stand",
    },
    front_belt_left_stand: {
        "de-DE": "Förderband vorne verlässt Standplatz",
        "en-GB": "Fwd starboard belt left stand",
        "en-US": "Fwd starboard belt left stand",
        "ja-JP": "Fwd starboard belt left stand",
    },
    back_belt_entered_stand: {
        "de-DE": "Förderband hinten auf Standplatz",
        "en-GB": "Aft starboard belt entered stand",
        "en-US": "Aft starboard belt entered stand",
        "ja-JP": "Aft starboard belt entered stand",
    },
    back_belt_left_stand: {
        "de-DE": "Förderband hinten verlässt Standplatz",
        "en-GB": "Aft starboard belt left stand",
        "en-US": "Aft starboard belt left stand",
        "ja-JP": "Aft starboard belt left stand",
    },
    highloader_entered_stand: {
        "de-DE": "Highloader auf Standplatz",
        "en-GB": "Highloader entered stand",
        "en-US": "Highloader entered stand",
        "ja-JP": "Highloader entered stand",
    },
    highloader_left_stand: {
        "de-DE": "Highloader verlässt Standplatz",
        "en-GB": "Highloader left stand",
        "en-US": "Highloader left stand",
        "ja-JP": "Highloader left stand",
    },
    door_open: {
        "de-DE": "Luftfahrzeugtür offen",
        "en-GB": "Door open",
        "en-US": "Door open",
        "ja-JP": "Door open",
    },
    door_closed: {
        "de-DE": "Luftfahrzeugtür geschlossen",
        "en-GB": "Door closed",
        "en-US": "Door closed",
        "ja-JP": "Door closed",
    },
    front_left_door_open: {
        "de-DE": "Servicetür vorne offen",
        "en-GB": "Fwd starboard aircraft door open",
        "en-US": "Fwd starboard aircraft door open",
        "ja-JP": "Fwd starboard aircraft door open",
    },
    front_left_door_closed: {
        "de-DE": "Servicetür vorne geschlossen",
        "en-GB": "Fwd starboard aircraft door closed",
        "en-US": "Fwd starboard aircraft door closed",
        "ja-JP": "Fwd starboard aircraft door closed",
    },
    middle_front_left_door_open: {
        "de-DE": "Servicetür mitte vorne offen",
        "en-GB": "Mid fwd starboard aircraft door open",
        "en-US": "Mid fwd starboard aircraft door open",
        "ja-JP": "Mid fwd starboard aircraft door open",
    },
    middle_front_left_door_closed: {
        "de-DE": "Servicetür mitte vorne geschlossen",
        "en-GB": "Mid fwd starboard aircraft door closed",
        "en-US": "Mid fwd starboard aircraft door closed",
        "ja-JP": "Mid fwd starboard aircraft door closed",
    },
    middle_back_left_door_open: {
        "de-DE": "Servicetür mitte hinten offen",
        "en-GB": "Mid aft starboard aircraft door open",
        "en-US": "Mid aft starboard aircraft door open",
        "ja-JP": "Mid aft starboard aircraft door open",
    },
    middle_back_left_door_closed: {
        "de-DE": "Servicetür mitte hinten geschlossen",
        "en-GB": "Mid aft starboard aircraft door closed",
        "en-US": "Mid aft starboard aircraft door closed",
        "ja-JP": "Mid aft starboard aircraft door closed",
    },
    back_left_door_open: {
        "de-DE": "Servicetür hinten offen",
        "en-GB": "Aft starboard aircraft door open",
        "en-US": "Aft starboard aircraft door open",
        "ja-JP": "Aft starboard aircraft door open",
    },
    back_left_door_closed: {
        "de-DE": "Servicetür hinten geschlossen",
        "en-GB": "Aft starboard aircraft door closed",
        "en-US": "Aft starboard aircraft door closed",
        "ja-JP": "Aft starboard aircraft door closed",
    },
    back_right_door_open: {
        "de-DE": "Passagiertür hinten offen",
        "en-GB": "Aft port aircraft door open",
        "en-US": "Aft port aircraft door open",
        "ja-JP": "Aft port aircraft door open",
    },
    back_right_door_closed: {
        "de-DE": "Passagiertür hinten geschlossen",
        "en-GB": "Aft port aircraft door closed",
        "en-US": "Aft port aircraft door closed",
        "ja-JP": "Aft port aircraft door closed",
    },
    front_right_door_open: {
        "de-DE": "Passagiertür vorne offen",
        "en-GB": "Fwd port aircraft door open",
        "en-US": "Fwd port aircraft door open",
        "ja-JP": "Fwd port aircraft door open",
    },
    front_right_door_closed: {
        "de-DE": "Passagiertür vorne geschlossen",
        "en-GB": "Fwd port aircraft door closed",
        "en-US": "Fwd port aircraft door closed",
        "ja-JP": "Fwd port aircraft door closed",
    },
    middle_front_right_door_open: {
        "de-DE": "Servicetür mitte vorne offen",
        "en-GB": "Mid fwd port aircraft door open",
        "en-US": "Mid fwd port aircraft door open",
        "ja-JP": "Mid fwd port aircraft door open",
    },
    middle_front_right_door_closed: {
        "de-DE": "Servicetür mitte vorne geschlossen",
        "en-GB": "Mid fwd port aircraft door closed",
        "en-US": "Mid fwd port aircraft door closed",
        "ja-JP": "Mid fwd port aircraft door closed",
    },
    middle_back_right_door_open: {
        "de-DE": "Servicetür mitte hinten offen",
        "en-GB": "Mid aft port aircraft door open",
        "en-US": "Mid aft port aircraft door open",
        "ja-JP": "Mid aft port aircraft door open",
    },
    middle_back_right_door_closed: {
        "de-DE": "Servicetür mitte hinten geschlossend",
        "en-GB": "Mid aft port aircraft door closed",
        "en-US": "Mid aft port aircraft door closed",
        "ja-JP": "Mid aft port aircraft door closed",
    },
    back_luggage_on_belt_loading_ended: {
        "de-DE": "Gepäckbeladung hinten beendet",
        "en-GB": "Aft starboard bag loading finished",
        "en-US": "Aft starboard bag loading finished",
        "ja-JP": "Aft starboard bag loading finished",
    },
    back_luggage_on_belt_loading_started: {
        "de-DE": "Gepäckbeladung hinten gestartet",
        "en-GB": "Aft starboard bag loading started",
        "en-US": "Aft starboard bag loading started",
        "ja-JP": "Aft starboard bag loading started",
    },
    back_luggage_on_belt_unloading_ended: {
        "de-DE": "Gepäckentladung hinten beendet",
        "en-GB": "Aft starboard bag unloading finished",
        "en-US": "Aft starboard bag unloading finished",
        "ja-JP": "Aft starboard bag unloading finished",
    },
    back_luggage_on_belt_unloading_started: {
        "de-DE": "Gepäckentladung hinten gestartet",
        "en-GB": "Aft starboard bag unloading started",
        "en-US": "Aft starboard bag unloading started",
        "ja-JP": "Aft starboard bag unloading started",
    },
    front_luggage_on_belt_unloading_ended: {
        "de-DE": "Gepäckentladung vorne beendet",
        "en-GB": "Fwd starboard bag unloading finished",
        "en-US": "Fwd starboard bag unloading finished",
        "ja-JP": "Fwd starboard bag unloading finished",
    },
    front_luggage_on_belt_unloading_started: {
        "de-DE": "Gepäckentladung vorne gestartet",
        "en-GB": "Fwd starboard bag unloading started",
        "en-US": "Fwd starboard bag unloading started",
        "ja-JP": "Fwd starboard bag unloading started",
    },
    front_luggage_on_belt_loading_ended: {
        "de-DE": "Gepäckbeladung vorne beendet",
        "en-GB": "Fwd starboard bag loading finished",
        "en-US": "Fwd starboard bag loading finished",
        "ja-JP": "Fwd starboard bag loading finished",
    },
    front_luggage_on_belt_loading_started: {
        "de-DE": "Gepäckbeladung vorne gestartet",
        "en-GB": "Fwd starboard bag loading started",
        "en-US": "Fwd starboard bag loading started",
        "ja-JP": "Fwd starboard bag loading started",
    },
    back_right_luggage_on_belt_loading_ended: {
        "de-DE": "Gepäckbeladung hinten beendet",
        "en-GB": "Aft port bags loading finished",
        "en-US": "Aft port bags loading finished",
        "ja-JP": "Aft port bags loading finished",
    },
    back_right_luggage_on_belt_loading_started: {
        "de-DE": "Gepäckbeladung hinten gestartet",
        "en-GB": "Aft port bags loading started",
        "en-US": "Aft port bags loading started",
        "ja-JP": "Aft port bags loading started",
    },
    back_right_luggage_on_belt_unloading_ended: {
        "de-DE": "Gepäckentladung hinten beendet",
        "en-GB": "Aft port bags unloading finished",
        "en-US": "Aft port bags unloading finished",
        "ja-JP": "Aft port bags unloading finished",
    },
    back_right_luggage_on_belt_unloading_started: {
        "de-DE": "Gepäckentladung hinten gestartet",
        "en-GB": "Aft port bags unloading started",
        "en-US": "Aft port bags unloading started",
        "ja-JP": "Aft port bags unloading started",
    },
    front_left_aircraft_door_open: {
        "de-DE": "Servicetür vorne offen",
        "en-GB": "Fwd starboard door 1 open",
        "en-US": "Fwd starboard door 1 open",
        "ja-JP": "Fwd starboard door 1 open",
    },
    front_left_aircraft_door_closed: {
        "de-DE": "Servicetür vorne geschlossen",
        "en-GB": "Fwd starboard door 1 closed",
        "en-US": "Fwd starboard door 1 closed",
        "ja-JP": "Fwd starboard door 1 closed",
    },
    front_right_aircraft_door_open: {
        "de-DE": "Passagiertür vorne offen",
        "en-GB": "Fwd port door 1 open",
        "en-US": "Fwd port door 1 open",
        "ja-JP": "Fwd port door 1 open",
    },
    front_right_aircraft_door_closed: {
        "de-DE": "Passagiertür vorne geschlossen",
        "en-GB": "Fwd port door 1 closed",
        "en-US": "Fwd port door 1 closed",
        "ja-JP": "Fwd port door 1 closed",
    },
    middle_front_left_aircraft_door_open: {
        "de-DE": "Servicetür mitte vorne offen",
        "en-GB": "Fwd starboard door 2 open",
        "en-US": "Fwd starboard door 2 open",
        "ja-JP": "Fwd starboard door 2 open",
    },
    middle_front_left_aircraft_door_closed: {
        "de-DE": "Servicetür mitte vorne geschlossen",
        "en-GB": "Fwd starboard door 2 closed",
        "en-US": "Fwd starboard door 2 closed",
        "ja-JP": "Fwd starboard door 2 closed",
    },
    back_left_aircraft_door_open: {
        "de-DE": "Servicetür hinten offen",
        "en-GB": "Aft starboard door 1 open",
        "en-US": "Aft starboard door 1 open",
        "ja-JP": "Aft starboard door 1 open",
    },
    back_left_aircraft_door_closed: {
        "de-DE": "Servicetür hinten geschlossen",
        "en-GB": "Aft starboard door 1 closed",
        "en-US": "Aft starboard door 1 closed",
        "ja-JP": "Aft starboard door 1 closed",
    },
    middle_back_left_aircraft_door_open: {
        "de-DE": "Servicetür mitte hinten offen",
        "en-GB": "Aft starboard door 2 open",
        "en-US": "Aft starboard door 2 open",
        "ja-JP": "Aft starboard door 2 open",
    },
    middle_back_left_aircraft_door_closed: {
        "de-DE": "Servicetür mitte hinten geschlossen",
        "en-GB": "Aft starboard door 2 closed",
        "en-US": "Aft starboard door 2 closed",
        "ja-JP": "Aft starboard door 2 closed",
    },
    back_right_aircraft_door_open: {
        "de-DE": "Passagiertür hinten offen",
        "en-GB": "Aft port door 1 open",
        "en-US": "Aft port door 1 open",
        "ja-JP": "Aft port door 1 open",
    },
    back_right_aircraft_door_closed: {
        "de-DE": "Passagiertür hinten geschlossen",
        "en-GB": "Aft port door 1 closed",
        "en-US": "Aft port door 1 closed",
        "ja-JP": "Aft port door 1 closed",
    },
    aircraft_ready_dummy: {
        "de-DE": "Luftfahrzeug bereit",
        "en-GB": "Aircraft ready",
        "en-US": "Aircraft ready",
        "ja-JP": "Aircraft ready",
    },
    lower_middle_back_right_aircraft_door_open: {
        "de-DE": "Servicetür mitte hinten offen",
        "en-GB": "Lower mid aft port aircraft door open",
        "en-US": "Lower mid aft port aircraft door open",
        "ja-JP": "Lower mid aft port aircraft door open",
    },
    lower_middle_back_right_aircraft_door_closed: {
        "de-DE": "Servicetür mitte hinten geschlossen",
        "en-GB": "Lower mid aft port aircraft door closed",
        "en-US": "Lower mid aft port aircraft door closed",
        "ja-JP": "Lower mid aft port aircraft door closed",
    },
    lower_middle_back_right_catering_truck_disconnected: {
        "de-DE": "Catering mitte hinten getrennt",
        "en-GB": "Lower mid aft port catering disconnected",
        "en-US": "Lower mid aft port catering disconnected",
        "ja-JP": "Lower mid aft port catering disconnected",
    },
    lower_middle_back_right_catering_truck_connected: {
        "de-DE": "Catering mitte hinten verbunden",
        "en-GB": "Lower mid aft port catering connected",
        "en-US": "Lower mid aft port catering connected",
        "ja-JP": "Lower mid aft port catering connected",
    },
    lower_middle_bridge_alt_disconnected: {
        "de-DE": "Fluggastbrücke mitte getrennt",
        "en-GB": "Lower mid bridge disconnected",
        "en-US": "Lower mid bridge disconnected",
        "ja-JP": "Lower mid bridge disconnected",
    },
    lower_middle_bridge_alt_connected: {
        "de-DE": "Fluggastbrücke mitte verbunden",
        "en-GB": "Lower mid bridge connected",
        "en-US": "Lower mid bridge connected",
        "ja-JP": "Lower mid bridge connected",
    },
    upper_middle_bridge_alt_disconnected: {
        "de-DE": "Upper mid bridge disconnected",
        "en-GB": "Upper mid bridge disconnected",
        "en-US": "Upper mid bridge disconnected",
        "ja-JP": "Upper mid bridge disconnected",
    },
    upper_middle_bridge_alt_connected: {
        "de-DE": "Upper mid bridge connected",
        "en-GB": "Upper mid bridge connected",
        "en-US": "Upper mid bridge connected",
        "ja-JP": "Upper mid bridge connected",
    },
    lower_middle_front_left_aircraft_door_open: {
        "de-DE": "Servicetür mitte vorne offen",
        "en-GB": "Lower mid fwd starboard aircraft door open",
        "en-US": "Lower mid fwd starboard aircraft door open",
        "ja-JP": "Lower mid fwd starboard aircraft door open",
    },
    lower_middle_front_left_aircraft_door_closed: {
        "de-DE": "Servicetür mitte vorne geschlossen",
        "en-GB": "Lower mid fwd starboard aircraft door closed",
        "en-US": "Lower mid fwd starboard aircraft door closed",
        "ja-JP": "Lower mid fwd starboard aircraft door closed",
    },
    lower_middle_back_left_aircraft_door_open: {
        "de-DE": "Servicetür mitte hinten offen",
        "en-GB": "Lower mid aft starboard aircraft door open",
        "en-US": "Lower mid aft starboard aircraft door open",
        "ja-JP": "Lower mid aft starboard aircraft door open",
    },
    lower_middle_back_left_aircraft_door_closed: {
        "de-DE": "Servicetür mitte hinten geschlossen",
        "en-GB": "Lower mid aft starboard aircraft door closed",
        "en-US": "Lower mid aft starboard aircraft door closed",
        "ja-JP": "Lower mid aft starboard aircraft door closed",
    },
    lower_middle_left_catering_truck_connected: {
        "de-DE": "Catering mitte verbunden",
        "en-GB": "Lower mid starboard catering connected",
        "en-US": "Lower mid starboard catering connected",
        "ja-JP": "Lower mid starboard catering connected",
    },
    lower_middle_left_catering_truck_disconnected: {
        "de-DE": "Catering mitte getrennt",
        "en-GB": "Lower mid starboard catering disconnected",
        "en-US": "Lower mid starboard catering disconnected",
        "ja-JP": "Lower mid starboard catering disconnected",
    },
    lower_middle_front_right_aircraft_door_open: {
        "de-DE": "Servicetür mitte vorne offen",
        "en-GB": "Lower mid fwd port aircraft door open",
        "en-US": "Lower mid fwd port aircraft door open",
        "ja-JP": "Lower mid fwd port aircraft door open",
    },
    lower_middle_front_right_aircraft_door_closed: {
        "de-DE": "Servicetür mitte vorne geschlossen",
        "en-GB": "Lower mid fwd port aircraft door closed",
        "en-US": "Lower mid fwd port aircraft door closed",
        "ja-JP": "Lower mid fwd port aircraft door closed",
    },
    lower_middle_back_left_catering_truck_connected: {
        "de-DE": "Catering mitte vorne verbunden",
        "en-GB": "Lower mid aft starboard catering connected",
        "en-US": "Lower mid aft starboard catering connected",
        "ja-JP": "Lower mid aft starboard catering connected",
    },
    lower_middle_back_left_catering_truck_disconnected: {
        "de-DE": "Catering mitte vorne getrennt",
        "en-GB": "Lower mid aft starboard catering disconnected",
        "en-US": "Lower mid aft starboard catering disconnected",
        "ja-JP": "Lower mid aft starboard catering disconnected",
    },
    middle_left_catering_truck_connected: {
        "de-DE": "Catering mitte verbunden",
        "en-GB": "Mid starboard catering connected",
        "en-US": "Mid starboard catering connected",
        "ja-JP": "中央右側ケータリング車接続",
    },
    middle_left_catering_truck_disconnected: {
        "de-DE": "Catering mitte getrennt",
        "en-GB": "Mid starboard catering disconnected",
        "en-US": "Mid starboard catering disconnected",
        "ja-JP": "中央右側ケータリング車取り外し",
    },
    middle_back_left_catering_truck_connected: {
        "de-DE": "Catering mitte hinten verbunden",
        "en-GB": "Mid aft starboard catering connected",
        "en-US": "Mid aft starboard catering connected",
        "ja-JP": "前方中央右側ケータリング車接続",
    },
    middle_back_left_catering_truck_disconnected: {
        "de-DE": "Catering mitte hinten Catering getrennt",
        "en-GB": "Mid aft starboard catering disconnected",
        "en-US": "Mid aft starboard catering disconnected",
        "ja-JP": "前方中央右側ケータリング車取り外し",
    },
    middle_front_right_aircraft_door_open: {
        "de-DE": "Servicetür mitte vorne offen",
        "en-GB": "Mid fwd port aircraft door open",
        "en-US": "Mid fwd port aircraft door open",
        "ja-JP": "Mid fwd port aircraft door open",
    },
    middle_front_right_aircraft_door_closed: {
        "de-DE": "Servicetür mitte vorne geschlossen",
        "en-GB": "Mid fwd port aircraft door closed",
        "en-US": "Mid fwd port aircraft door closed",
        "ja-JP": "Mid fwd port aircraft door closed",
    },
    back_container_loading_started: {
        "de-DE": "ULD-Beladung hinten gestartet",
        "en-GB": "Aft starboard ULD loading started",
        "en-US": "Aft starboard ULD loading started",
        "ja-JP": "Aft starboard ULD loading started",
    },
    back_container_loading_ended: {
        "de-DE": "ULD-Beladung hinten beendet",
        "en-GB": "Aft starboard ULD loading finished",
        "en-US": "Aft starboard ULD loading finished",
        "ja-JP": "Aft starboard ULD loading finished",
    },
    back_container_unloading_started: {
        "de-DE": "ULD-Entladung hinten gestartet",
        "en-GB": "Aft starboard ULD unloading started",
        "en-US": "Aft starboard ULD unloading started",
        "ja-JP": "Aft starboard ULD unloading started",
    },
    back_container_unloading_ended: {
        "de-DE": "ULD-Entladung hinten beendet",
        "en-GB": "Aft starboard ULD unloading finished",
        "en-US": "Aft starboard ULD unloading finished",
        "ja-JP": "Aft starboard ULD unloading finished",
    },
    front_container_loading_started: {
        "de-DE": "ULD-Beladung vorne gestartet",
        "en-GB": "Fwd starboard ULD loading started",
        "en-US": "Fwd starboard ULD loading started",
        "ja-JP": "Fwd starboard ULD loading started",
    },
    front_container_loading_ended: {
        "de-DE": "ULD-Beladung vorne beendet",
        "en-GB": "Fwd starboard ULD loading finished",
        "en-US": "Fwd starboard ULD loading finished",
        "ja-JP": "Fwd starboard ULD loading finished",
    },
    front_container_unloading_started: {
        "de-DE": "ULD-Entladung vorne gestartet",
        "en-GB": "Fwd starboard ULD unloading started",
        "en-US": "Fwd starboard ULD unloading started",
        "ja-JP": "Fwd starboard ULD unloading started",
    },
    front_container_unloading_ended: {
        "de-DE": "ULD-Entladung vorne beendet",
        "en-GB": "Fwd starboard ULD unloading finished",
        "en-US": "Fwd starboard ULD unloading finished",
        "ja-JP": "Fwd starboard ULD unloading finished",
    },
    lower_middle_back_right_aircraft_closed: {
        "de-DE": "Servicetür mitte hinten geschlossen",
        "en-GB": "Lower mid aft port aircraft door closed",
        "en-US": "Lower mid aft port aircraft door closed",
        "ja-JP": "Lower mid aft port aircraft door closed",
    },
    middle_back_left_catering_asc: {
        "de-DE": "Catering mitte hinten verbunden",
        "en-GB": "Mid aft startboard catering connected",
        "en-US": "Mid aft startboard catering connected",
        "ja-JP": "Mid aft startboard catering connected",
    },
    middle_back_left_catering_desc: {
        "de-DE": "Catering mitte hinten getrennt",
        "en-GB": "Mid aft startboard catering disconnected",
        "en-US": "Mid aft startboard catering disconnected",
        "ja-JP": "Mid aft startboard catering disconnected",
    },
    back_left_ambulift_connected: {
        "de-DE": "Ambulift hinten verbunden",
        "en-GB": "Aft starboard ambulift connected",
        "en-US": "Aft starboard ambulift connected",
        "ja-JP": "Aft starboard ambulift connected",
    },
    back_left_ambulift_disconnected: {
        "de-DE": "Ambulift hinten getrennt",
        "en-GB": "Aft starboard ambulift disconnected",
        "en-US": "Aft starboard ambulift disconnected",
        "ja-JP": "Aft starboard ambulift disconnected",
    },
    ambulift_connected: {
        "de-DE": "Ambulift verbunden",
        "en-GB": "Ambulift connected",
        "en-US": "Ambulift connected",
        "ja-JP": "Ambulift connected",
    },
    ambulift_disconnected: {
        "de-DE": "Ambulift getrennt",
        "en-GB": "Ambulift disconnected",
        "en-US": "Ambulift disconnected",
        "ja-JP": "Ambulift disconnected",
    },
    front_ambulift_connected: {
        "de-DE": "Ambulift vorne verbunden",
        "en-GB": "Fwd starboard ambulift connected",
        "en-US": "Fwd starboard ambulift connected",
        "ja-JP": "Fwd starboard ambulift connected",
    },
    front_ambulift_disconnected: {
        "de-DE": "Ambulift vorne getrennt",
        "en-GB": "Fwd starboard ambulift disconnected",
        "en-US": "Fwd starboard ambulift disconnected",
        "ja-JP": "Fwd starboard ambulift disconnected",
    },
    back_ambulift_connected: {
        "de-DE": "Ambulift hinten verbunden",
        "en-GB": "Aft starboard ambulift connected",
        "en-US": "Aft starboard ambulift connected",
        "ja-JP": "Aft starboard ambulift connected",
    },
    back_ambulift_disconnected: {
        "de-DE": "Ambulift hinten getrennt",
        "en-GB": "Aft starboard ambulift disconnected",
        "en-US": "Aft starboard ambulift disconnected",
        "ja-JP": "Aft starboard ambulift disconnected",
    },
    back_right_ambulift_connected: {
        "de-DE": "Ambulift hinten verbunden",
        "en-GB": "Aft port ambulift connected",
        "en-US": "Aft port ambulift connected",
        "ja-JP": "Aft port ambulift connected",
    },
    back_right_ambulift_disconnected: {
        "de-DE": "Ambulift hinten getrennt",
        "en-GB": "Aft port ambulift disconnected",
        "en-US": "Aft port ambulift disconnected",
        "ja-JP": "Aft port ambulift disconnected",
    },
    front_ambulift_entered_stand: {
        "de-DE": "Ambulift vorne auf Standplatz",
        "en-GB": "Fwd starboard ambulift entered stand",
        "en-US": "Fwd starboard ambulift entered stand",
        "ja-JP": "Fwd starboard ambulift entered stand",
    },
    front_ambulift_left_stand: {
        "de-DE": "Ambulift vorne verlässt Standplatz",
        "en-GB": "Fwd starboard ambulift left stand",
        "en-US": "Fwd starboard ambulift left stand",
        "ja-JP": "Fwd starboard ambulift left stand",
    },
    bridge_entered_parking: {
        "de-DE": "Bridge entered parking",
        "en-GB": "Bridge entered parking",
        "en-US": "Bridge entered parking",
        "ja-JP": "Bridge entered parking",
    },
    bridge_left_parking: {
        "de-DE": "Bridge left parking",
        "en-GB": "Bridge left parking",
        "en-US": "Bridge left parking",
        "ja-JP": "Bridge left parking",
    },
    cone_placed: {
        "de-DE": "Cone placed",
        "en-GB": "Cone placed",
        "en-US": "Cone placed",
        "ja-JP": "Cone placed",
    },
    cone_removed: {
        "de-DE": "Cone removed",
        "en-GB": "Cone removed",
        "en-US": "Cone removed",
        "ja-JP": "Cone removed",
    },
    cleaners_connected: {
        "de-DE": "Cleaners connected",
        "en-GB": "Cleaners connected",
        "en-US": "Cleaners connected",
        "ja-JP": "Cleaners connected",
    },
    cleaners_disconnected: {
        "de-DE": "Cleaners disconnected",
        "en-GB": "Cleaners disconnected",
        "en-US": "Cleaners disconnected",
        "ja-JP": "Cleaners disconnected",
    },
    cleaners_entered_stand: {
        "de-DE": "Cleaners entered stand",
        "en-GB": "Cleaners entered stand",
        "en-US": "Cleaners entered stand",
        "ja-JP": "Cleaners entered stand",
    },
    cleaners_left_stand: {
        "de-DE": "Cleaners left stand",
        "en-GB": "Cleaners left stand",
        "en-US": "Cleaners left stand",
        "ja-JP": "Cleaners left stand",
    },
    back_left_cleaners_connected: {
        "de-DE": "Aft starboard cleaners connected",
        "en-GB": "Aft starboard cleaners connected",
        "en-US": "Aft starboard cleaners connected",
        "ja-JP": "Aft starboard cleaners connected",
    },
    back_left_cleaners_disconnected: {
        "de-DE": "Aft starboard cleaners disconnected",
        "en-GB": "Aft starboard cleaners disconnected",
        "en-US": "Aft starboard cleaners disconnected",
        "ja-JP": "Aft starboard cleaners disconnected",
    },
    back_left_cleaners_entered_stand: {
        "de-DE": "Aft starboard cleaners entered stand",
        "en-GB": "Aft starboard cleaners entered stand",
        "en-US": "Aft starboard cleaners entered stand",
        "ja-JP": "Aft starboard cleaners entered stand",
    },
    back_left_cleaners_left_stand: {
        "de-DE": "Aft starboard cleaners left stand",
        "en-GB": "Aft starboard cleaners left stand",
        "en-US": "Aft starboard cleaners left stand",
        "ja-JP": "Aft starboard cleaners left stand",
    },
    back_right_cleaners_connected: {
        "de-DE": "Aft port cleaners connected",
        "en-GB": "Aft port cleaners connected",
        "en-US": "Aft port cleaners connected",
        "ja-JP": "Aft port cleaners connected",
    },
    back_right_cleaners_disconnected: {
        "de-DE": "Aft port cleaners disconnected",
        "en-GB": "Aft port cleaners disconnected",
        "en-US": "Aft port cleaners disconnected",
        "ja-JP": "Aft port cleaners disconnected",
    },
    back_right_cleaners_entered_stand: {
        "de-DE": "Aft port cleaners entered stand",
        "en-GB": "Aft port cleaners entered stand",
        "en-US": "Aft port cleaners entered stand",
        "ja-JP": "Aft port cleaners entered stand",
    },
    back_right_cleaners_left_stand: {
        "de-DE": "Aft port cleaners left stand",
        "en-GB": "Aft port cleaners left stand",
        "en-US": "Aft port cleaners left stand",
        "ja-JP": "Aft port cleaners left stand",
    },
    acu_connected: {
        "de-DE": "PC Air Hose connected",
        "en-GB": "PC Air Hose connected",
        "en-US": "PC Air Hose connected",
        "ja-JP": "PC Air Hose connected",
    },
    acu_disconnected: {
        "de-DE": "PC Air Hose disconnected",
        "en-GB": "PC Air Hose disconnected",
        "en-US": "PC Air Hose disconnected",
        "ja-JP": "PC Air Hose disconnected",
    },
    acu_inflated: {
        "de-DE": "PC Air Hose inflated",
        "en-GB": "PC Air Hose inflated",
        "en-US": "PC Air Hose inflated",
        "ja-JP": "PC Air Hose inflated",
    },
    acu_deflated: {
        "de-DE": "PC Air Hose deflated",
        "en-GB": "PC Air Hose deflated",
        "en-US": "PC Air Hose deflated",
        "ja-JP": "PC Air Hose deflated",
    },
    cleaning_entered_stand: {
        "de-DE": "Cleaning entered stand",
        "en-GB": "Cleaning entered stand",
        "en-US": "Cleaning entered stand",
        "ja-JP": "Cleaning entered stand",
    },
    cleaning_left_stand: {
        "de-DE": "Cleaning left stand",
        "en-GB": "Cleaning left stand",
        "en-US": "Cleaning left stand",
        "ja-JP": "Cleaning left stand",
    },
    maintenance_entered_stand: {
        "de-DE": "Maintenance entered stand",
        "en-GB": "Maintenance entered stand",
        "en-US": "Maintenance entered stand",
        "ja-JP": "Maintenance entered stand",
    },
    maintenance_left_stand: {
        "de-DE": "Maintenance left stand",
        "en-GB": "Maintenance left stand",
        "en-US": "Maintenance left stand",
        "ja-JP": "Maintenance left stand",
    },
    sewage_entered_position: {
        "de-DE": "Sewage entered stand",
        "en-GB": "Sewage entered stand",
        "en-US": "Sewage entered stand",
        "ja-JP": "Sewage entered stand",
    },
    sewage_left_position: {
        "de-DE": "Sewage left stand",
        "en-GB": "Sewage left stand",
        "en-US": "Sewage left stand",
        "ja-JP": "Sewage left stand",
    },
    chocks_on: {
        "de-DE": "Nose chocks on",
        "en-GB": "Nose chocks on",
        "en-US": "Nose chocks on",
        "ja-JP": "Nose chocks on",
    },
    chocks_off: {
        "de-DE": "Nose chocks off",
        "en-GB": "Nose chocks off",
        "en-US": "Nose chocks off",
        "ja-JP": "Nose chocks off",
    },
    tail_stand_on: {
        "de-DE": "Tailstand on",
        "en-GB": "Tailstand on",
        "en-US": "Tailstand on",
        "ja-JP": "Tailstand on",
    },
    tail_stand_off: {
        "de-DE": "Tailstand off",
        "en-GB": "Tailstand off",
        "en-US": "Tailstand off",
        "ja-JP": "Tailstand off",
    },
    freshwater_connected: {
        "de-DE": "Freshwater connected",
        "en-GB": "Freshwater connected",
        "en-US": "Freshwater connected",
        "ja-JP": "Freshwater connected",
    },
    sewage_connected: {
        "de-DE": "Water connected",
        "en-GB": "Water connected",
        "en-US": "Water connected",
        "ja-JP": "Water connected",
    },
    freshwater_disconnected: {
        "de-DE": "Freshwater disconnected",
        "en-GB": "Freshwater disconnected",
        "en-US": "Freshwater disconnected",
        "ja-JP": "Freshwater disconnected",
    },
    sewage_disconnected: {
        "de-DE": "Water disconnected",
        "en-GB": "Water disconnected",
        "en-US": "Water disconnected",
        "ja-JP": "Water disconnected",
    },
    pax_door_open: {
        "de-DE": "Passenger door open",
        "en-GB": "Passenger door open",
        "en-US": "Passenger door open",
        "ja-JP": "Passenger door open",
    },
    pax_door_closed: {
        "de-DE": "Passenger door closed",
        "en-GB": "Passenger door closed",
        "en-US": "Passenger door closed",
        "ja-JP": "Passenger door closed",
    },
    pass_onboarding_started: {
        "de-DE": "Passenger onboarding started",
        "en-GB": "Passenger onboarding started",
        "en-US": "Passenger onboarding started",
        "ja-JP": "Passenger onboarding started",
    },
    pass_onboarding_ended: {
        "de-DE": "Passenger onboarding finished",
        "en-GB": "Passenger onboarding finished",
        "en-US": "Passenger onboarding finished",
        "ja-JP": "Passenger onboarding finished",
    },
    pass_offboarding_started: {
        "de-DE": "Passenger offboarding started",
        "en-GB": "Passenger offboarding started",
        "en-US": "Passenger offboarding started",
        "ja-JP": "Passenger offboarding started",
    },
    pass_offboarding_ended: {
        "de-DE": "Passenger offboarding finished",
        "en-GB": "Passenger offboarding finished",
        "en-US": "Passenger offboarding finished",
        "ja-JP": "Passenger offboarding finished",
    },
    first_pass_in: {
        "de-DE": "Passenger onboarding started",
        "en-GB": "Passenger onboarding started",
        "en-US": "Passenger onboarding started",
        "ja-JP": "Passenger onboarding started",
    },
    last_pass_in: {
        "de-DE": "Passenger onboarding finished",
        "en-GB": "Passenger onboarding finished",
        "en-US": "Passenger onboarding finished",
        "ja-JP": "Passenger onboarding finished",
    },
    first_pass_out: {
        "de-DE": "Passenger disembarkation started",
        "en-GB": "Passenger disembarkation started",
        "en-US": "Passenger disembarkation started",
        "ja-JP": "Passenger disembarkation started",
    },
    last_pass_out: {
        "de-DE": "Passenger disembarkation finished",
        "en-GB": "Passenger disembarkation finished",
        "en-US": "Passenger disembarkation finished",
        "ja-JP": "Passenger disembarkation finished",
    },
    small_passenger_ramp_entered_stand: {
        "de-DE": "Passenger ramp entered stand",
        "en-GB": "Passenger ramp entered stand",
        "en-US": "Passenger ramp entered stand",
        "ja-JP": "Passenger ramp entered stand",
    },
    small_passenger_ramp_left_stand: {
        "de-DE": "Passenger ramp left stand",
        "en-GB": "Passenger ramp left stand",
        "en-US": "Passenger ramp left stand",
        "ja-JP": "Passenger ramp left stand",
    },
    passenger_ramp_entered_stand: {
        "de-DE": "Passenger ramp entered stand",
        "en-GB": "Passenger ramp entered stand",
        "en-US": "Passenger ramp entered stand",
        "ja-JP": "Passenger ramp entered stand",
    },
    passenger_ramp_left_stand: {
        "de-DE": "Passenger ramp left stand",
        "en-GB": "Passenger ramp left stand",
        "en-US": "Passenger ramp left stand",
        "ja-JP": "Passenger ramp left stand",
    },
    stand_clear: {
        "de-DE": "Stand not clear end",
        "en-GB": "Stand not clear end",
        "en-US": "Stand not clear end",
        "ja-JP": "Stand not clear end",
    },
    stand_not_clear: {
        "de-DE": "Stand not clear",
        "en-GB": "Stand not clear",
        "en-US": "Stand not clear",
        "ja-JP": "Stand not clear",
    },
    aircraft_wait_for_park_started: {
        "de-DE": "Aircraft wait for park started",
        "en-GB": "Aircraft wait for park started",
        "en-US": "Aircraft wait for park started",
        "ja-JP": "Aircraft wait for park started",
    },
    aircraft_wait_for_park_ended: {
        "de-DE": "Aircraft wait for park ended",
        "en-GB": "Aircraft wait for park ended",
        "en-US": "Aircraft wait for park ended",
        "ja-JP": "Aircraft wait for park ended",
    },
    cleaning_team_onboarding_via_airstairs_started: {
        "de-DE": "Cleaning team started boarding via airstairs",
        "en-GB": "Cleaning team started boarding via airstairs",
        "en-US": "Cleaning team started boarding via airstairs",
        "ja-JP": "Cleaning team started boarding via airstairs",
    },
    cleaning_team_onboarding_via_airstairs_ended: {
        "de-DE": "Cleaning team finished boarding via airstairs",
        "en-GB": "Cleaning team finished boarding via airstairs",
        "en-US": "Cleaning team finished boarding via airstairs",
        "ja-JP": "Cleaning team finished boarding via airstairs",
    },
    cleaning_team_disembarkation_via_airstairs_started: {
        "de-DE": "Cleaning team started disembarkation via airstairs",
        "en-GB": "Cleaning team started disembarkation via airstairs",
        "en-US": "Cleaning team started disembarkation via airstairs",
        "ja-JP": "Cleaning team started disembarkation via airstairs",
    },
    cleaning_team_disembarkation_via_airstairs_ended: {
        "de-DE": "Cleaning team finished disembarkation via airstairs",
        "en-GB": "Cleaning team finished disembarkation via airstairs",
        "en-US": "Cleaning team finished disembarkation via airstairs",
        "ja-JP": "Cleaning team finished disembarkation via airstairs",
    },
    cleaning_team_onboarding_started: {
        "de-DE": "Cleaning team started boarding via jetbridge",
        "en-GB": "Cleaning team started boarding via jetbridge",
        "en-US": "Cleaning team started boarding via jetbridge",
        "ja-JP": "Cleaning team started boarding via jetbridge",
    },
    cleaning_team_onboarding_ended: {
        "de-DE": "Cleaning team finished boarding via jetbridge",
        "en-GB": "Cleaning team finished boarding via jetbridge",
        "en-US": "Cleaning team finished boarding via jetbridge",
        "ja-JP": "Cleaning team finished boarding via jetbridge",
    },
    cleaning_team_offboarding_started: {
        "de-DE": "Cleaning team started disembarkation via jetbridge",
        "en-GB": "Cleaning team started disembarkation via jetbridge",
        "en-US": "Cleaning team started disembarkation via jetbridge",
        "ja-JP": "Cleaning team started disembarkation via jetbridge",
    },
    cleaning_team_offboarding_ended: {
        "de-DE": "Cleaning team finished disembarkation via jetbridge",
        "en-GB": "Cleaning team finished disembarkation via jetbridge",
        "en-US": "Cleaning team finished disembarkation via jetbridge",
        "ja-JP": "Cleaning team finished disembarkation via jetbridge",
    },
    cockpit_crew_onboarding_started: {
        "de-DE": "Cockpit crew started onboarding",
        "en-GB": "Cockpit crew started onboarding",
        "en-US": "Cockpit crew started onboarding",
        "ja-JP": "Cockpit crew started onboarding",
    },
    cockpit_crew_onboarding_ended: {
        "de-DE": "Cockpit crew finished onboarding",
        "en-GB": "Cockpit crew finished onboarding",
        "en-US": "Cockpit crew finished onboarding",
        "ja-JP": "Cockpit crew finished onboarding",
    },
    cockpit_crew_offboarding_started: {
        "de-DE": "Cockpit crew started disembarkation",
        "en-GB": "Cockpit crew started disembarkation",
        "en-US": "Cockpit crew started disembarkation",
        "ja-JP": "Cockpit crew started disembarkation",
    },
    cockpit_crew_offboarding_ended: {
        "de-DE": "Cockpit crew finished disembarkation",
        "en-GB": "Cockpit crew finished disembarkation",
        "en-US": "Cockpit crew finished disembarkation",
        "ja-JP": "Cockpit crew finished disembarkation",
    },
    cabin_crew_onboarding_started: {
        "de-DE": "Cabin crew started onboarding",
        "en-GB": "Cabin crew started onboarding",
        "en-US": "Cabin crew started onboarding",
        "ja-JP": "Cabin crew started onboarding",
    },
    cabin_crew_onboarding_ended: {
        "de-DE": "Cabin crew finished onboarding",
        "en-GB": "Cabin crew finished onboarding",
        "en-US": "Cabin crew finished onboarding",
        "ja-JP": "Cabin crew finished onboarding",
    },
    cabin_crew_offboarding_started: {
        "de-DE": "Cabin crew started disembarkation",
        "en-GB": "Cabin crew started disembarkation",
        "en-US": "Cabin crew started disembarkation",
        "ja-JP": "Cabin crew started disembarkation",
    },
    cabin_crew_offboarding_ended: {
        "de-DE": "Cabin crew finished disembarkation",
        "en-GB": "Cabin crew finished disembarkation",
        "en-US": "Cabin crew finished disembarkation",
        "ja-JP": "Cabin crew finished disembarkation",
    },
    acu_hose_deployed: {
        "de-DE": "PC Air Hose deployed",
        "en-GB": "PC Air Hose deployed",
        "en-US": "PC Air Hose deployed",
        "ja-JP": "PC Air Hose deployed",
    },
    acu_hose_retracted: {
        "de-DE": "PC Air Hose retracted",
        "en-GB": "PC Air Hose retracted",
        "en-US": "PC Air Hose retracted",
        "ja-JP": "PC Air Hose retracted",
    },
    back_left_catering_guard_rail_deployed: {
        "de-DE": "Aft starboard catering handrail deployed",
        "en-GB": "Aft starboard catering handrail deployed",
        "en-US": "Aft starboard catering handrail deployed",
        "ja-JP": "Aft starboard catering handrail deployed",
    },
    one_back_left_catering_guard_rail_deployed: {
        "de-DE": "Aft starboard catering handrail deployed",
        "en-GB": "Aft starboard catering handrail deployed",
        "en-US": "Aft starboard catering handrail deployed",
        "ja-JP": "Aft starboard catering handrail deployed",
    },
    back_left_catering_guard_rail_removed: {
        "de-DE": "Aft starboard catering handrail removed",
        "en-GB": "Aft starboard catering handrail removed",
        "en-US": "Aft starboard catering handrail removed",
        "ja-JP": "Aft starboard catering handrail removed",
    },
    one_back_left_catering_guard_rail_removed: {
        "de-DE": "Aft starboard catering handrail removed",
        "en-GB": "Aft starboard catering handrail removed",
        "en-US": "Aft starboard catering handrail removed",
        "ja-JP": "Aft starboard catering handrail removed",
    },
    back_right_catering_guard_rail_deployed: {
        "de-DE": "Aft port catering handrail deployed",
        "en-GB": "Aft port catering handrail deployed",
        "en-US": "Aft port catering handrail deployed",
        "ja-JP": "Aft port catering handrail deployed",
    },
    one_back_right_catering_guard_rail_deployed: {
        "de-DE": "Aft port catering handrail deployed",
        "en-GB": "Aft port catering handrail deployed",
        "en-US": "Aft port catering handrail deployed",
        "ja-JP": "Aft port catering handrail deployed",
    },
    back_right_catering_guard_rail_removed: {
        "de-DE": "Aft port catering handrail removed",
        "en-GB": "Aft port catering handrail removed",
        "en-US": "Aft port catering handrail removed",
        "ja-JP": "Aft port catering handrail removed",
    },
    one_back_right_catering_guard_rail_removed: {
        "de-DE": "Aft port catering handrail removed",
        "en-GB": "Aft port catering handrail removed",
        "en-US": "Aft port catering handrail removed",
        "ja-JP": "Aft port catering handrail removed",
    },
    front_catering_guard_rail_deployed: {
        "de-DE": "Fwd starboard catering handrail deployed",
        "en-GB": "Fwd starboard catering handrail deployed",
        "en-US": "Fwd starboard catering handrail deployed",
        "ja-JP": "Fwd starboard catering handrail deployed",
    },
    one_front_catering_guard_rail_deployed: {
        "de-DE": "Fwd starboard catering handrail deployed",
        "en-GB": "Fwd starboard catering handrail deployed",
        "en-US": "Fwd starboard catering handrail deployed",
        "ja-JP": "Fwd starboard catering handrail deployed",
    },
    front_catering_guard_rail_removed: {
        "de-DE": "Fwd starboard catering handrail removed",
        "en-GB": "Fwd starboard catering handrail removed",
        "en-US": "Fwd starboard catering handrail removed",
        "ja-JP": "Fwd starboard catering handrail removed",
    },
    one_front_catering_guard_rail_removed: {
        "de-DE": "Fwd starboard catering handrail removed",
        "en-GB": "Fwd starboard catering handrail removed",
        "en-US": "Fwd starboard catering handrail removed",
        "ja-JP": "Fwd starboard catering handrail removed",
    },
    human_without_vest_started: {
        "de-DE": "Human without vest started",
        "en-GB": "Human without vest started",
        "en-US": "Human without vest started",
        "ja-JP": "Human without vest started",
    },
    human_without_vest_ended: {
        "de-DE": "Human without vest ended",
        "en-GB": "Human without vest ended",
        "en-US": "Human without vest ended",
        "ja-JP": "Human without vest ended",
    },
    human_entered_eiz2: {
        "de-DE": "Engine ingestion zone violated",
        "en-GB": "Engine ingestion zone violated",
        "en-US": "Engine ingestion zone violated",
        "ja-JP": "Engine ingestion zone violated",
    },
    human_left_eiz2: {
        "de-DE": "Engine ingestion zone violated",
        "en-GB": "Engine ingestion zone violated",
        "en-US": "Engine ingestion zone violated",
        "ja-JP": "Engine ingestion zone violated",
    },
    back_right_truck_entered_position: {
        "de-DE": "Aft port water/lav truck entered position",
        "en-GB": "Aft port water/lav truck entered position",
        "en-US": "Aft port water/lav truck entered position",
        "ja-JP": "Aft port water/lav truck entered position",
    },
    back_right_truck_left_position: {
        "de-DE": "Aft port water/lav truck left position",
        "en-GB": "Aft port water/lav truck left position",
        "en-US": "Aft port water/lav truck left position",
        "ja-JP": "Aft port water/lav truck left position",
    },
    back_left_truck_entered_position: {
        "de-DE": "Aft starboard water/lav truck entered position",
        "en-GB": "Aft starboard water/lav truck entered position",
        "en-US": "Aft starboard water/lav truck entered position",
        "ja-JP": "Aft starboard water/lav truck entered position",
    },
    back_left_truck_left_position: {
        "de-DE": "Aft starboard water/lav truck left position",
        "en-GB": "Aft starboard water/lav truck left position",
        "en-US": "Aft starboard water/lav truck left position",
        "ja-JP": "Aft starboard water/lav truck left position",
    },
    front_right_truck_entered_position: {
        "de-DE": "Fwd port water/lav truck entered position",
        "en-GB": "Fwd port water/lav truck entered position",
        "en-US": "Fwd port water/lav truck entered position",
        "ja-JP": "Fwd port water/lav truck entered position",
    },
    front_right_truck_left_position: {
        "de-DE": "Fwd port water/lav truck left position",
        "en-GB": "Fwd port water/lav truck left position",
        "en-US": "Fwd port water/lav truck left position",
        "ja-JP": "Fwd port water/lav truck left position",
    },
    front_left_truck_entered_position: {
        "de-DE": "Fwd starboard water/lav truck entered position",
        "en-GB": "Fwd starboard water/lav truck entered position",
        "en-US": "Fwd starboard water/lav truck entered position",
        "ja-JP": "Fwd starboard water/lav truck entered position",
    },
    front_left_truck_left_position: {
        "de-DE": "Fwd starboard water/lav truck left position",
        "en-GB": "Fwd starboard water/lav truck left position",
        "en-US": "Fwd starboard water/lav truck left position",
        "ja-JP": "Fwd starboard water/lav truck left position",
    },
    water_truck_entered_position: {
        "de-DE": "Water/lav truck entered position",
        "en-GB": "Water/lav truck entered position",
        "en-US": "Water/lav truck entered position",
        "ja-JP": "Water/lav truck entered position",
    },
    water_truck_left_position: {
        "de-DE": "Water/lav truck left position",
        "en-GB": "Water/lav truck left position",
        "en-US": "Water/lav truck left position",
        "ja-JP": "Water/lav truck left position",
    },
    boarding_into_gate_area_started: {
        "de-DE": "Boarding into gate area started",
        "en-GB": "Boarding into gate area started",
        "en-US": "Boarding into gate area started",
        "ja-JP": "Boarding into gate area started",
    },
    boarding_into_gate_area_finished: {
        "de-DE": "Boarding into gate area finished",
        "en-GB": "Boarding into gate area finished",
        "en-US": "Boarding into gate area finished",
        "ja-JP": "Boarding into gate area finished",
    },
    gate_door_open: {
        "de-DE": "Gate door open",
        "en-GB": "Gate door open",
        "en-US": "Gate door open",
        "ja-JP": "Gate door open",
    },
    gate_door_closed: {
        "de-DE": "Gate door closed",
        "en-GB": "Gate door closed",
        "en-US": "Gate door closed",
        "ja-JP": "Gate door closed",
    },
    gate_open: {
        "de-DE": "Gate open",
        "en-GB": "Gate open",
        "en-US": "Gate open",
        "ja-JP": "Gate open",
    },
    gate_closed: {
        "de-DE": "Gate closed",
        "en-GB": "Gate closed",
        "en-US": "Gate closed",
        "ja-JP": "Gate closed",
    },
    fod_walk_started: {
        "de-DE": "FOD walk started",
        "en-GB": "FOD walk started",
        "en-US": "FOD walk started",
        "ja-JP": "FOD walk started",
    },
    fod_walk_finished: {
        "de-DE": "FOD walk finished",
        "en-GB": "FOD walk finished",
        "en-US": "FOD walk finished",
        "ja-JP": "FOD walk finished",
    },
    prm_staff_present: {
        "de-DE": "PRM staff present",
        "en-GB": "PRM staff present",
        "en-US": "PRM staff present",
        "ja-JP": "PRM staff present",
    },
    prm_staff_left: {
        "de-DE": "PRM staff left",
        "en-GB": "PRM staff left",
        "en-US": "PRM staff left",
        "ja-JP": "PRM staff left",
    },
    vacuum_onboarding_started: {
        "de-DE": "Vacuum onboarding started",
        "en-GB": "Vacuum onboarding started",
        "en-US": "Vacuum onboarding started",
        "ja-JP": "Vacuum onboarding started",
    },
    vacuum_onboarding_ended: {
        "de-DE": "Vacuum onboarding finished",
        "en-GB": "Vacuum onboarding finished",
        "en-US": "Vacuum onboarding finished",
        "ja-JP": "Vacuum onboarding finished",
    },
    vacuum_offboarding_started: {
        "de-DE": "Vacuum offboarding started",
        "en-GB": "Vacuum offboarding started",
        "en-US": "Vacuum offboarding started",
        "ja-JP": "Vacuum offboarding started",
    },
    vacuum_offboarding_ended: {
        "de-DE": "Vacuum offboarding finished",
        "en-GB": "Vacuum offboarding finished",
        "en-US": "Vacuum offboarding finished",
        "ja-JP": "Vacuum offboarding finished",
    },
    boarding_agent_present_at_gate: {
        "de-DE": "Boarding agent present at gate",
        "en-GB": "Boarding agent present at gate",
        "en-US": "Boarding agent present at gate",
        "ja-JP": "Boarding agent present at gate",
    },
    boarding_agent_left_gate: {
        "de-DE": "Boarding agent left gate",
        "en-GB": "Boarding agent left gate",
        "en-US": "Boarding agent left gate",
        "ja-JP": "Boarding agent left gate",
    },
    apu_on: {
        "de-DE": "APU on",
        "en-GB": "APU on",
        "en-US": "APU on",
        "ja-JP": "APU on",
    },
    apu_off: {
        "de-DE": "APU off",
        "en-GB": "APU off",
        "en-US": "APU off",
        "ja-JP": "APU off",
    },
    engine_on: {
        "de-DE": "Engine on",
        "en-GB": "Engine on",
        "en-US": "Engine on",
        "ja-JP": "Engine on",
    },
    engine_off: {
        "de-DE": "Engine off",
        "en-GB": "Engine off",
        "en-US": "Engine off",
        "ja-JP": "Engine off",
    },
    left_wingwalker_started: {
        "de-DE": "Starboard wingwalker started",
        "en-GB": "Starboard wingwalker started",
        "en-US": "Starboard wingwalker started",
        "ja-JP": "Starboard wingwalker started",
    },
    left_wingwalker_ended: {
        "de-DE": "Starboard wingwalker ended",
        "en-GB": "Starboard wingwalker ended",
        "en-US": "Starboard wingwalker ended",
        "ja-JP": "Starboard wingwalker ended",
    },
    right_wingwalker_started: {
        "de-DE": "Port wingwalker started",
        "en-GB": "Port wingwalker started",
        "en-US": "Port wingwalker started",
        "ja-JP": "Port wingwalker started",
    },
    right_wingwalker_ended: {
        "de-DE": "Port wingwalker ended",
        "en-GB": "Port wingwalker ended",
        "en-US": "Port wingwalker ended",
        "ja-JP": "Port wingwalker ended",
    },
    left_engine_cone_placed: {
        "de-DE": "Starboard engine cone placed",
        "en-GB": "Starboard engine cone placed",
        "en-US": "Starboard engine cone placed",
        "ja-JP": "Starboard engine cone placed",
    },
    left_engine_cone_removed: {
        "de-DE": "Starboard engine cone removed",
        "en-GB": "Starboard engine cone removed",
        "en-US": "Starboard engine cone removed",
        "ja-JP": "Starboard engine cone removed",
    },
    right_engine_cone_placed: {
        "de-DE": "Port engine cone placed",
        "en-GB": "Port engine cone placed",
        "en-US": "Port engine cone placed",
        "ja-JP": "Port engine cone placed",
    },
    right_engine_cone_removed: {
        "de-DE": "Port engine cone removed",
        "en-GB": "Port engine cone removed",
        "en-US": "Port engine cone removed",
        "ja-JP": "Port engine cone removed",
    },
    second_right_engine_cone_placed: {
        "de-DE": "Port engine cone #2 placed",
        "en-GB": "Port engine cone #2 placed",
        "en-US": "Port engine cone #2 placed",
        "ja-JP": "Port engine cone #2 placed",
    },
    second_right_engine_cone_removed: {
        "de-DE": "Port engine cone #2 removed",
        "en-GB": "Port engine cone #2 removed",
        "en-US": "Port engine cone #2 removed",
        "ja-JP": "Port engine cone #2 removed",
    },
    second_left_engine_cone_placed: {
        "de-DE": "Starboard engine cone #2 placed",
        "en-GB": "Starboard engine cone #2 placed",
        "en-US": "Starboard engine cone #2 placed",
        "ja-JP": "Starboard engine cone #2 placed",
    },
    second_left_engine_cone_removed: {
        "de-DE": "Starboard engine cone #2 removed",
        "en-GB": "Starboard engine cone #2 removed",
        "en-US": "Starboard engine cone #2 removed",
        "ja-JP": "Starboard engine cone #2 removed",
    },
    deicing_truck_started: {
        "de-DE": "Deicing started",
        "en-GB": "Deicing started",
        "en-US": "Deicing started",
        "ja-JP": "Deicing started",
    },
    deicing_truck_finished: {
        "de-DE": "Deicing finished",
        "en-GB": "Deicing finished",
        "en-US": "Deicing finished",
        "ja-JP": "Deicing finished",
    },
    back_right_catering_handrail_not_deployed: {
        "en-GB": "Provo aft port rails not deployed",
        "en-US": "Provo aft port rails not deployed",
        "de-DE": "Provo aft port rails not deployed",
        "ja-JP": "Provo aft port rails not deployed",
    },
    back_right_catering_handrail_deployed: {
        "en-GB": "Provo aft port rails deployed",
        "en-US": "Provo aft port rails deployed",
        "de-DE": "Provo aft port rails deployed",
        "ja-JP": "Provo aft port rails deployed",
    },
    one_back_right_catering_handrail_not_deployed: {
        "en-GB": "Provo aft port rails not deployed",
        "en-US": "Provo aft port rails not deployed",
        "de-DE": "Provo aft port rails not deployed",
        "ja-JP": "Provo aft port rails not deployed",
    },
    one_back_right_catering_handrail_deployed: {
        "en-GB": "Provo aft port rails deployed",
        "en-US": "Provo aft port rails deployed",
        "de-DE": "Provo aft port rails deployed",
        "ja-JP": "Provo aft port rails deployed",
    },
    front_catering_handrail_not_deployed: {
        "en-GB": "Provo rails not deployed",
        "en-US": "Provo rails not deployed",
        "de-DE": "Provo rails not deployed",
        "ja-JP": "Provo rails not deployed",
    },
    front_catering_handrail_deployed: {
        "en-GB": "Provo rails deployed",
        "en-US": "Provo rails deployed",
        "de-DE": "Provo rails deployed",
        "ja-JP": "Provo rails deployed",
    },
    one_front_left_catering_handrail_not_deployed: {
        "en-GB": "Provo rails not deployed",
        "en-US": "Provo rails not deployed",
        "de-DE": "Provo rails not deployed",
        "ja-JP": "Provo rails not deployed",
    },
    one_front_left_catering_handrail_deployed: {
        "en-GB": "Provo rails deployed",
        "en-US": "Provo rails deployed",
        "de-DE": "Provo rails deployed",
        "ja-JP": "Provo rails deployed",
    },
    catering_handrail_deployed: {
        "en-GB": "Provo rails deployed",
        "en-US": "Provo rails deployed",
        "de-DE": "Provo rails deployed",
        "ja-JP": "Provo rails deployed",
    },
    catering_entered_whole_stand: {
        "en-GB": "Catering entered stand",
        "en-US": "Catering entered stand",
        "de-DE": "Catering entered stand",
        "ja-JP": "Catering entered stand",
    },
    catering_left_whole_stand: {
        "en-GB": "Catering left stand",
        "en-US": "Catering left stand",
        "de-DE": "Catering left stand",
        "ja-JP": "Catering left stand",
    },
    towbar_connected: {
        "en-GB": "Towbar connected",
        "en-US": "Towbar connected",
        "de-DE": "Towbar connected",
        "ja-JP": "Towbar connected",
    },
    towbar_disconnected: {
        "en-GB": "Towbar disconnected",
        "en-US": "Towbar disconnected",
        "de-DE": "Towbar disconnected",
        "ja-JP": "Towbar disconnected",
    },
    towbar_arrived: {
        "en-GB": "Towbar entered stand",
        "en-US": "Towbar entered stand",
        "de-DE": "Towbar entered stand",
        "ja-JP": "Towbar entered stand",
    },
    towbar_left: {
        "en-GB": "Towbar left stand",
        "en-US": "Towbar left stand",
        "de-DE": "Towbar left stand",
        "ja-JP": "Towbar left stand",
    },
    walkaround_back_right_started: {
        "en-GB": "walkaround_back_right_started",
        "en-US": "walkaround_back_right_started",
        "de-DE": "walkaround_back_right_started",
        "ja-JP": "walkaround_back_right_started",
    },
    walkaround_back_right_ended: {
        "en-GB": "walkaround_back_right_ended",
        "en-US": "walkaround_back_right_ended",
        "de-DE": "walkaround_back_right_ended",
        "ja-JP": "walkaround_back_right_ended",
    },
    walkaround_back_left_started: {
        "en-GB": "walkaround_back_left_started",
        "en-US": "walkaround_back_left_started",
        "de-DE": "walkaround_back_left_started",
        "ja-JP": "walkaround_back_left_started",
    },
    walkaround_back_left_ended: {
        "en-GB": "walkaround_back_left_ended",
        "en-US": "walkaround_back_left_ended",
        "de-DE": "walkaround_back_left_ended",
        "ja-JP": "walkaround_back_left_ended",
    },
    walkaround_front_left_started: {
        "en-GB": "walkaround_front_left_started",
        "en-US": "walkaround_front_left_started",
        "de-DE": "walkaround_front_left_started",
        "ja-JP": "walkaround_front_left_started",
    },
    walkaround_front_left_ended: {
        "en-GB": "walkaround_front_left_ended",
        "en-US": "walkaround_front_left_ended",
        "de-DE": "walkaround_front_left_ended",
        "ja-JP": "walkaround_front_left_ended",
    },
    walkaround_front_right_started: {
        "en-GB": "walkaround_front_right_started",
        "en-US": "walkaround_front_right_started",
        "de-DE": "walkaround_front_right_started",
        "ja-JP": "walkaround_front_right_started",
    },
    walkaround_front_right_ended: {
        "en-GB": "walkaround_front_right_ended",
        "en-US": "walkaround_front_right_ended",
        "de-DE": "walkaround_front_right_ended",
        "ja-JP": "walkaround_front_right_ended",
    },
    arrival_walkaround_together_started: {
        "en-GB": "Post-arrival walkaround started",
        "en-US": "Post-arrival walkaround started",
        "de-DE": "Post-arrival walkaround started",
        "ja-JP": "Post-arrival walkaround started",
    },
    arrival_walkaround_together_finished: {
        "en-GB": "Post-arrival walkaround finished",
        "en-US": "Post-arrival walkaround finished",
        "de-DE": "Post-arrival walkaround finished",
        "ja-JP": "Post-arrival walkaround finished",
    },
    departure_walkaround_together_started: {
        "en-GB": "Pre-departure walkaround started",
        "en-US": "Pre-departure walkaround started",
        "de-DE": "Pre-departure walkaround started",
        "ja-JP": "Pre-departure walkaround started",
    },
    departure_walkaround_together_finished: {
        "en-GB": "Pre-departure walkaround finished",
        "en-US": "Pre-departure walkaround finished",
        "de-DE": "Pre-departure walkaround finished",
        "ja-JP": "Pre-departure walkaround finished",
    },
    critical_stand_not_clear: {
        "en-GB": "Critical stand not clear",
        "en-US": "Critical stand not clear",
        "de-DE": "Critical stand not clear",
        "ja-JP": "Critical stand not clear",
    },
    critical_stand_clear: {
        "en-GB": "Critical stand not clear end",
        "en-US": "Critical stand not clear end",
        "de-DE": "Critical stand not clear end",
        "ja-JP": "Critical stand not clear end",
    },
    cleaning_process_started: {
        "en-GB": "Cleaning process started",
        "en-US": "Cleaning process started",
        "de-DE": "Cleaning process started",
        "ja-JP": "Cleaning process started",
    },
    cleaning_process_finished: {
        "en-GB": "Cleaning process finished",
        "en-US": "Cleaning process finished",
        "de-DE": "Cleaning process finished",
        "ja-JP": "Cleaning process finished",
    },
    bridge_not_parked_started: {
        "en-GB": "L1 bridge not parked started",
        "en-US": "L1 bridge not parked started",
        "de-DE": "L1 bridge not parked started",
        "ja-JP": "L1 bridge not parked started",
    },
    bridge_not_parked_finished: {
        "en-GB": "L1 bridge not parked finished",
        "en-US": "L1 bridge not parked finished",
        "de-DE": "L1 bridge not parked finished",
        "ja-JP": "L1 bridge not parked finished",
    },
    second_bridge_not_parked_started: {
        "en-GB": "L2 bridge not parked started",
        "en-US": "L2 bridge not parked started",
        "de-DE": "L2 bridge not parked started",
        "ja-JP": "L2 bridge not parked started",
    },
    second_bridge_not_parked_finished: {
        "en-GB": "L2 bridge not parked finished",
        "en-US": "L2 bridge not parked finished",
        "de-DE": "L2 bridge not parked finished",
        "ja-JP": "L2 bridge not parked finished",
    },
    flight_bags_start: {
        "en-GB": "First bag scan received",
        "en-US": "First bag scan received",
        "de-DE": "First bag scan received",
        "ja-JP": "First bag scan received",
    },
    flight_bags_end: {
        "en-GB": "Last bag scan received",
        "en-US": "Last bag scan received",
        "de-DE": "Last bag scan received",
        "ja-JP": "Last bag scan received",
    },
    flight_pax_start: {
        "en-GB": "Passenger boarding started",
        "en-US": "Passenger boarding started",
        "de-DE": "Passenger boarding started",
        "ja-JP": "Passenger boarding started",
    },
    flight_pax_end: {
        "en-GB": "Passenger boarding ended",
        "en-US": "Passenger boarding ended",
        "de-DE": "Passenger boarding ended",
        "ja-JP": "Passenger boarding ended",
    },
    middle_bridge_connected: {
        "en-GB": "Middle bridge connected",
        "en-US": "Middle bridge connected",
        "de-DE": "Fluggastbrücke mitte verbunden",
        "ja-JP": "中央搭乗橋接続",
    },
    middle_bridge_disconnected: {
        "en-GB": "Middle bridge disconnected",
        "en-US": "Middle bridge disconnected",
        "de-DE": "Fluggastbrücke mitte getrennt",
        "ja-JP": "中央搭乗橋取り外し",
    },
    fueling_right_connected: {
        "de-DE": "Betankung verbunden",
        "en-GB": "Port fueller connected",
        "en-US": "Port fueler connected",
        "ja-JP": "右側給油車接続",
    },
    fueling_right_disconnected: {
        "de-DE": "Betankung getrennt",
        "en-GB": "Port fueller disconnected",
        "en-US": "Port fueler disconnected",
        "ja-JP": "右側給油車取り外し",
    },
    front_right_ambulift_connected: {
        "en-GB": "Fwd Port Ambulift Connected",
        "en-US": "Fwd Port Ambulift Connected",
        "de-DE": "Ambulift vorne verbunden",
        "ja-JP": "Fwd Port Ambulift Connected",
    },
    front_right_ambulift_disconnected: {
        "en-GB": "Fwd Port Ambulift Disconnected",
        "en-US": "Fwd Port Ambulift Disconnected",
        "de-DE": "Ambulift vorne getrennt",
        "ja-JP": "Fwd Port Ambulift Disconnected",
    },
    aircraft_entered_line_1: {
        "en-GB": "Aircraft entered line 1",
        "en-US": "Aircraft entered line 1",
        "de-DE": "Aircraft entered line 1",
        "ja-JP": "Aircraft entered line 1",
    },
    aircraft_left_line_1: {
        "en-GB": "Aircraft left line 1",
        "en-US": "Aircraft left line 1",
        "de-DE": "Aircraft left line 1",
        "ja-JP": "Aircraft left line 1",
    },
    aircraft_entered_line_2: {
        "en-GB": "Aircraft entered line 2",
        "en-US": "Aircraft entered line 2",
        "de-DE": "Aircraft entered line 2",
        "ja-JP": "Aircraft entered line 2",
    },
    aircraft_left_line_2: {
        "en-GB": "Aircraft left line 2",
        "en-US": "Aircraft left line 2",
        "de-DE": "Aircraft left line 2",
        "ja-JP": "Aircraft left line 2",
    },
    aircraft_entered_line_3: {
        "en-GB": "Aircraft entered line 3",
        "en-US": "Aircraft entered line 3",
        "de-DE": "Aircraft entered line 3",
        "ja-JP": "Aircraft entered line 3",
    },
    aircraft_left_line_3: {
        "en-GB": "Aircraft left line 3",
        "en-US": "Aircraft left line 3",
        "de-DE": "Aircraft left line 3",
        "ja-JP": "Aircraft left line 3",
    },
    aircraft_entered_line_4: {
        "en-GB": "Aircraft entered line 4",
        "en-US": "Aircraft entered line 4",
        "de-DE": "Aircraft entered line 4",
        "ja-JP": "Aircraft entered line 4",
    },
    aircraft_left_line_4: {
        "en-GB": "Aircraft left line 4",
        "en-US": "Aircraft left line 4",
        "de-DE": "Aircraft left line 4",
        "ja-JP": "Aircraft left line 4",
    },
    aircraft_entered_line_5: {
        "en-GB": "Aircraft entered line 5",
        "en-US": "Aircraft entered line 5",
        "de-DE": "Aircraft entered line 5",
        "ja-JP": "Aircraft entered line 5",
    },
    aircraft_left_line_5: {
        "en-GB": "Aircraft left line 5",
        "en-US": "Aircraft left line 5",
        "de-DE": "Aircraft left line 5",
        "ja-JP": "Aircraft left line 5",
    },
    aircraft_entered_line_6: {
        "en-GB": "Aircraft entered line 6",
        "en-US": "Aircraft entered line 6",
        "de-DE": "Aircraft entered line 6",
        "ja-JP": "Aircraft entered line 6",
    },
    aircraft_left_line_6: {
        "en-GB": "Aircraft left line 6",
        "en-US": "Aircraft left line 6",
        "de-DE": "Aircraft left line 6",
        "ja-JP": "Aircraft left line 6",
    },
    aircraft_entered_line_7: {
        "en-GB": "Aircraft entered line 7",
        "en-US": "Aircraft entered line 7",
        "de-DE": "Aircraft entered line 7",
        "ja-JP": "Aircraft entered line 7",
    },
    aircraft_left_line_7: {
        "en-GB": "Aircraft left line 7",
        "en-US": "Aircraft left line 7",
        "de-DE": "Aircraft left line 7",
        "ja-JP": "Aircraft left line 7",
    },
    aircraft_entered_line_8: {
        "en-GB": "Aircraft entered line 8",
        "en-US": "Aircraft entered line 8",
        "de-DE": "Aircraft entered line 8",
        "ja-JP": "Aircraft entered line 8",
    },
    aircraft_left_line_8: {
        "en-GB": "Aircraft left line 8",
        "en-US": "Aircraft left line 8",
        "de-DE": "Aircraft left line 8",
        "ja-JP": "Aircraft left line 8",
    },
    aircraft_entered_line_9: {
        "en-GB": "Aircraft entered line 9",
        "en-US": "Aircraft entered line 9",
        "de-DE": "Aircraft entered line 9",
        "ja-JP": "Aircraft entered line 9",
    },
    aircraft_left_line_9: {
        "en-GB": "Aircraft left line 9",
        "en-US": "Aircraft left line 9",
        "de-DE": "Aircraft left line 9",
        "ja-JP": "Aircraft left line 9",
    },
};

const defaultOperationLabels = {
    front_dolly: {
        "de-DE": "Vorne Dolly",
        "en-GB": "Forward dolly",
        "en-US": "Forward dolly",
        "ja-JP": "Forward dolly",
    },
    back_dolly: {
        "de-DE": "Hinten Dolly",
        "en-GB": "Aft dolly",
        "en-US": "Aft dolly",
        "ja-JP": "Aft dolly",
    },
    pushback_on_stand: {
        "de-DE": "Pushback auf Standplatz",
        "en-GB": "Pushback tug in position",
        "en-US": "Pushback tug in position",
        "ja-JP": "航空機牽引車定位置準備",
    },
    tbl_pushback_on_stand: {
        "de-DE": "Pushback auf Standplatz",
        "en-GB": "Pushback tug in position",
        "en-US": "Pushback tug in position",
        "ja-JP": "Pushback tug in position",
    },
    push_back: {
        "de-DE": "Pushback verbunden",
        "en-GB": "Pushback tug connected",
        "en-US": "Pushback tug connected",
        "ja-JP": "航空機牽引車 接続",
    },
    tbl_push_back: {
        "de-DE": "Pushback verbunden",
        "en-GB": "Pushback tug connected",
        "en-US": "Pushback tug connected",
        "ja-JP": "航空機牽引車接続",
    },
    small_tbl_push_back: {
        "de-DE": "Pushback verbunden",
        "en-GB": "Pushback tug connected",
        "en-US": "Pushback tug connected",
        "ja-JP": "航空機牽引車接続",
    },
    push_back_together: {
        "de-DE": "Pushback verbunden",
        "en-GB": "Pushback tug connected",
        "en-US": "Pushback tug connected",
        "ja-JP": "Pushback tug connected",
    },
    remote_control_pushback: {
        "de-DE": "Pushback verbunden",
        "en-GB": "Pushback tug connected",
        "en-US": "Pushback tug connected",
        "ja-JP": "航空機牽引車接続",
    },
    aircraft_on_stand: {
        "de-DE": "Luftfahrzeug auf Standplatz",
        "en-GB": "Aircraft on stand",
        "en-US": "Aircraft on stand",
        "ja-JP": "航空機 スポット内駐機",
    },
    aircraft: {
        "de-DE": "Luftfahrzeug in Parkposition",
        "en-GB": "Aircraft stationary",
        "en-US": "Aircraft stationary",
        "ja-JP": "航空機定置",
    },
    aircraft_ready: {
        "de-DE": "Luftfahrzeug bereit",
        "en-GB": "Aircraft ready",
        "en-US": "Aircraft ready",
        "ja-JP": "Aircraft ready",
    },
    bridge: {
        "de-DE": "Fluggastbrücke verbunden",
        "en-GB": "Bridge connected",
        "en-US": "Bridge connected",
        "ja-JP": "Bridge connected",
    },
    bridge_alt: {
        "de-DE": "Fluggastbrücke verbunden",
        "en-GB": "Bridge connected",
        "en-US": "Bridge connected",
        "ja-JP": "搭乗橋接続",
    },
    middle_bridge_alt: {
        "de-DE": "Fluggastbrücke Mitte verbunden",
        "en-GB": "Mid bridge connected",
        "en-US": "Mid bridge connected",
        "ja-JP": "中央搭乗橋接続",
    },
    upper_middle_bridge_alt: {
        "de-DE": "Upper mid bridge connected",
        "en-GB": "Upper mid bridge connected",
        "en-US": "Upper mid bridge connected",
        "ja-JP": "Upper mid bridge connected",
    },
    bridge_alt_together: {
        "de-DE": "Fluggastbrücke verbunden",
        "en-GB": "Bridge connected",
        "en-US": "Bridge connected",
        "ja-JP": "Bridge connected",
    },
    bridges: {
        "de-DE": "Fluggastbrücken",
        "en-GB": "Bridges connected",
        "en-US": "Bridges connected",
        "ja-JP": "Bridges connected",
    },
    middle_bridge: {
        "de-DE": "Fluggastbrücke Mitte verbunden",
        "en-GB": "Mid starboard bridge connected",
        "en-US": "Mid starboard bridge connected",
        "ja-JP": "Mid starboard bridge connected",
    },
    back_stairs_on_stand: {
        "de-DE": "Fluggasttreppe hinten auf Standplatz",
        "en-GB": "Aft port stairs on stand",
        "en-US": "Aft port stairs on stand",
        "ja-JP": "Aft port stairs on stand",
    },
    back_stairs: {
        "de-DE": "Fluggasttreppe hinten verbunden",
        "en-GB": "Aft port stairs connected",
        "en-US": "Aft port stairs connected",
        "ja-JP": "Aft port stairs connected",
    },
    back_left_stairs_on_stand: {
        "de-DE": "Fluggasttreppe hinten auf Standplatz",
        "en-GB": "Aft starboard stairs on stand",
        "en-US": "Aft starboard stairs on stand",
        "ja-JP": "Aft starboard stairs on stand",
    },
    back_left_stairs: {
        "de-DE": "Fluggasttreppe hinten verbunden",
        "en-GB": "Aft starboard stairs connected",
        "en-US": "Aft starboard stairs connected",
        "ja-JP": "Aft starboard stairs connected",
    },
    front_stairs_on_stand: {
        "de-DE": "Fluggasttreppe vorne auf Standplatz",
        "en-GB": "Fwd port stairs on stand",
        "en-US": "Fwd port stairs on stand",
        "ja-JP": "Fwd port stairs on stand",
    },
    front_stairs: {
        "de-DE": "Fluggasttreppe vorne verbunden",
        "en-GB": "Fwd port stairs connected",
        "en-US": "Fwd port stairs connected",
        "ja-JP": "Fwd port stairs connected",
    },
    front_left_stairs: {
        "de-DE": "Fluggasttreppe vorne verbunden",
        "en-GB": "Fwd starboard stairs connected",
        "en-US": "Fwd starboard stairs connected",
        "ja-JP": "Fwd starboard stairs connected",
    },
    front_cargo: {
        "de-DE": "Frachttür vorne offen",
        "en-GB": "Fwd starboard cargo door open",
        "en-US": "Fwd starboard cargo door open",
        "ja-JP": "前方右側貨物ドアオープン",
    },
    front_right_cargo: {
        "de-DE": "Frachttür vorne offen",
        "en-GB": "Fwd port cargo door open",
        "en-US": "Fwd port cargo door open",
        "ja-JP": "前方左側貨物ドアオープン",
    },
    front_cargo_bulk: {
        "de-DE": "Frachttür vorne offen",
        "en-GB": "Fwd starboard cargo bulk door open",
        "en-US": "Fwd starboard cargo bulk door open",
        "ja-JP": "Fwd starboard cargo bulk door open",
    },
    back_cargo: {
        "de-DE": "Frachttür hinten offen",
        "en-GB": "Aft starboard cargo door open",
        "en-US": "Aft starboard cargo door open",
        "ja-JP": "後方右側貨物ドアオープン",
    },
    back_cargo_bulk: {
        "de-DE": "Frachttür hinten offen",
        "en-GB": "Aft starboard cargo bulk door open",
        "en-US": "Aft starboard cargo bulk door open",
        "ja-JP": "Aft starboard cargo bulk door open",
    },
    back_right_cargo: {
        "de-DE": "Frachttür hinten offen",
        "en-GB": "Aft port cargo door open",
        "en-US": "Aft port cargo door open",
        "ja-JP": "後方左側貨物ドアオープン",
    },
    back_right_cargo_bulk: {
        "de-DE": "Frachttür hinten offen",
        "en-GB": "Aft port cargo bulk door open",
        "en-US": "Aft port cargo bulk door open",
        "ja-JP": "Aft port cargo bulk door open",
    },
    front_right_cargo_bulk: {
        "de-DE": "Frachttür vorne offen",
        "en-GB": "Fwd port cargo bulk door open",
        "en-US": "Fwd port cargo bulk door open",
        "ja-JP": "Fwd port cargo bulk door open",
    },
    middle_cargo_bulk: {
        "de-DE": "Frachttür mitte offen",
        "en-GB": "Mid starboard cargo bulk door open",
        "en-US": "Mid starboard cargo bulk door open",
        "ja-JP": "Mid starboard cargo bulk door open",
    },
    front_cargo_together: {
        "de-DE": "Frachttür vorne offen",
        "en-GB": "Fwd starboard cargo door open",
        "en-US": "Fwd starboard cargo door open",
        "ja-JP": "Fwd starboard cargo door open",
    },
    back_cargo_together: {
        "de-DE": "Frachttür hinten offen",
        "en-GB": "Aft starboard cargo door open",
        "en-US": "Aft starboard cargo door open",
        "ja-JP": "Aft starboard cargo door open",
    },
    caterings: {
        "de-DE": "Catering",
        "en-GB": "Catering",
        "en-US": "Catering",
        "ja-JP": "Catering",
    },
    catering_on_whole_stand: {
        "de-DE": "Catering on stand",
        "en-GB": "Catering on stand",
        "en-US": "Catering on stand",
        "ja-JP": "Catering on stand",
    },
    front_catering_on_stand: {
        "de-DE": "Catering vorne auf Standplatz",
        "en-GB": "Fwd starboard catering on stand",
        "en-US": "Fwd starboard catering on stand",
        "ja-JP": "Fwd starboard catering on stand",
    },
    front_catering: {
        "de-DE": "Catering vorne verbunden",
        "en-GB": "Fwd starboard catering connected",
        "en-US": "Fwd starboard catering connected",
        "ja-JP": "後方右側ケータリング車接続",
    },
    front_catering_truck: {
        "de-DE": "Catering vorne verbunden",
        "en-GB": "Fwd starboard catering connected",
        "en-US": "Fwd starboard catering connected",
        "ja-JP": "前方右側ケータリング車接続",
    },
    front_catering_together: {
        "de-DE": "Catering verbunden",
        "en-GB": "Fwd or mid starboard catering connected",
        "en-US": "Fwd or mid starboard catering connected",
        "ja-JP": "Fwd or mid starboard catering connected",
    },
    back_right_catering: {
        "de-DE": "Catering hinten verbunden",
        "en-GB": "Aft port catering connected",
        "en-US": "Aft port catering connected",
        "ja-JP": "後方左側ケータリング車接続",
    },
    back_left_catering_on_stand: {
        "de-DE": "Catering hinten auf Standplatz",
        "en-GB": "Aft starboard catering on stand",
        "en-US": "Aft starboard catering on stand",
        "ja-JP": "Aft starboard catering on stand",
    },
    back_right_catering_on_stand: {
        "de-DE": "Catering hinten auf Standplatz",
        "en-GB": "Aft port catering on stand",
        "en-US": "Aft port catering on stand",
        "ja-JP": "Aft port catering on stand",
    },
    middle_left_catering: {
        "de-DE": "Catering mitte verbunden",
        "en-GB": "Mid starboard catering connected",
        "en-US": "Mid starboard catering connected",
        "ja-JP": "中央右側ケータリング車接続",
    },
    highloader_on_stand: {
        "de-DE": "Highloader auf Standplatz",
        "en-GB": "Highloader on stand",
        "en-US": "Highloader on stand",
        "ja-JP": "Highloader on stand",
    },
    front_highloader_on_stand: {
        "de-DE": "Highloader vorne auf Standplatz",
        "en-GB": "Fwd starboard highloader on stand",
        "en-US": "Fwd starboard highloader on stand",
        "ja-JP": "Fwd starboard highloader on stand",
    },
    back_highloader_on_stand: {
        "de-DE": "Highloader hinten auf Standplatz",
        "en-GB": "Aft starboard highloader on stand",
        "en-US": "Aft starboard highloader on stand",
        "ja-JP": "Aft starboard highloader on stand",
    },
    back_left_catering: {
        "de-DE": "Catering hinten verbunden",
        "en-GB": "Aft starboard catering connected",
        "en-US": "Aft starboard catering connected",
        "ja-JP": "後方右側ケータリング車接続",
    },
    back_catering_with_door: {
        "de-DE": "Catering hinten verbunden",
        "en-GB": "Aft starboard catering connected",
        "en-US": "Aft starboard catering connected",
        "ja-JP": "後方右側ケータリング車接続",
    },
    back_left_catering_truck: {
        "de-DE": "Catering hinten verbunden",
        "en-GB": "Aft starboard catering connected",
        "en-US": "Aft starboard catering connected",
        "ja-JP": "後方右側ケータリング車接続",
    },
    back_right_catering_truck: {
        "de-DE": "Catering hinten verbunden",
        "en-GB": "Aft port catering connected",
        "en-US": "Aft port catering connected",
        "ja-JP": "後方左側ケータリング車接続",
    },
    middle_left_catering_truck: {
        "de-DE": "Catering mitte verbunden",
        "en-GB": "Mid starboard catering connected",
        "en-US": "Mid starboard catering connected",
        "ja-JP": "Mid starboard catering connected",
    },
    front_belt: {
        "de-DE": "Förderband vorne verbunden",
        "en-GB": "Fwd starboard belt connected",
        "en-US": "Fwd starboard belt connected",
        "ja-JP": "前方右側ベルトローダー接続",
    },
    front_belt_on_stand: {
        "de-DE": "Förderband vorne auf Standplatz",
        "en-GB": "Fwd starboard belt on stand",
        "en-US": "Fwd starboard belt on stand",
        "ja-JP": "Fwd starboard belt on stand",
    },
    front_and_middle_belt: {
        "de-DE": "Förderband vorne verbunden",
        "en-GB": "Fwd starboard belt connected",
        "en-US": "Fwd starboard belt connected",
        "ja-JP": "Fwd starboard belt connected",
    },
    back_belt: {
        "de-DE": "Förderband hinten verbunden",
        "en-GB": "Aft starboard belt connected",
        "en-US": "Aft starboard belt connected",
        "ja-JP": "後方右側ベルトローダー接続",
    },
    back_belt_on_stand: {
        "de-DE": "Förderband hinten auf Standplatz",
        "en-GB": "Aft starboard belt on stand",
        "en-US": "Aft starboard belt on stand",
        "ja-JP": "Aft starboard belt on stand",
    },
    belt_on_stand: {
        "de-DE": "Förderband auf Standplatz",
        "en-GB": "Belt on stand",
        "en-US": "Belt on stand",
        "ja-JP": "Belt on stand",
    },
    back_right_belt_on_stand: {
        "de-DE": "Förderband hinten auf Standplatz",
        "en-GB": "Aft port belt on stand",
        "en-US": "Aft port belt on stand",
        "ja-JP": "Aft port belt on stand",
    },
    middle_belt: {
        "de-DE": "Förderband mitte verbunden",
        "en-GB": "Mid starboard belt connected",
        "en-US": "Mid starboard belt connected",
        "ja-JP": "Mid starboard belt connected",
    },
    back_right_belt: {
        "de-DE": "Förderband hinten verbunden",
        "en-GB": "Aft port belt connected",
        "en-US": "Aft port belt connected",
        "ja-JP": "後方左側ベルトローダー接続",
    },
    gp_together: {
        "de-DE": "Bodenstrom verbunden",
        "en-GB": "Ground power connected",
        "en-US": "Ground power connected",
        "ja-JP": "Ground power connected",
    },
    fueling_on_stand: {
        "de-DE": "Betankung auf Standplatz",
        "en-GB": "Starboard fueller on stand",
        "en-US": "Starboard fueler on stand",
        "ja-JP": "Starboard fueller on stand",
    },
    fueling_on_whole_stand: {
        "de-DE": "Fueling on stand",
        "en-GB": "Fueling on stand",
        "en-US": "Fueling on stand",
        "ja-JP": "Fueling on stand",
    },
    fueling_right_on_stand: {
        "de-DE": "Betankung auf Standplatz",
        "en-GB": "Port fueller on stand",
        "en-US": "Port fueler on stand",
        "ja-JP": "Port fueller on stand",
    },
    fueling: {
        "de-DE": "Betankung verbunden",
        "en-GB": "Starboard fueller connected",
        "en-US": "Starboard fueler connected",
        "ja-JP": "右側給油車接続",
    },
    fueling_right: {
        "de-DE": "Betankung verbunden",
        "en-GB": "Port fueller connected",
        "en-US": "Port fueler connected",
        "ja-JP": "左側給油車接続",
    },
    fueling_right_in_position: {
        "de-DE": "Betankung in Position",
        "en-GB": "Port fueller in position",
        "en-US": "Port fueler in position",
        "ja-JP": "Port fueller in position",
    },
    fuelings: {
        "de-DE": "Betankung",
        "en-GB": "Fuelling",
        "en-US": "Fueling",
        "ja-JP": "Fuelling",
    },
    fueling_in_position: {
        "de-DE": "Betankung in Position",
        "en-GB": "Starboard fueller in position",
        "en-US": "Starboard fueler in position",
        "ja-JP": "Starboard fueller in position",
    },
    pass_bus_on_stand: {
        "de-DE": "Passagierbus auf Standplatz",
        "en-GB": "Passenger bus on stand",
        "en-US": "Passenger bus on stand",
        "ja-JP": "Passenger bus on stand",
    },
    front_highloader: {
        "de-DE": "Highloader vorne verbunden",
        "en-GB": "Fwd starboard highloader connected",
        "en-US": "Fwd starboard highloader connected",
        "ja-JP": "前方右側ハイリフトローダー接続",
    },
    back_highloader: {
        "de-DE": "Highloader hinten verbunden",
        "en-GB": "Aft starboard highloader connected",
        "en-US": "Aft starboard highloader connected",
        "ja-JP": "後方右側ハイリフトローダー接続",
    },
    upper_middle_front_left_aircraft_door: {
        "de-DE": "Servicetür mitte vorne offen",
        "en-GB": "Upper mid fwd starboard aircraft door",
        "en-US": "Upper mid fwd starboard aircraft door",
        "ja-JP": "Upper mid fwd starboard aircraft door",
    },
    upper_middle_front_right_aircraft_door: {
        "de-DE": "Servicetür mitte vorne offen",
        "en-GB": "Upper mid fwd port aircraft door open",
        "en-US": "Upper mid fwd port aircraft door open",
        "ja-JP": "Upper mid fwd port aircraft door open",
    },
    upper_middle_back_right_aircraft_door: {
        "de-DE": "Servicetür mitte hinten offen",
        "en-GB": "Upper mid aft port aircraft door open",
        "en-US": "Upper mid aft port aircraft door open",
        "ja-JP": "Upper mid aft port aircraft door open",
    },
    upper_middle_back_left_aircraft_door: {
        "de-DE": "Servicetür mitte hinten offen",
        "en-GB": "Upper mid aft starboard aircraft door open",
        "en-US": "Upper mid aft starboard aircraft door open",
        "ja-JP": "Upper mid aft starboard aircraft door open",
    },
    upper_middle_left_catering_truck: {
        "de-DE": "Catering mitte vorne verbunden",
        "en-GB": "Upper mid fwd starboard catering connected",
        "en-US": "Upper mid fwd starboard catering connected",
        "ja-JP": "Upper mid fwd starboard catering connected",
    },
    middle_front_left_catering_truck: {
        "de-DE": "Catering mitte vorne verbunden",
        "en-GB": "Mid fwd starboard catering connected",
        "en-US": "Mid fwd starboard catering connected",
        "ja-JP": "前方中央右側ケータリング車接続",
    },
    middle_front_right_catering_truck: {
        "de-DE": "Catering mitte vorne verbunden",
        "en-GB": "Mid fwd port catering connected",
        "en-US": "Mid fwd port catering connected",
        "ja-JP": "前方中央左側ケータリング車接続",
    },
    upper_middle_front_left_catering_truck: {
        "de-DE": "Catering mitte vorne verbunden",
        "en-GB": "Upper mid fwd starboard catering connected",
        "en-US": "Upper mid fwd starboard catering connected",
        "ja-JP": "Upper mid fwd starboard catering connected",
    },
    upper_middle_front_right_catering_truck: {
        "de-DE": "Catering mitte vorne verbunden",
        "en-GB": "Upper mid fwd port catering connected",
        "en-US": "Upper mid fwd port catering connected",
        "ja-JP": "Upper mid fwd port catering connected",
    },
    middle_back_right_catering_truck: {
        "de-DE": "Catering mitte hinten verbunden",
        "en-GB": "Mid aft port catering connected",
        "en-US": "Mid aft port catering connected",
        "ja-JP": "後方中央左側ケータリング車接続",
    },
    middle_back_left_catering_truck: {
        "de-DE": "Catering mitte hinten verbunden",
        "en-GB": "Mid aft starboard catering connected",
        "en-US": "Mid aft starboard catering connected",
        "ja-JP": "後方中央右側ケータリング車接続",
    },
    upper_middle_back_right_catering_truck: {
        "de-DE": "Catering mitte hinten verbunden",
        "en-GB": "Upper mid aft port catering connected",
        "en-US": "Upper mid aft port catering connected",
        "ja-JP": "Upper mid aft port catering connected",
    },
    upper_middle_back_left_catering_truck: {
        "de-DE": "Catering mitte hinten verbunden",
        "en-GB": "Upper mid aft starboard catering connected",
        "en-US": "Upper mid aft starboard catering connected",
        "ja-JP": "Upper mid aft starboard catering connected",
    },
    front_left_aircraft_door: {
        "de-DE": "Servicetür vorne offen",
        "en-GB": "Fwd starboard aircraft door open",
        "en-US": "Fwd starboard aircraft door open",
        "ja-JP": "Fwd starboard aircraft door open",
    },
    front_right_aircraft_door: {
        "de-DE": "Passagiertür vorne offen",
        "en-GB": "Fwd port aircraft door open",
        "en-US": "Fwd port aircraft door open",
        "ja-JP": "Fwd port aircraft door open",
    },
    middle_front_left_aircraft_door: {
        "de-DE": "Servicetür mitte vorne offen",
        "en-GB": "Mid starboard aircraft door open",
        "en-US": "Mid starboard aircraft door open",
        "ja-JP": "Mid starboard aircraft door open",
    },
    middle_front_right_aircraft_door: {
        "de-DE": "Servicetür mitte vorne offen",
        "en-GB": "Mid port aircraft door open",
        "en-US": "Mid port aircraft door open",
        "ja-JP": "Mid port aircraft door open",
    },
    back_left_aircraft_door: {
        "de-DE": "Servicetür hinten offen",
        "en-GB": "Aft starboard aircraft door open",
        "en-US": "Aft starboard aircraft door open",
        "ja-JP": "Aft starboard aircraft door open",
    },
    middle_back_left_aircraft_door: {
        "de-DE": "Servicetür mitte hinten offen",
        "en-GB": "Mid aft starboard aircraft door open",
        "en-US": "Mid aft starboard aircraft door open",
        "ja-JP": "Mid aft starboard aircraft door open",
    },
    middle_back_right_aircraft_door: {
        "de-DE": "Servicetür mitte hinten offen",
        "en-GB": "Mid aft port aircraft door open",
        "en-US": "Mid aft port aircraft door open",
        "ja-JP": "Mid aft port aircraft door open",
    },
    back_right_aircraft_door: {
        "de-DE": "Passagiertür hinten offen",
        "en-GB": "Aft port aircraft door open",
        "en-US": "Aft port aircraft door open",
        "ja-JP": "Aft port aircraft door open",
    },
    back_luggage_on_belt_loading: {
        "de-DE": "Gepäckbeladung hinten",
        "en-GB": "Aft starboard bag loading",
        "en-US": "Aft starboard bag loading",
        "ja-JP": "Aft starboard bag loading",
    },
    back_luggage_on_belt_unloading: {
        "de-DE": "Gepäckentladung hinten",
        "en-GB": "Aft starboard bag unloading",
        "en-US": "Aft starboard bag unloading",
        "ja-JP": "Aft starboard bag unloading",
    },
    front_luggage_on_belt_loading: {
        "de-DE": "Gepäckbeladung vorne",
        "en-GB": "Fwd starboard bag loading",
        "en-US": "Fwd starboard bag loading",
        "ja-JP": "Fwd starboard bag loading",
    },
    front_luggage_on_belt_unloading: {
        "de-DE": "Gepäckentladung vorne",
        "en-GB": "Fwd starboard bag unloading",
        "en-US": "Fwd starboard bag unloading",
        "ja-JP": "Fwd starboard bag unloading",
    },
    back_right_luggage_on_belt_loading: {
        "de-DE": "Gepäckbeladung hinten",
        "en-GB": "Aft port bags loading",
        "en-US": "Aft port bags loading",
        "ja-JP": "Aft port bags loading",
    },
    back_right_luggage_on_belt_unloading: {
        "de-DE": "Gepäckentladung hinten",
        "en-GB": "Aft port bags unloading",
        "en-US": "Aft port bags unloading",
        "ja-JP": "Aft port bags unloading",
    },
    luggage_loading: {
        "de-DE": "Gepäckbeladung",
        "en-GB": "Luggage loading",
        "en-US": "Luggage loading",
        "ja-JP": "Luggage loading",
    },
    luggage_unloading: {
        "de-DE": "Gepäckentladung",
        "en-GB": "Luggage unloading",
        "en-US": "Luggage unloading",
        "ja-JP": "Luggage unloading",
    },
    catering_car_on_stand: {
        "de-DE": "Catering auf Standplatz",
        "en-GB": "Catering on stand",
        "en-US": "Catering on stand",
        "ja-JP": "Catering on stand",
    },
    onboard_airstair: {
        "de-DE": "Bordeigene Treppe vorne ausgefahren",
        "en-GB": "Fwd on-board stairs deployed",
        "en-US": "Fwd on-board stairs deployed",
        "ja-JP": "Fwd on-board stairs deployed",
    },
    back_onboard_airstair: {
        "de-DE": "Bordeigene Treppe hinten ausgefahren",
        "en-GB": "Aft on-board stairs deployed",
        "en-US": "Aft on-board stairs deployed",
        "ja-JP": "Aft on-board stairs deployed",
    },
    lower_middle_back_left_aircraft_door: {
        "de-DE": "Servicetür mitte hinten offen",
        "en-GB": "Lower mid aft starboard aircraft door open",
        "en-US": "Lower mid aft starboard aircraft door open",
        "ja-JP": "Lower mid aft starboard aircraft door open",
    },
    lower_middle_back_right_aircraft_door: {
        "de-DE": "Servicetür mitte hinten offen",
        "en-GB": "Lower mid aft port aircraft door",
        "en-US": "Lower mid aft port aircraft door",
        "ja-JP": "Lower mid aft port aircraft door",
    },
    lower_middle_back_right_catering_truck: {
        "de-DE": "Catering mitte hinten verbunden",
        "en-GB": "Lower mid aft port catering connected",
        "en-US": "Lower mid aft port catering connected",
        "ja-JP": "Lower mid aft port catering connected",
    },
    lower_middle_bridge_alt: {
        "de-DE": "Fluggastbrücke mitte verbunden",
        "en-GB": "Lower mid starboard bridge connected",
        "en-US": "Lower mid starboard bridge connected",
        "ja-JP": "Lower mid starboard bridge connected",
    },
    lower_middle_front_left_aircraft_door: {
        "de-DE": "Servicetür mitte vorne offen",
        "en-GB": "Lower mid fwd starboard aircraft door open",
        "en-US": "Lower mid fwd starboard aircraft door open",
        "ja-JP": "Lower mid fwd starboard aircraft door open",
    },
    lower_middle_front_right_aircraft_door: {
        "de-DE": "Servicetür mitte vorne offen",
        "en-GB": "Lower mid fwd port aircraft door open",
        "en-US": "Lower mid fwd port aircraft door open",
        "ja-JP": "Lower mid fwd port aircraft door open",
    },
    lower_middle_left_catering_truck: {
        "de-DE": "Catering mitte verbunden",
        "en-GB": "Lower mid starboard catering connected",
        "en-US": "Lower mid starboard catering connected",
        "ja-JP": "Lower mid starboard catering connected",
    },
    lower_middle_back_left_catering_truck: {
        "de-DE": "Catering mitte hinten verbunden",
        "en-GB": "Lower mid aft starboard catering connected",
        "en-US": "Lower mid aft starboard catering connected",
        "ja-JP": "Lower mid aft starboard catering connected",
    },
    back_container_loading: {
        "de-DE": "ULD-Beladung hinten",
        "en-GB": "Aft starboard ULD loading",
        "en-US": "Aft starboard ULD loading",
        "ja-JP": "Aft starboard ULD loading",
    },
    back_container_unloading: {
        "de-DE": "ULD-Entladung hinten",
        "en-GB": "Aft starboard ULD unloading",
        "en-US": "Aft starboard ULD unloading",
        "ja-JP": "Aft starboard ULD unloading",
    },
    front_container_loading: {
        "de-DE": "ULD-Beladung vorne",
        "en-GB": "Fwd starboard ULD loading",
        "en-US": "Fwd starboard ULD loading",
        "ja-JP": "Fwd starboard ULD loading",
    },
    front_container_unloading: {
        "de-DE": "ULD-Entladung vorne",
        "en-GB": "Fwd starboard ULD unloading",
        "en-US": "Fwd starboard ULD unloading",
        "ja-JP": "Fwd starboard ULD unloading",
    },
    front_ambulift_on_stand: {
        "de-DE": "Ambulift vorne auf Standplatz",
        "en-GB": "Ambulift 1 on stand",
        "en-US": "Ambulift 1 on stand",
        "ja-JP": "Ambulift 1 on stand",
    },
    front_ambulift: {
        "de-DE": "Ambulift vorne verbunden",
        "en-GB": "Ambulift 1 connected",
        "en-US": "Ambulift 1 connected",
        "ja-JP": "Ambulift 1 connected",
    },
    front_ambulift_moved: {
        "de-DE": "Ambulift vorne verbunden",
        "en-GB": "Ambulift 1 connected",
        "en-US": "Ambulift 1 connected",
        "ja-JP": "Ambulift 1 connected",
    },
    back_ambulift_moved: {
        "de-DE": "Ambulift hinten verbunden",
        "en-GB": "Ambulift 2 connected",
        "en-US": "Ambulift 2 connected",
        "ja-JP": "Ambulift 2 connected",
    },
    back_ambulift_on_stand: {
        "de-DE": "Ambulift hinten auf Standplatz",
        "en-GB": "Ambulift 2 on stand",
        "en-US": "Ambulift 2 on stand",
        "ja-JP": "Ambulift 2 on stand",
    },
    back_ambulift: {
        "de-DE": "Ambulift hinten verbunden",
        "en-GB": "Ambulift 2 connected",
        "en-US": "Ambulift 2 connected",
        "ja-JP": "Ambulift 2 connected",
    },
    bridge_parked: {
        "de-DE": "Bridge on parking",
        "en-GB": "Bridge on parking",
        "en-US": "Bridge on parking",
        "ja-JP": "Bridge on parking",
    },
    cone: {
        "de-DE": "Cone in place",
        "en-GB": "Cone in place",
        "en-US": "Cone in place",
        "ja-JP": "Cone in place",
    },
    back_right_cleaners_on_stand: {
        "de-DE": "Cleaners on stand",
        "en-GB": "Cleaners on stand",
        "en-US": "Cleaners on stand",
        "ja-JP": "Cleaners on stand",
    },
    back_left_cleaners: {
        "de-DE": "Aft starboard cleaners connected",
        "en-GB": "Aft starboard cleaners connected",
        "en-US": "Aft starboard cleaners connected",
        "ja-JP": "Aft starboard cleaners connected",
    },
    back_right_cleaners: {
        "de-DE": "Aft port cleaners connected",
        "en-GB": "Aft port cleaners connected",
        "en-US": "Aft port cleaners connected",
        "ja-JP": "Aft port cleaners connected",
    },
    acu: {
        "de-DE": "PC Air Hose connected",
        "en-GB": "PC Air Hose connected",
        "en-US": "PC Air Hose connected",
        "ja-JP": "PC Air Hose connected",
    },
    acu_hose: {
        "de-DE": "PC Air Hose inflated",
        "en-GB": "PC Air Hose inflated",
        "en-US": "PC Air Hose inflated",
        "ja-JP": "PC Air Hose inflated",
    },
    sewage_potable_together: {
        "de-DE": "Potable water or sewage",
        "en-GB": "Potable water or sewage",
        "en-US": "Potable water or sewage",
        "ja-JP": "Potable water or sewage",
    },
    chocks: {
        "de-DE": "Nose chocks on",
        "en-GB": "Nose chocks on",
        "en-US": "Nose chocks on",
        "ja-JP": "Nose chocks on",
    },
    tail_stand: {
        "de-DE": "Tailstand on",
        "en-GB": "Tailstand on",
        "en-US": "Tailstand on",
        "ja-JP": "Tailstand on",
    },
    freshwater: {
        "de-DE": "Freshwater connected",
        "en-GB": "Freshwater connected",
        "en-US": "Freshwater connected",
        "ja-JP": "Freshwater connected",
    },
    boarding_into_gate_area: {
        "de-DE": "Boarding into gate area",
        "en-GB": "Boarding into gate area",
        "en-US": "Boarding into gate area",
        "ja-JP": "Boarding into gate area",
    },
    gate_door_open: {
        "de-DE": "Gate door open",
        "en-GB": "Gate door open",
        "en-US": "Gate door open",
        "ja-JP": "Gate door open",
    },
    gate_open: {
        "de-DE": "Gate open",
        "en-GB": "Gate open",
        "en-US": "Gate open",
        "ja-JP": "Gate open",
    },
    fod_walk: {
        "de-DE": "FOD walk",
        "en-GB": "FOD walk",
        "en-US": "FOD walk",
        "ja-JP": "FOD walk",
    },
    prm_staff_at_bridge: {
        "de-DE": "PRM staff present",
        "en-GB": "PRM staff present",
        "en-US": "PRM staff present",
        "ja-JP": "PRM staff present",
    },
    vacuum_onboarding: {
        "de-DE": "Vacuum onboarding",
        "en-GB": "Vacuum onboarding",
        "en-US": "Vacuum onboarding",
        "ja-JP": "Vacuum onboarding",
    },
    vacuum_offboarding: {
        "de-DE": "Vacuum offboarding",
        "en-GB": "Vacuum offboarding",
        "en-US": "Vacuum offboarding",
        "ja-JP": "Vacuum offboarding",
    },
    boarding_agent_at_gate: {
        "de-DE": "Boarding agent at gate",
        "en-GB": "Boarding agent at gate",
        "en-US": "Boarding agent at gate",
        "ja-JP": "Boarding agent at gate",
    },
    back_right_truck_in_position: {
        "de-DE": "Aft port water/lav truck in position",
        "en-GB": "Aft port water/lav truck in position",
        "en-US": "Aft port water/lav truck in position",
        "ja-JP": "Aft port water/lav truck in position",
    },
    back_left_truck_in_position: {
        "de-DE": "Aft starboard water/lav truck in position",
        "en-GB": "Aft starboard water/lav truck in position",
        "en-US": "Aft starboard water/lav truck in position",
        "ja-JP": "Aft starboard water/lav truck in position",
    },
    front_right_truck_in_position: {
        "de-DE": "Fwd port water/lav truck in position",
        "en-GB": "Fwd port water/lav truck in position",
        "en-US": "Fwd port water/lav truck in position",
        "ja-JP": "Fwd port water/lav truck in position",
    },
    front_left_truck_in_position: {
        "de-DE": "Fwd starboard water/lav truck in position",
        "en-GB": "Fwd starboard water/lav truck in position",
        "en-US": "Fwd starboard water/lav truck in position",
        "ja-JP": "Fwd starboard water/lav truck in position",
    },
    water_truck_in_position: {
        "de-DE": "Water/lav truck in position",
        "en-GB": "Water/lav truck in position",
        "en-US": "Water/lav truck in position",
        "ja-JP": "Water/lav truck in position",
    },
    front_pax_door: {
        "de-DE": "Fwd starboard passenger door open",
        "en-GB": "Fwd starboard passenger door open",
        "en-US": "Fwd starboard passenger door open",
        "ja-JP": "Fwd starboard passenger door open",
    },
    back_pax_door: {
        "de-DE": "Aft starboard passenger door open",
        "en-GB": "Aft starboard passenger door open",
        "en-US": "Aft starboard passenger door open",
        "ja-JP": "Aft starboard passenger door open",
    },
    pax_in: {
        "de-DE": "Passengers onboarding via jetbridge",
        "en-GB": "Passengers onboarding via jetbridge",
        "en-US": "Passengers onboarding via jetbridge",
        "ja-JP": "Passengers onboarding via jetbridge",
    },
    pax_out: {
        "de-DE": "Passengers offboarding via jetbridge",
        "en-GB": "Passengers offboarding via jetbridge",
        "en-US": "Passengers offboarding via jetbridge",
        "ja-JP": "Passengers offboarding via jetbridge",
    },
    pax_on_back_stair_loading: {
        "de-DE": "Passengers onboarding via airstairs",
        "en-GB": "Passengers onboarding via airstairs",
        "en-US": "Passengers onboarding via airstairs",
        "ja-JP": "Passengers onboarding via airstairs",
    },
    pax_on_back_stair_unloading: {
        "de-DE": "Passengers offboarding via airstairs",
        "en-GB": "Passengers offboarding via airstairs",
        "en-US": "Passengers offboarding via airstairs",
        "ja-JP": "Passengers offboarding via airstairs",
    },
    cleaning_on_stand: {
        "de-DE": "Cleaners on stand",
        "en-GB": "Cleaners on stand",
        "en-US": "Cleaners on stand",
        "ja-JP": "Cleaners on stand",
    },
    maintenance_on_stand: {
        "de-DE": "Maintenance on stand",
        "en-GB": "Maintenance on stand",
        "en-US": "Maintenance on stand",
        "ja-JP": "Maintenance on stand",
    },
    sewage_in_position: {
        "de-DE": "Sewage in position",
        "en-GB": "Sewage in position",
        "en-US": "Sewage in position",
        "ja-JP": "Sewage in position",
    },
    small_passenger_ramp_on_stand: {
        "de-DE": "Passenger ramp on stand",
        "en-GB": "Passenger ramp on stand",
        "en-US": "Passenger ramp on stand",
        "ja-JP": "Passenger ramp on stand",
    },
    passenger_ramp_on_stand: {
        "de-DE": "Passenger ramp on stand",
        "en-GB": "Passenger ramp on stand",
        "en-US": "Passenger ramp on stand",
        "ja-JP": "Passenger ramp on stand",
    },
    front_catering_guard_rail: {
        "de-DE": "Fwd starboard catering handrail deployed",
        "en-GB": "Fwd starboard catering handrail deployed",
        "en-US": "Fwd starboard catering handrail deployed",
        "ja-JP": "Fwd starboard catering handrail deployed",
    },
    back_left_catering_guard_rail: {
        "de-DE": "Aft starboard catering handrail deployed",
        "en-GB": "Aft starboard catering handrail deployed",
        "en-US": "Aft starboard catering handrail deployed",
        "ja-JP": "Aft starboard catering handrail deployed",
    },
    back_right_catering_guard_rail: {
        "de-DE": "Aft port catering handrail deployed",
        "en-GB": "Aft port catering handrail deployed",
        "en-US": "Aft port catering handrail deployed",
        "ja-JP": "Aft port catering handrail deployed",
    },
    one_back_left_catering_guard_rail: {
        "de-DE": "Aft starboard catering handrail deployed",
        "en-GB": "Aft starboard catering handrail deployed",
        "en-US": "Aft starboard catering handrail deployed",
        "ja-JP": "Aft starboard catering handrail deployed",
    },
    one_back_right_catering_guard_rail: {
        "de-DE": "Aft port catering handrail deployed",
        "en-GB": "Aft port catering handrail deployed",
        "en-US": "Aft port catering handrail deployed",
        "ja-JP": "Aft port catering handrail deployed",
    },
    one_front_catering_guard_rail: {
        "de-DE": "Fwd starboard catering handrail deployed",
        "en-GB": "Fwd starboard catering handrail deployed",
        "en-US": "Fwd starboard catering handrail deployed",
        "ja-JP": "Fwd starboard catering handrail deployed",
    },
    right_engine_cone: {
        "de-DE": "Port engine cone",
        "en-GB": "Port engine cone",
        "en-US": "Port engine cone",
        "ja-JP": "Port engine cone",
    },
    left_engine_cone: {
        "de-DE": "Starboard engine cone",
        "en-GB": "Starboard engine cone",
        "en-US": "Starboard engine cone",
        "ja-JP": "Starboard engine cone",
    },
    second_right_engine_cone: {
        "de-DE": "Port engine cone #2",
        "en-GB": "Port engine cone #2",
        "en-US": "Port engine cone #2",
        "ja-JP": "Port engine cone #2",
    },
    second_left_engine_cone: {
        "de-DE": "Starboard engine cone #2",
        "en-GB": "Starboard engine cone #2",
        "en-US": "Starboard engine cone #2",
        "ja-JP": "Starboard engine cone #2",
    },
    left_chocks: {
        "de-DE": "Starboard main chocks",
        "en-GB": "Starboard main chocks",
        "en-US": "Starboard main chocks",
        "ja-JP": "Starboard main chocks",
    },
    right_chocks: {
        "de-DE": "Port main chocks",
        "en-GB": "Port main chocks",
        "en-US": "Port main chocks",
        "ja-JP": "Port main chocks",
    },
    front_belt_guard_rail_not_deployed: {
        "de-DE": "Fwd starboard belt handrail not deployed",
        "en-GB": "Fwd starboard belt handrail not deployed",
        "en-US": "Fwd starboard belt handrail not deployed",
        "ja-JP": "Fwd starboard belt handrail not deployed",
    },
    human_without_vest: {
        "de-DE": "Human without vest",
        "en-GB": "Human without vest",
        "en-US": "Human without vest",
        "ja-JP": "Human without vest",
    },
    human_entered_eiz2: {
        "de-DE": "Engine ingestion zone violated",
        "en-GB": "Engine ingestion zone violated",
        "en-US": "Engine ingestion zone violated",
        "ja-JP": "Engine ingestion zone violated",
    },
    object_track_not_stopped: {
        "de-DE": "GSE brake check not performed",
        "en-GB": "GSE brake check not performed",
        "en-US": "GSE brake check not performed",
        "ja-JP": "GSE brake check not performed",
    },
    cleaning_team_onboarding_via_airstairs: {
        "de-DE": "Cleaning team onboarding via airstairs",
        "en-GB": "Cleaning team onboarding via airstairs",
        "en-US": "Cleaning team onboarding via airstairs",
        "ja-JP": "Cleaning team onboarding via airstairs",
    },
    cleaning_team_disembarkation_via_airstairs: {
        "de-DE": "Cleaning team disembarking via airstairs",
        "en-GB": "Cleaning team disembarking via airstairs",
        "en-US": "Cleaning team disembarking via airstairs",
        "ja-JP": "Cleaning team disembarking via airstairs",
    },
    cleaning_team_onboarding: {
        "de-DE": "Cleaning team onboarding via jetbridge",
        "en-GB": "Cleaning team onboarding via jetbridge",
        "en-US": "Cleaning team onboarding via jetbridge",
        "ja-JP": "Cleaning team onboarding via jetbridge",
    },
    cleaning_team_offboarding: {
        "de-DE": "Cleaning team disembarking via jetbridge",
        "en-GB": "Cleaning team disembarking via jetbridge",
        "en-US": "Cleaning team disembarking via jetbridge",
        "ja-JP": "Cleaning team disembarking via jetbridge",
    },
    cockpit_crew_onboarding: {
        "de-DE": "Cockpit crew onboarding",
        "en-GB": "Cockpit crew onboarding",
        "en-US": "Cockpit crew onboarding",
        "ja-JP": "Cockpit crew onboarding",
    },
    cockpit_crew_offboarding: {
        "de-DE": "Cockpit crew disembarking",
        "en-GB": "Cockpit crew disembarking",
        "en-US": "Cockpit crew disembarking",
        "ja-JP": "Cockpit crew disembarking",
    },
    cabin_crew_onboarding: {
        "de-DE": "Cabin crew onboarding",
        "en-GB": "Cabin crew onboarding",
        "en-US": "Cabin crew onboarding",
        "ja-JP": "Cabin crew onboarding",
    },
    cabin_crew_offboarding: {
        "de-DE": "Cabin crew disembarking",
        "en-GB": "Cabin crew disembarking",
        "en-US": "Cabin crew disembarking",
        "ja-JP": "Cabin crew disembarking",
    },
    stand_not_clear: {
        "de-DE": "Stand not clear",
        "en-GB": "Stand not clear",
        "en-US": "Stand not clear",
        "ja-JP": "Stand not clear",
    },
    acu_hose_deployed: {
        "de-DE": "PC Air Hose deployed",
        "en-GB": "PC Air Hose deployed",
        "en-US": "PC Air Hose deployed",
        "ja-JP": "PC Air Hose deployed",
    },
    aircraft_wait_for_park: {
        "de-DE": "Aircraft wait for park",
        "en-GB": "Aircraft wait for park",
        "en-US": "Aircraft wait for park",
        "ja-JP": "Aircraft wait for park",
    },
    left_wingwalker: {
        "de-DE": "Starboard wingwalker on stand",
        "en-GB": "Starboard wingwalker on stand",
        "en-US": "Starboard wingwalker on stand",
        "ja-JP": "Starboard wingwalker on stand",
    },
    right_wingwalker: {
        "de-DE": "Port wingwalker on stand",
        "en-GB": "Port wingwalker on stand",
        "en-US": "Port wingwalker on stand",
        "ja-JP": "Port wingwalker on stand",
    },
    apu_sound: {
        "de-DE": "APU on",
        "en-GB": "APU on",
        "en-US": "APU on",
        "ja-JP": "APU on",
    },
    engine_sound: {
        "de-DE": "Engine on",
        "en-GB": "Engine on",
        "en-US": "Engine on",
        "ja-JP": "Engine on",
    },
    deicing_in_progress: {
        "de-DE": "Deicing",
        "en-GB": "Deicing",
        "en-US": "Deicing",
        "ja-JP": "Deicing",
    },
    gp: {
        "de-DE": "Ground power connected",
        "en-GB": "Ground power connected",
        "en-US": "Ground power connected",
        "ja-JP": "Ground power connected",
    },
    gpu: {
        "de-DE": "GPU connected",
        "en-GB": "GPU connected",
        "en-US": "GPU connected",
        "ja-JP": "GPU connected",
    },
    pax_door_together: {
        "de-DE": "Passenger door open",
        "en-GB": "Passenger door open",
        "en-US": "Passenger door open",
        "ja-JP": "Passenger door open",
    },
    back_right_catering_handrail_not_deployed: {
        "en-GB": "Provo aft port rails not deployed",
        "en-US": "Provo aft port rails not deployed",
        "de-DE": "Provo aft port rails not deployed",
        "ja-JP": "Provo aft port rails not deployed",
    },
    one_back_right_catering_handrail_not_deployed: {
        "en-GB": "Provo aft port rails not deployed",
        "en-US": "Provo aft port rails not deployed",
        "de-DE": "Provo aft port rails not deployed",
        "ja-JP": "Provo aft port rails not deployed",
    },
    front_catering_handrail_not_deployed: {
        "en-GB": "Provo rails not deployed",
        "en-US": "Provo rails not deployed",
        "de-DE": "Provo rails not deployed",
        "ja-JP": "Provo rails not deployed",
    },
    one_front_left_catering_handrail_not_deployed: {
        "en-GB": "Provo rails not deployed",
        "en-US": "Provo rails not deployed",
        "de-DE": "Provo rails not deployed",
        "ja-JP": "Provo rails not deployed",
    },
    catering_handrail_not_deployed: {
        "en-GB": "Provo rails not deployed",
        "en-US": "Provo rails not deployed",
        "de-DE": "Provo rails not deployed",
        "ja-JP": "Provo rails not deployed",
    },
    towbar: {
        "en-GB": "Towbar connected",
        "en-US": "Towbar connected",
        "de-DE": "Towbar connected",
        "ja-JP": "Towbar connected",
    },
    towbar_on_stand: {
        "en-GB": "Towbar on stand",
        "en-US": "Towbar on stand",
        "de-DE": "Towbar on stand",
        "ja-JP": "Towbar on stand",
    },
    arrival_walkaround_together: {
        "en-GB": "Post-arrival walkaround",
        "en-US": "Post-arrival walkaround",
        "de-DE": "Post-arrival walkaround",
        "ja-JP": "Post-arrival walkaround",
    },
    walkaround_back_left: {
        "en-GB": "DEBUG: walkaround_back_left",
        "en-US": "walkaround_back_left",
        "de-DE": "walkaround_back_left",
        "ja-JP": "DEBUG: walkaround_back_left",
    },
    walkaround_back_right: {
        "en-GB": "DEBUG: walkaround_back_right",
        "en-US": "walkaround_back_right",
        "de-DE": "walkaround_back_right",
        "ja-JP": "DEBUG: walkaround_back_right",
    },
    walkaround_front_left: {
        "en-GB": "DEBUG: walkaround_front_left",
        "en-US": "walkaround_front_left",
        "de-DE": "walkaround_front_left",
        "ja-JP": "DEBUG: walkaround_front_left",
    },
    walkaround_front_right: {
        "en-GB": "DEBUG: walkaround_front_right",
        "en-US": "walkaround_front_right",
        "de-DE": "walkaround_front_right",
        "ja-JP": "DEBUG: walkaround_front_right",
    },
    departure_walkaround_together: {
        "en-GB": "Pre-departure walkaround",
        "en-US": "Pre-departure walkaround",
        "de-DE": "Pre-departure walkaround",
        "ja-JP": "Pre-departure walkaround",
    },
    critical_stand_not_clear: {
        "en-GB": "Critical stand not clear",
        "en-US": "Critical stand not clear",
        "de-DE": "Critical stand not clear",
        "ja-JP": "Critical stand not clear",
    },
    cleaning_process: {
        "en-GB": "Cleaning process",
        "en-US": "Cleaning process",
        "de-DE": "Cleaning process",
        "ja-JP": "Cleaning process",
    },
    bridge_not_parked: {
        "en-GB": "L1 bridge",
        "en-US": "L1 bridge",
        "de-DE": "L1 bridge",
        "ja-JP": "L1 bridge",
    },
    second_bridge_not_parked: {
        "en-GB": "L2 bridge",
        "en-US": "L2 bridge",
        "de-DE": "L2 bridge",
        "ja-JP": "L2 bridge",
    },
    flight_bags: {
        "en-GB": "Baggage loading scans",
        "en-US": "Baggage loading scans",
        "de-DE": "Baggage loading scans",
        "ja-JP": "Baggage loading scans",
    },
    flight_pax: {
        "en-GB": "Passenger boarding scans",
        "en-US": "Passenger boarding scans",
        "de-DE": "Passenger boarding scans",
        "ja-JP": "Passenger boarding scans",
    },
    front_right_ambulift_moved: {
        "en-GB": "Fwd Port Ambulift",
        "en-US": "Fwd Port Ambulift",
        "de-DE": "Ambulift vorne",
        "ja-JP": "Fwd Port Ambulift",
    },
    back_right_ambulift_moved: {
        "en-GB": "Aft Port Ambulift",
        "en-US": "Aft Port Ambulift",
        "de-DE": "Ambulift hinten",
        "ja-JP": "Aft Port Ambulift",
    },
    aircraft_on_line_1: {
        "en-GB": "Aircraft parked on line 1",
        "en-US": "Aircraft parked on line 1",
        "de-DE": "Aircraft parked on line 1",
        "ja-JP": "Aircraft parked on line 1",
    },
    aircraft_on_line_2: {
        "en-GB": "Aircraft parked on line 2",
        "en-US": "Aircraft parked on line 2",
        "de-DE": "Aircraft parked on line 2",
        "ja-JP": "Aircraft parked on line 2",
    },
    aircraft_on_line_3: {
        "en-GB": "Aircraft parked on line 3",
        "en-US": "Aircraft parked on line 3",
        "de-DE": "Aircraft parked on line 3",
        "ja-JP": "Aircraft parked on line 3",
    },
    aircraft_on_line_4: {
        "en-GB": "Aircraft parked on line 4",
        "en-US": "Aircraft parked on line 4",
        "de-DE": "Aircraft parked on line 4",
        "ja-JP": "Aircraft parked on line 4",
    },
    aircraft_on_line_5: {
        "en-GB": "Aircraft parked on line 5",
        "en-US": "Aircraft parked on line 5",
        "de-DE": "Aircraft parked on line 5",
        "ja-JP": "Aircraft parked on line 5",
    },
    aircraft_on_line_6: {
        "en-GB": "Aircraft parked on line 6",
        "en-US": "Aircraft parked on line 6",
        "de-DE": "Aircraft parked on line 6",
        "ja-JP": "Aircraft parked on line 6",
    },
    aircraft_on_line_7: {
        "en-GB": "Aircraft parked on line 7",
        "en-US": "Aircraft parked on line 7",
        "de-DE": "Aircraft parked on line 7",
        "ja-JP": "Aircraft parked on line 7",
    },
    aircraft_on_line_8: {
        "en-GB": "Aircraft parked on line 8",
        "en-US": "Aircraft parked on line 8",
        "de-DE": "Aircraft parked on line 8",
        "ja-JP": "Aircraft parked on line 8",
    },
    aircraft_on_line_9: {
        "en-GB": "Aircraft parked on line 9",
        "en-US": "Aircraft parked on line 9",
        "de-DE": "Aircraft parked on line 9",
        "ja-JP": "Aircraft parked on line 9",
    },
};

const defaultPtsLabels = {
    pts_schedule_passengers: {
        "en-GB": "Pax",
        "en-US": "Pax",
        "de-DE": "Pax",
        "ja-JP": "旅客",
    },
    pts_category_baggage: {
        "en-GB": "Baggage loading scans",
        "en-US": "Baggage loading scans",
        "de-DE": "Baggage loading scans",
        "ja-JP": "Baggage loading scans",
    },
    pts_schedule_baggage: {
        "en-GB": "Bags",
        "en-US": "Bags",
        "de-DE": "Bags",
        "ja-JP": "荷物",
    },
    pts_category_acu: {
        "en-GB": "ACU",
        "en-US": "ACU",
        "de-DE": "ACU",
        "ja-JP": "ACU",
    },
    pts_schedule_acu_connected: {
        "en-GB": "ACU connected",
        "en-US": "ACU connected",
        "de-DE": "ACU verbunden",
        "ja-JP": "ACU接続",
    },
    pts_category_aircraft_door: {
        "en-GB": "Aircraft door",
        "en-US": "Aircraft door",
        "de-DE": "Luftfahrzeugtür",
        "ja-JP": "ドア",
    },
    pts_schedule_aircraft_door_open: {
        "en-GB": "Aircraft door open",
        "en-US": "Aircraft door open",
        "de-DE": "Luftfahrzeugtür offen",
        "ja-JP": "ドアオープン",
    },
    pts_category_aircraft: {
        "en-GB": "Aircraft",
        "en-US": "Aircraft",
        "de-DE": "Luftfahrzeug",
        "ja-JP": "航空機",
    },
    pts_schedule_aircraft_parked: {
        "en-GB": "Aircraft parked",
        "en-US": "Aircraft parked",
        "de-DE": "Luftfahrzeug in Parkposition",
        "ja-JP": "航空機定置",
    },
    pts_schedule_aircraft_on_stand: {
        "en-GB": "Aircraft on stand",
        "en-US": "Aircraft on stand",
        "de-DE": "Luftfahrzeug auf Standplatz",
        "ja-JP": "航空機のスポット内駐機",
    },
    pts_category_ambulift: {
        "en-GB": "Ambulift",
        "en-US": "Ambulift",
        "de-DE": "Ambulift",
        "ja-JP": "リフト車",
    },
    pts_schedule_ambulift_connected: {
        "en-GB": "Ambulift connected",
        "en-US": "Ambulift connected",
        "de-DE": "Ambulift verbunden",
        "ja-JP": "リフト車接続",
    },
    pts_schedule_ambulift_on_stand: {
        "en-GB": "Ambulift on stand",
        "en-US": "Ambulift on stand",
        "de-DE": "Ambulift auf Standplatz",
        "ja-JP": "リフト車スポット内準備",
    },
    pts_category_apu: {
        "en-GB": "APU",
        "en-US": "APU",
        "de-DE": "APU",
        "ja-JP": "APU",
    },
    pts_schedule_apu: {
        "en-GB": "APU on",
        "en-US": "APU on",
        "de-DE": "APU on",
        "ja-JP": "APUオン",
    },
    pts_category_belt: {
        "en-GB": "Loader",
        "en-US": "Loader",
        "de-DE": "Förderband",
        "ja-JP": "ローダー",
    },
    pts_schedule_belt_connected: {
        "en-GB": "Loader connected",
        "en-US": "Loader connected",
        "de-DE": "Ladeequipment verbunden",
        "ja-JP": "ローダー接続",
    },
    pts_schedule_belt_on_stand: {
        "en-GB": "Loader on stand",
        "en-US": "Loader on stand",
        "de-DE": "Förderband auf Standplatz",
        "ja-JP": "ローダー スポット内準備",
    },
    pts_category_bridge: {
        "en-GB": "Bridge",
        "en-US": "Bridge",
        "de-DE": "Fluggastbrücke",
        "ja-JP": "搭乗橋",
    },
    pts_schedule_bridge_connected: {
        "en-GB": "Boarding bridge/Stairs",
        "en-US": "Boarding bridge/Stairs",
        "de-DE": "Fluggastbrücke/-treppe",
        "ja-JP": "搭乗橋/エアステア接続",
    },
    pts_schedule_bridge_parked: {
        "en-GB": "Bridge parked",
        "en-US": "Bridge parked",
        "de-DE": "Fluggastbrücke geparkt",
        "ja-JP": "搭乗橋駐車",
    },
    pts_schedule_bridge_on_stand: {
        "en-GB": "Bridge on stand",
        "en-US": "Bridge on stand",
        "de-DE": "Fluggastbrücke auf Standplatz",
        "ja-JP": "搭乗橋 スポット内準備",
    },
    pts_category_cargo_door: {
        "en-GB": "Cargo door",
        "en-US": "Cargo door",
        "de-DE": "Frachttür",
        "ja-JP": "貨物ドア",
    },
    pts_schedule_cargo_door_open: {
        "en-GB": "Cargo door open",
        "en-US": "Cargo door open",
        "de-DE": "Frachttür geöffnet",
        "ja-JP": "貨物ドアオープン",
    },
    pts_category_catering: {
        "en-GB": "Catering",
        "en-US": "Catering",
        "de-DE": "Frachttür",
        "ja-JP": "ケータリング車",
    },
    pts_schedule_catering_on_stand: {
        "en-GB": "Catering on stand",
        "en-US": "Catering on stand",
        "de-DE": "Catering auf Standplatz",
        "ja-JP": "ケータリング車 スポット内準備",
    },
    pts_schedule_catering_connected: {
        "en-GB": "Catering connected",
        "en-US": "Catering connected",
        "de-DE": "Catering verbunden",
        "ja-JP": "ケータリング車 接続",
    },
    pts_category_chocks: {
        "en-GB": "Chocks",
        "en-US": "Chocks",
        "de-DE": "Chock",
        "ja-JP": "チョーク",
    },
    pts_schedule_chocks_on: {
        "en-GB": "Chocks on",
        "en-US": "Chocks on",
        "de-DE": "Chocks platziert",
        "ja-JP": "チョーク装着",
    },
    pts_category_cleaners: {
        "en-GB": "Cleaners",
        "en-US": "Cleaners",
        "de-DE": "Cleaners",
        "ja-JP": "清掃車",
    },
    pts_schedule_cleaners_connected: {
        "en-GB": "Cleaners connected",
        "en-US": "Cleaners connected",
        "de-DE": "Cleaners connected",
        "ja-JP": "清掃車接続",
    },
    pts_schedule_cleaners_on_stand: {
        "en-GB": "Cleaners on stand",
        "en-US": "Cleaners on stand",
        "de-DE": "Cleaners on stand",
        "ja-JP": "清掃車 スポット内準備",
    },
    pts_category_containers: {
        "en-GB": "Containers",
        "en-US": "Containers",
        "de-DE": "ULD",
        "ja-JP": "ULD",
    },
    pts_schedule_container_loading: {
        "en-GB": "ULD loading",
        "en-US": "ULD loading",
        "de-DE": "Beladung (ULD)",
        "ja-JP": "ULD積み上げ",
    },
    pts_schedule_container_unloading: {
        "en-GB": "ULD unloading",
        "en-US": "ULD unloading",
        "de-DE": "Entladung (ULD)",
        "ja-JP": "ULD積み下ろし",
    },
    pts_category_engine: {
        "en-GB": "Engine",
        "en-US": "Engine",
        "de-DE": "Engine",
        "ja-JP": "エンジン",
    },
    pts_schedule_engine: {
        "en-GB": "Engine on",
        "en-US": "Engine on",
        "de-DE": "Engine on",
        "ja-JP": "エンジンオン",
    },
    pts_category_engine_cones: {
        "en-GB": "Engine cones",
        "en-US": "Engine cones",
        "de-DE": "Engine cones",
        "ja-JP": "エンジンコーン",
    },
    pts_schedule_engine_cone_on: {
        "en-GB": "Engine cones in place",
        "en-US": "Engine cones in place",
        "de-DE": "Engine cones in place",
        "ja-JP": "エンジンコーン設置",
    },
    pts_category_fueller: {
        "en-GB": "Fueller",
        "en-US": "Fueler",
        "de-DE": "Betankung",
        "ja-JP": "給油車",
    },
    pts_schedule_fueller_connected: {
        "en-GB": "Fueller connected",
        "en-US": "Fueler connected",
        "de-DE": "Betankung verbunden",
        "ja-JP": "給油車接続",
    },
    pts_schedule_fueller_in_position: {
        "en-GB": "Fueller in position",
        "en-US": "Fueler in position",
        "de-DE": "Betankung in Position",
        "ja-JP": "給油車 定位置準備",
    },
    pts_schedule_fueller_on_stand: {
        "en-GB": "Fueller on stand",
        "en-US": "Fueler on stand",
        "de-DE": "Betankung auf Standplatz",
        "ja-JP": "給油車 スポット内準備",
    },
    pts_category_gpu: {
        "en-GB": "GPU",
        "en-US": "GPU",
        "de-DE": "Bodenstrom",
        "ja-JP": "GPU（地上電源装置）",
    },
    pts_schedule_gpu_connected: {
        "en-GB": "GPU connected",
        "en-US": "GPU connected",
        "de-DE": "Bodenstrom verbunden",
        "ja-JP": "GPU（地上電源装置）接続",
    },
    pts_category_luggage: {
        "en-GB": "Luggage",
        "en-US": "Luggage",
        "de-DE": "Gepäck",
        "ja-JP": "手荷物",
    },
    pts_schedule_luggage_loading: {
        "en-GB": "Luggage loading",
        "en-US": "Luggage loading",
        "de-DE": "Beladung (Bulk)",
        "ja-JP": "手荷物塔載",
    },
    pts_schedule_luggage_unloading: {
        "en-GB": "Luggage unloading",
        "en-US": "Luggage unloading",
        "de-DE": "Entladung (Bulk)",
        "ja-JP": "手荷物取降し",
    },
    pts_category_pushback: {
        "en-GB": "Pushback",
        "en-US": "Pushback",
        "de-DE": "Pushback",
        "ja-JP": "プッシュバック",
    },
    pts_schedule_pushback_connected: {
        "en-GB": "Pushback connected",
        "en-US": "Pushback connected",
        "de-DE": "Pushback verbunden",
        "ja-JP": "航空機牽引車接続",
    },
    pts_schedule_pushback_on_stand: {
        "en-GB": "Pushback on stand",
        "en-US": "Pushback on stand",
        "de-DE": "Pushback auf Standplatz",
        "ja-JP": "航空機牽引車 スポット内準備",
    },
    pts_category_tailstand: {
        "en-GB": "Tailstand",
        "en-US": "Tailstand",
        "de-DE": "Heckstütze",
        "ja-JP": "テールスタンド",
    },
    pts_schedule_tailstand_connected: {
        "en-GB": "Tailstand connected",
        "en-US": "Tailstand connected",
        "de-DE": "Heckstütze verbunden",
        "ja-JP": "テールスタンド装着",
    },
    pts_category_water_lav_truck: {
        "en-GB": "Water/lav truck",
        "en-US": "Water/lav truck",
        "de-DE": "Water/lav truck",
        "ja-JP": "給水/汚水車",
    },
    pts_schedule_water_lav_truck_in_position: {
        "en-GB": "Water/lav truck in position",
        "en-US": "Water/lav truck in position",
        "de-DE": "Water/lav truck in position",
        "ja-JP": "給水/汚水車 定位置準備",
    },
    pts_category_wingwalkers: {
        "en-GB": "Wingwalkers",
        "en-US": "Wingwalkers",
        "de-DE": "Wingwalkers",
        "ja-JP": "翼端監視員",
    },
    pts_schedule_wingwalkers: {
        "en-GB": "Wingwalkers",
        "en-US": "Wingwalkers",
        "de-DE": "Wingwalkers",
        "ja-JP": "翼端監視員",
    },
    pts_category_passengers: {
        "en-GB": "Passengers",
        "en-US": "Passengers",
        "de-DE": "Passengers",
        "ja-JP": "旅客",
    },
    pts_schedule_passengers_onboarding: {
        "en-GB": "Passengers onboarding",
        "en-US": "Passengers onboarding",
        "de-DE": "Passengers onboarding",
        "ja-JP": "旅客搭乗",
    },
    pts_schedule_passengers_offboarding: {
        "en-GB": "Passengers offboarding",
        "en-US": "Passengers offboarding",
        "de-DE": "Passengers offboarding",
        "ja-JP": "旅客降機",
    },
};

const createDefaultIDConfig = () => ({
    backgroundPictureUrl: null,
    oidcData: {},
});

const isRoleBasedParam = (value) => {
    return Boolean(typeof value === "object" &&
        value &&
        "roleBasedAccess" in value &&
        value.roleBasedAccess);
};
const extractRoleBasedParam = (value, roles) => {
    if (!isRoleBasedParam(value)) {
        return value;
    }
    const { variants, fallbackValue } = value;
    if (!Array.isArray(roles) || !roles.length) {
        return fallbackValue;
    }
    for (const { roles: variantRoles, value: variantValue } of variants) {
        if (roles.some((role) => variantRoles.includes(role))) {
            return variantValue;
        }
    }
    return fallbackValue;
};

export { APP_KINDS, DEFAULT_LOCALE, DEFAULT_LOCALES, FE_TO_ML_SETUP_NAME_MAP, IMAGES_FOLDER_NAME, LOCALES, ML_CONFIG_SUBMODULE_PATH, PARAMETER_GROUPS_IDS, SAFETY_ROLE, createDashboardConfigMock, createDefaultAdminConfig, createDefaultDashboardConfig, createDefaultIDConfig, defaultAdminUITexts, defaultDashboardUITexts, defaultEventLabels, defaultOperationLabels, defaultPtsLabels, extractRoleBasedParam, getAdminConfigMock, getAirlineIconMap, getDefaultMulticonfig, getDefaultTimelineGroups, getDefaultTurnaroundParameters, isRoleBasedParam, turnaroundApiRegex };
//# sourceMappingURL=index.esm.js.map
